'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var rebass = require('rebass');
var styled = _interopDefault(require('styled-components'));
var LazyLoad = _interopDefault(require('react-lazy-load'));
var Modal = _interopDefault(require('react-modal'));
var reactSpring = require('react-spring');
var Slider = _interopDefault(require('react-slick'));
var Vimeo = _interopDefault(require('@u-wave/react-vimeo'));
var YouTube = _interopDefault(require('@u-wave/react-youtube'));
var Sticky = _interopDefault(require('react-stickynode'));
var Media = _interopDefault(require('react-media'));
var InViewMonitor = _interopDefault(require('react-inview-monitor'));
var reactParallax = require('react-parallax');
var Lightbox = _interopDefault(require('react-image-lightbox'));
var renderprops = require('react-spring/renderprops');
var reactShare = require('react-share');

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Row = function Row(props) {
  return /*#__PURE__*/React__default.createElement(rebass.Flex, _extends({
    mx: '-15px',
    flexDirection: ['column', 'row']
  }, props));
};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

var merge = function merge(a, b) {
  var result = objectAssign({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    objectAssign(result, (_assign = {}, _assign[key] = objectAssign(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue = function getValue(n, scale) {
  return get(scale, n, n);
};

var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      objectAssign(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      objectAssign(styles, style);
    } else {
      var _assign2;

      objectAssign(styles, (_assign2 = {}, _assign2[media] = objectAssign({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      objectAssign(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      objectAssign(styles, (_assign3 = {}, _assign3[media] = objectAssign({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = createStyleFunction(conf);
  });
  var parser = createParser(config);
  return parser;
};
var compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    objectAssign(config, parser.config);
  });
  var parser = createParser(config);
  return parser;
};

var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth = function getWidth(n, scale) {
  return get(scale, n, !isNumber(n) || n > 1 ? n : n * 100 + '%');
};

var config = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config);

var config$1 = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
config$1.bg = config$1.backgroundColor;
var color = system(config$1);

var defaults$1 = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var config$2 = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: defaults$1.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography = system(config$2);

var config$3 = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(config$3);

var defaults$2 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$4 = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system(config$4);

var config$5 = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  }
};
config$5.borderTopWidth = {
  property: 'borderTopWidth',
  scale: 'borderWidths'
};
config$5.borderTopColor = {
  property: 'borderTopColor',
  scale: 'colors'
};
config$5.borderTopStyle = {
  property: 'borderTopStyle',
  scale: 'borderStyles'
};
config$5.borderTopLeftRadius = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
};
config$5.borderTopRightRadius = {
  property: 'borderTopRightRadius',
  scale: 'radii'
};
config$5.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
};
config$5.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
};
config$5.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
};
config$5.borderBottomLeftRadius = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
};
config$5.borderBottomRightRadius = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
};
config$5.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
};
config$5.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
};
config$5.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
};
config$5.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
};
config$5.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
};
config$5.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
};
var border = system(config$5);

var config$6 = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config$6.bgImage = config$6.backgroundImage;
config$6.bgSize = config$6.backgroundSize;
config$6.bgPosition = config$6.backgroundPosition;
config$6.bgRepeat = config$6.backgroundRepeat;
var background = system(config$6);

var defaults$3 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$7 = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: defaults$3.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: defaults$3.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: defaults$3.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: defaults$3.space
  }
};
var position = system(config$7);

var defaults$4 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var isNumber$1 = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getMargin = function getMargin(n, scale) {
  if (!isNumber$1(n)) {
    return get(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get(scale, absolute, absolute);

  if (!isNumber$1(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$4.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: defaults$4.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: defaults$4.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: defaults$4.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: defaults$4.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: defaults$4.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: defaults$4.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: defaults$4.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
var space = compose(margin, padding);

var shadow = system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
} // based on https://github.com/developit/dlv


var get$1 = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  outlineColor: 'colors',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return get$1(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get$1(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends$1({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = get$1(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};
var css = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends$1({}, defaultTheme, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(get$1(theme, val))(theme);
        result = _extends$1({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = get$1(aliases, key, key);
      var scaleName = get$1(scales, prop);
      var scale = get$1(theme, scaleName, get$1(theme, prop, {}));
      var transform = get$1(transforms, prop, get$1);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};

var variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return css(get(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return get(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = createParser(config);
  return parser;
};
var buttonStyle = variant({
  key: 'buttons'
});
var textStyle = variant({
  key: 'textStyles',
  prop: 'textStyle'
});
var colorStyle = variant({
  key: 'colorStyles',
  prop: 'colors'
});

var textAlign = typography.textAlign;

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Column = styled(rebass.Box)(_templateObject(), textAlign);
Column.defaultProps = {
  px: '15px',
  flex: '1 1 auto'
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  max-width: ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var Container = styled(rebass.Box)(_templateObject$1(), function (props) {
  return props.maxWidth;
});
Container.defaultProps = {
  mx: 'auto',
  px: '15px',
  maxWidth: '1230px'
};

var baseTheme = {
  breakpoints: ['576px', '768px', '992px', '1200px'],
  fonts: {
    sans: "futura-pt, 'Helvetica Neue', Helvetica, Arial, sans-serif",
    serif: "'le-monde-livre-std', Georgia, 'Times New Roman', Times, serif"
  },
  fontSizes: {
    // Text sizes
    tiny: '12px',
    small: '14px',
    body: '16px',
    bodyMobile: '14px',
    bodySmall: '14px',
    bodySmallMobile: '13px',
    bodyBig: '26px',
    bodyBigMobile: '24px',
    // Heading sizes
    hero: '36px',
    heroMobile: '24px',
    headline: '36px',
    headlineMobile: '24px',
    title: '30px',
    titleMobile: '24px',
    titleSmall: '20px',
    titleSmallMobile: '18px',
    meta: '12px',
    metaMobile: '10px',
    description: '14px',
    descriptionMobile: '11px'
  },
  icons: {
    none: '',
    close: 'close',
    arrowUp: 'arrow-up',
    arrowRight: 'arrow-right',
    arrowLeft: 'arrow-left',
    arrowDown: 'arrow-down',
    facebook: 'facebook',
    instagram: 'instagram',
    plus: 'plus',
    scale: 'scale',
    play: 'video',
    rotate: 'rotate',
    menu: 'menu',
    info: 'info',
    success: 'success',
    warning: 'warning',
    error: 'error',
    zoomIn: 'zoom-in',
    zoomOut: 'zoom-out',
    camera: 'camera',
    page: 'essay',
    envelope: 'envelope'
  },
  speed: {
    "default": '0.3s',
    slow: '0.5s',
    fast: '0.1s'
  },
  colors: {
    baseGray: '#6c757d',
    baseGrayDark: '#747371',
    baseBlack: '#000000',
    baseWhite: '#FFFFFF',
    baseGrayLight: '#EAEAEA',
    transparent: 'transparent',
    statusSuccess: '#006950',
    statusError: '#AE162A',
    statusWarning: '#E8931B',
    statusInfo: '#1078BA'
  },
  fontWeight: {
    light: 100,
    normal: 400,
    medium: 500,
    bold: 600
  },
  tracking: {
    none: '0',
    negTiny: '-0.5px',
    tiny: '0.5px',
    small: '1px',
    medium: '3px',
    large: '5px'
  },
  shadows: {
    small: '0 0 4px rgba(0, 0, 0, .125)',
    large: '0 0 24px rgba(0, 0, 0, .125)'
  },
  space: [4, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96, 104, 112, 120, 128, 256]
};
var theme = {
  garden: _objectSpread2(_objectSpread2({}, baseTheme), {}, {
    colors: _objectSpread2(_objectSpread2({}, baseTheme.colors), {}, {
      bg: '#FFFFFF',
      text: '#8F8E8D',
      subTitle: '#8F8E8D',
      menu: '#828282',
      underlineHover: 'rgba(130,130,130, 0.5)',
      underline: '#8F8E8D',
      heroText: '#FFFFFF',
      hr: '#E0E0E0',
      mobileMenuBG: '#fff',
      buttonLight: '#FFFFFF',
      buttonDark: '#8F8E8D'
    })
  }),
  studio: _objectSpread2(_objectSpread2({}, baseTheme), {}, {
    colors: _objectSpread2(_objectSpread2({}, baseTheme.colors), {}, {
      bg: '#8F8E8D',
      text: '#EEEEEE',
      subTitle: '#EEEEEE',
      menu: '#FFFFFF',
      underlineHover: 'rgba(171,170,169, 0.5)',
      underline: '#EEEEEE',
      heroText: '#FFFFFF',
      hr: '#ABAAA9',
      mobileMenuBG: '#8F8E8D',
      buttonLight: '#FFFFFF',
      buttonDark: '#8F8E8D'
    })
  }),
  portfolio: _objectSpread2(_objectSpread2({}, baseTheme), {}, {
    colors: _objectSpread2(_objectSpread2({}, baseTheme.colors), {}, {
      bg: '#ffffff',
      text: '#222222',
      subTitle: 'rgba(130,130,130, 1)',
      menu: '#222222',
      buttonLight: '#222222',
      buttonDark: '#FFFFFF',
      underlineHover: 'rgba(130,130,130, 0.5)',
      underline: '#222',
      heroText: '#FFFFFF',
      hr: 'rgba(224,224,224, 0.25)',
      mobileMenuBG: '#FFFFFF'
    })
  })
};

var baseStyles = {
  display: 'inherit'
}; // Todo: Refactor: https://gitlab.com/dylanlewis/dylanlewis-mono/-/issues/2

var display = {
  size: {
    hero: {
      fontSize: ['heroMobile', 'heroMobile', 'hero']
    },
    headline: {
      fontSize: ['headlineMobile', 'headline']
    },
    title: {
      fontSize: ['titleMobile', 'title']
    },
    titleSmall: {
      fontSize: ['titleSmallMobile', 'titleSmall']
    },
    titleCard: {
      fontSize: ['titleSmallMobile', 'titleSmall'],
      fontFamily: baseTheme.fonts.sans,
      fontWeight: 300
    },
    meta: {
      fontSize: ['metaMobile', 'meta'],
      letterSpacing: '3.2px',
      textTransform: 'uppercase',
      fontFamily: baseTheme.fonts.sans
    },
    description: {
      fontSize: ['descriptionMobile', 'description'],
      textTransform: 'uppercase',
      letterSpacing: '3.2px'
    }
  }
};
var Heading = styled(rebass.Heading)(function (props) {
  return _objectSpread2(_objectSpread2({}, baseStyles), {}, {
    textTransform: props.textTransform,
    color: !props.color ? props.theme.colors.text : props.color
  });
});
var headings = {
  rebass: Heading
};

var getHeadingProps = function getHeadingProps(props) {
  var _props = props,
      _props$size = _props.size,
      size = _props$size === void 0 ? null : _props$size,
      html = _props.html;

  if (size && display.size[size]) {
    props = _objectSpread2(_objectSpread2({}, props), display.size[size]);
  }

  if (html) {
    props.dangerouslySetInnerHTML = {
      __html: html
    };
  }

  return props;
};

var Element = function Element(_ref) {
  var variant = _ref.variant,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["variant", "children"]);

  return /*#__PURE__*/React.createElement(headings[variant], getHeadingProps(props), children);
};

Element.defaultProps = {
  variant: 'rebass',
  fontSize: 'title',
  fontWeight: '300',
  fontFamily: 'serif',
  textTransform: 'none',
  lineHeight: '1.35',
  html: null
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  display: inherit;\n  color: ", ";\n  a {\n    /* text-decoration: underline; */\n    border-bottom: 1px solid;\n    border-bottom-color: ", " !important;\n    color: ", " !important;\n    &:hover {\n      text-decoration: none;\n      border-bottom-color: transparent !important;\n    }\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var display$1 = {
  size: {
    alert: {
      fontSize: ['tiny', 'tiny'],
      fontFamily: baseTheme.fonts.sans
    },
    form: {
      fontSize: ['bodyMobile', 'body'],
      fontFamily: baseTheme.fonts.sans
    },
    body: {
      fontSize: ['bodyMobile', 'body']
    },
    bodyBig: {
      fontSize: ['bodyBigMobile', 'bodyBig'],
      lineHeight: '1.34'
    },
    bodySmall: {
      fontSize: ['bodySmallMobile', 'bodySmall']
    },
    collapseBody: {
      fontSize: ['small', 'bodySmall'],
      fontFamily: baseTheme.fonts.sans,
      fontWeight: baseTheme.fontWeight.light
    },
    collapseBodyBold: {
      fontSize: ['small', 'bodySmall'],
      fontFamily: baseTheme.fonts.sans,
      fontWeight: baseTheme.fontWeight.medium
    }
  }
};
var Text = styled(rebass.Text)(_templateObject$2(), function (props) {
  return !props.color ? props.theme.colors.text : props.color;
}, function (props) {
  return !props.color ? props.theme.colors.text : props.color;
}, function (props) {
  return !props.color ? props.theme.colors.text : props.color;
});
var texts = {
  rebass: Text
};

var getTextProps = function getTextProps(props) {
  var _props = props,
      _props$size = _props.size,
      size = _props$size === void 0 ? null : _props$size,
      html = _props.html;

  if (size && display$1.size[size]) {
    props = _objectSpread2(_objectSpread2({}, props), display$1.size[size]);
  }

  if (html) {
    props.dangerouslySetInnerHTML = {
      __html: html
    };
  }

  return props;
};

var Element$1 = function Element(_ref) {
  var variant = _ref.variant,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["variant", "children"]);

  return /*#__PURE__*/React.createElement(texts[variant], getTextProps(props), children);
};

Element$1.defaultProps = {
  variant: 'rebass',
  fontSize: 'body',
  fontFamily: 'serif',
  fontWeight: '400',
  lineHeight: '1.75',
  as: 'p',
  m: '0px',
  html: null
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element$2 = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function (a) {
  return z(a) === k;
};

var isContextProvider = function (a) {
  return z(a) === h;
};

var isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function (a) {
  return z(a) === n;
};

var isFragment = function (a) {
  return z(a) === e;
};

var isLazy = function (a) {
  return z(a) === t;
};

var isMemo = function (a) {
  return z(a) === r;
};

var isPortal = function (a) {
  return z(a) === d;
};

var isProfiler = function (a) {
  return z(a) === g;
};

var isStrictMode = function (a) {
  return z(a) === f;
};

var isSuspense = function (a) {
  return z(a) === p;
};

var isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$2,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function () {
    // nor polyfill, then a plain number is used for performance.

    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }

    function typeOf(object) {
      if (typeof object === 'object' && object !== null) {
        var $$typeof = object.$$typeof;

        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;

            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;

              default:
                var $$typeofType = type && type.$$typeof;

                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;

                  default:
                    return $$typeof;
                }

            }

          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }

      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode


    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }

    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }

    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }

    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }

    function isElement(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }

    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }

    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }

    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }

    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }

    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }

    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }

    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }

    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }

    exports.AsyncMode = AsyncMode;
    exports.ConcurrentMode = ConcurrentMode;
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
    exports.isValidElementType = isValidElementType;
    exports.typeOf = typeOf;
  })();
}
});
var reactIs_development_1 = reactIs_development.AsyncMode;
var reactIs_development_2 = reactIs_development.ConcurrentMode;
var reactIs_development_3 = reactIs_development.ContextConsumer;
var reactIs_development_4 = reactIs_development.ContextProvider;
var reactIs_development_5 = reactIs_development.Element;
var reactIs_development_6 = reactIs_development.ForwardRef;
var reactIs_development_7 = reactIs_development.Fragment;
var reactIs_development_8 = reactIs_development.Lazy;
var reactIs_development_9 = reactIs_development.Memo;
var reactIs_development_10 = reactIs_development.Portal;
var reactIs_development_11 = reactIs_development.Profiler;
var reactIs_development_12 = reactIs_development.StrictMode;
var reactIs_development_13 = reactIs_development.Suspense;
var reactIs_development_14 = reactIs_development.isAsyncMode;
var reactIs_development_15 = reactIs_development.isConcurrentMode;
var reactIs_development_16 = reactIs_development.isContextConsumer;
var reactIs_development_17 = reactIs_development.isContextProvider;
var reactIs_development_18 = reactIs_development.isElement;
var reactIs_development_19 = reactIs_development.isForwardRef;
var reactIs_development_20 = reactIs_development.isFragment;
var reactIs_development_21 = reactIs_development.isLazy;
var reactIs_development_22 = reactIs_development.isMemo;
var reactIs_development_23 = reactIs_development.isPortal;
var reactIs_development_24 = reactIs_development.isProfiler;
var reactIs_development_25 = reactIs_development.isStrictMode;
var reactIs_development_26 = reactIs_development.isSuspense;
var reactIs_development_27 = reactIs_development.isValidElementType;
var reactIs_development_28 = reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function () {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1 = function () {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod


  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var colorName = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};

var isArrayish = function isArrayish(obj) {
  if (!obj || typeof obj === 'string') {
    return false;
  }

  return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
};

var simpleSwizzle = createCommonjsModule(function (module) {



var concat = Array.prototype.concat;
var slice = Array.prototype.slice;

var swizzle = module.exports = function swizzle(args) {
  var results = [];

  for (var i = 0, len = args.length; i < len; i++) {
    var arg = args[i];

    if (isArrayish(arg)) {
      // http://jsperf.com/javascript-array-concat-vs-push/98
      results = concat.call(results, slice.call(arg));
    } else {
      results.push(arg);
    }
  }

  return results;
};

swizzle.wrap = function (fn) {
  return function () {
    return fn(swizzle(arguments));
  };
};
});

var colorString = createCommonjsModule(function (module) {
/* MIT license */




var reverseNames = {}; // create a list of reverse color names

for (var name in colorName) {
  if (colorName.hasOwnProperty(name)) {
    reverseNames[colorName[name]] = name;
  }
}

var cs = module.exports = {
  to: {},
  get: {}
};

cs.get = function (string) {
  var prefix = string.substring(0, 3).toLowerCase();
  var val;
  var model;

  switch (prefix) {
    case 'hsl':
      val = cs.get.hsl(string);
      model = 'hsl';
      break;

    case 'hwb':
      val = cs.get.hwb(string);
      model = 'hwb';
      break;

    default:
      val = cs.get.rgb(string);
      model = 'rgb';
      break;
  }

  if (!val) {
    return null;
  }

  return {
    model: model,
    value: val
  };
};

cs.get.rgb = function (string) {
  if (!string) {
    return null;
  }

  var abbr = /^#([a-f0-9]{3,4})$/i;
  var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
  var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
  var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
  var keyword = /(\D+)/;
  var rgb = [0, 0, 0, 1];
  var match;
  var i;
  var hexAlpha;

  if (match = string.match(hex)) {
    hexAlpha = match[2];
    match = match[1];

    for (i = 0; i < 3; i++) {
      // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
      var i2 = i * 2;
      rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
    }

    if (hexAlpha) {
      rgb[3] = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
    }
  } else if (match = string.match(abbr)) {
    match = match[1];
    hexAlpha = match[3];

    for (i = 0; i < 3; i++) {
      rgb[i] = parseInt(match[i] + match[i], 16);
    }

    if (hexAlpha) {
      rgb[3] = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
    }
  } else if (match = string.match(rgba)) {
    for (i = 0; i < 3; i++) {
      rgb[i] = parseInt(match[i + 1], 0);
    }

    if (match[4]) {
      rgb[3] = parseFloat(match[4]);
    }
  } else if (match = string.match(per)) {
    for (i = 0; i < 3; i++) {
      rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
    }

    if (match[4]) {
      rgb[3] = parseFloat(match[4]);
    }
  } else if (match = string.match(keyword)) {
    if (match[1] === 'transparent') {
      return [0, 0, 0, 0];
    }

    rgb = colorName[match[1]];

    if (!rgb) {
      return null;
    }

    rgb[3] = 1;
    return rgb;
  } else {
    return null;
  }

  for (i = 0; i < 3; i++) {
    rgb[i] = clamp(rgb[i], 0, 255);
  }

  rgb[3] = clamp(rgb[3], 0, 1);
  return rgb;
};

cs.get.hsl = function (string) {
  if (!string) {
    return null;
  }

  var hsl = /^hsla?\(\s*([+-]?(?:\d*\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
  var match = string.match(hsl);

  if (match) {
    var alpha = parseFloat(match[4]);
    var h = (parseFloat(match[1]) + 360) % 360;
    var s = clamp(parseFloat(match[2]), 0, 100);
    var l = clamp(parseFloat(match[3]), 0, 100);
    var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, s, l, a];
  }

  return null;
};

cs.get.hwb = function (string) {
  if (!string) {
    return null;
  }

  var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
  var match = string.match(hwb);

  if (match) {
    var alpha = parseFloat(match[4]);
    var h = (parseFloat(match[1]) % 360 + 360) % 360;
    var w = clamp(parseFloat(match[2]), 0, 100);
    var b = clamp(parseFloat(match[3]), 0, 100);
    var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
    return [h, w, b, a];
  }

  return null;
};

cs.to.hex = function () {
  var rgba = simpleSwizzle(arguments);
  return '#' + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : '');
};

cs.to.rgb = function () {
  var rgba = simpleSwizzle(arguments);
  return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};

cs.to.rgb.percent = function () {
  var rgba = simpleSwizzle(arguments);
  var r = Math.round(rgba[0] / 255 * 100);
  var g = Math.round(rgba[1] / 255 * 100);
  var b = Math.round(rgba[2] / 255 * 100);
  return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};

cs.to.hsl = function () {
  var hsla = simpleSwizzle(arguments);
  return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
}; // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)


cs.to.hwb = function () {
  var hwba = simpleSwizzle(arguments);
  var a = '';

  if (hwba.length >= 4 && hwba[3] !== 1) {
    a = ', ' + hwba[3];
  }

  return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};

cs.to.keyword = function (rgb) {
  return reverseNames[rgb.slice(0, 3)];
}; // helpers


function clamp(num, min, max) {
  return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return str.length < 2 ? '0' + str : str;
}
});
var colorString_1 = colorString.to;
var colorString_2 = colorString.get;

var colorName$1 = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};

var conversions = createCommonjsModule(function (module) {
/* MIT license */
 // NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)


var reverseKeywords = {};

for (var key in colorName$1) {
  if (colorName$1.hasOwnProperty(key)) {
    reverseKeywords[colorName$1[key]] = key;
  }
}

var convert = module.exports = {
  rgb: {
    channels: 3,
    labels: 'rgb'
  },
  hsl: {
    channels: 3,
    labels: 'hsl'
  },
  hsv: {
    channels: 3,
    labels: 'hsv'
  },
  hwb: {
    channels: 3,
    labels: 'hwb'
  },
  cmyk: {
    channels: 4,
    labels: 'cmyk'
  },
  xyz: {
    channels: 3,
    labels: 'xyz'
  },
  lab: {
    channels: 3,
    labels: 'lab'
  },
  lch: {
    channels: 3,
    labels: 'lch'
  },
  hex: {
    channels: 1,
    labels: ['hex']
  },
  keyword: {
    channels: 1,
    labels: ['keyword']
  },
  ansi16: {
    channels: 1,
    labels: ['ansi16']
  },
  ansi256: {
    channels: 1,
    labels: ['ansi256']
  },
  hcg: {
    channels: 3,
    labels: ['h', 'c', 'g']
  },
  apple: {
    channels: 3,
    labels: ['r16', 'g16', 'b16']
  },
  gray: {
    channels: 1,
    labels: ['gray']
  }
}; // hide .channels and .labels properties

for (var model in convert) {
  if (convert.hasOwnProperty(model)) {
    if (!('channels' in convert[model])) {
      throw new Error('missing channels property: ' + model);
    }

    if (!('labels' in convert[model])) {
      throw new Error('missing channel labels property: ' + model);
    }

    if (convert[model].labels.length !== convert[model].channels) {
      throw new Error('channel and label counts mismatch: ' + model);
    }

    var channels = convert[model].channels;
    var labels = convert[model].labels;
    delete convert[model].channels;
    delete convert[model].labels;
    Object.defineProperty(convert[model], 'channels', {
      value: channels
    });
    Object.defineProperty(convert[model], 'labels', {
      value: labels
    });
  }
}

convert.rgb.hsl = function (rgb) {
  var r = rgb[0] / 255;
  var g = rgb[1] / 255;
  var b = rgb[2] / 255;
  var min = Math.min(r, g, b);
  var max = Math.max(r, g, b);
  var delta = max - min;
  var h;
  var s;
  var l;

  if (max === min) {
    h = 0;
  } else if (r === max) {
    h = (g - b) / delta;
  } else if (g === max) {
    h = 2 + (b - r) / delta;
  } else if (b === max) {
    h = 4 + (r - g) / delta;
  }

  h = Math.min(h * 60, 360);

  if (h < 0) {
    h += 360;
  }

  l = (min + max) / 2;

  if (max === min) {
    s = 0;
  } else if (l <= 0.5) {
    s = delta / (max + min);
  } else {
    s = delta / (2 - max - min);
  }

  return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
  var rdif;
  var gdif;
  var bdif;
  var h;
  var s;
  var r = rgb[0] / 255;
  var g = rgb[1] / 255;
  var b = rgb[2] / 255;
  var v = Math.max(r, g, b);
  var diff = v - Math.min(r, g, b);

  var diffc = function (c) {
    return (v - c) / 6 / diff + 1 / 2;
  };

  if (diff === 0) {
    h = s = 0;
  } else {
    s = diff / v;
    rdif = diffc(r);
    gdif = diffc(g);
    bdif = diffc(b);

    if (r === v) {
      h = bdif - gdif;
    } else if (g === v) {
      h = 1 / 3 + rdif - bdif;
    } else if (b === v) {
      h = 2 / 3 + gdif - rdif;
    }

    if (h < 0) {
      h += 1;
    } else if (h > 1) {
      h -= 1;
    }
  }

  return [h * 360, s * 100, v * 100];
};

convert.rgb.hwb = function (rgb) {
  var r = rgb[0];
  var g = rgb[1];
  var b = rgb[2];
  var h = convert.rgb.hsl(rgb)[0];
  var w = 1 / 255 * Math.min(r, Math.min(g, b));
  b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
  return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
  var r = rgb[0] / 255;
  var g = rgb[1] / 255;
  var b = rgb[2] / 255;
  var c;
  var m;
  var y;
  var k;
  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k) || 0;
  m = (1 - g - k) / (1 - k) || 0;
  y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
};
/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */


function comparativeDistance(x, y) {
  return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}

convert.rgb.keyword = function (rgb) {
  var reversed = reverseKeywords[rgb];

  if (reversed) {
    return reversed;
  }

  var currentClosestDistance = Infinity;
  var currentClosestKeyword;

  for (var keyword in colorName$1) {
    if (colorName$1.hasOwnProperty(keyword)) {
      var value = colorName$1[keyword]; // Compute comparative distance

      var distance = comparativeDistance(rgb, value); // Check if its less, if so set as closest

      if (distance < currentClosestDistance) {
        currentClosestDistance = distance;
        currentClosestKeyword = keyword;
      }
    }
  }

  return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
  return colorName$1[keyword];
};

convert.rgb.xyz = function (rgb) {
  var r = rgb[0] / 255;
  var g = rgb[1] / 255;
  var b = rgb[2] / 255; // assume sRGB

  r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
  g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
  b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
  var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
  var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
  var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
  return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
  var xyz = convert.rgb.xyz(rgb);
  var x = xyz[0];
  var y = xyz[1];
  var z = xyz[2];
  var l;
  var a;
  var b;
  x /= 95.047;
  y /= 100;
  z /= 108.883;
  x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
  y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
  z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
  l = 116 * y - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);
  return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
  var h = hsl[0] / 360;
  var s = hsl[1] / 100;
  var l = hsl[2] / 100;
  var t1;
  var t2;
  var t3;
  var rgb;
  var val;

  if (s === 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5) {
    t2 = l * (1 + s);
  } else {
    t2 = l + s - l * s;
  }

  t1 = 2 * l - t2;
  rgb = [0, 0, 0];

  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * -(i - 1);

    if (t3 < 0) {
      t3++;
    }

    if (t3 > 1) {
      t3--;
    }

    if (6 * t3 < 1) {
      val = t1 + (t2 - t1) * 6 * t3;
    } else if (2 * t3 < 1) {
      val = t2;
    } else if (3 * t3 < 2) {
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    } else {
      val = t1;
    }

    rgb[i] = val * 255;
  }

  return rgb;
};

convert.hsl.hsv = function (hsl) {
  var h = hsl[0];
  var s = hsl[1] / 100;
  var l = hsl[2] / 100;
  var smin = s;
  var lmin = Math.max(l, 0.01);
  var sv;
  var v;
  l *= 2;
  s *= l <= 1 ? l : 2 - l;
  smin *= lmin <= 1 ? lmin : 2 - lmin;
  v = (l + s) / 2;
  sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
  return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
  var h = hsv[0] / 60;
  var s = hsv[1] / 100;
  var v = hsv[2] / 100;
  var hi = Math.floor(h) % 6;
  var f = h - Math.floor(h);
  var p = 255 * v * (1 - s);
  var q = 255 * v * (1 - s * f);
  var t = 255 * v * (1 - s * (1 - f));
  v *= 255;

  switch (hi) {
    case 0:
      return [v, t, p];

    case 1:
      return [q, v, p];

    case 2:
      return [p, v, t];

    case 3:
      return [p, q, v];

    case 4:
      return [t, p, v];

    case 5:
      return [v, p, q];
  }
};

convert.hsv.hsl = function (hsv) {
  var h = hsv[0];
  var s = hsv[1] / 100;
  var v = hsv[2] / 100;
  var vmin = Math.max(v, 0.01);
  var lmin;
  var sl;
  var l;
  l = (2 - s) * v;
  lmin = (2 - s) * vmin;
  sl = s * vmin;
  sl /= lmin <= 1 ? lmin : 2 - lmin;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
}; // http://dev.w3.org/csswg/css-color/#hwb-to-rgb


convert.hwb.rgb = function (hwb) {
  var h = hwb[0] / 360;
  var wh = hwb[1] / 100;
  var bl = hwb[2] / 100;
  var ratio = wh + bl;
  var i;
  var v;
  var f;
  var n; // wh + bl cant be > 1

  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }

  i = Math.floor(6 * h);
  v = 1 - bl;
  f = 6 * h - i;

  if ((i & 0x01) !== 0) {
    f = 1 - f;
  }

  n = wh + f * (v - wh); // linear interpolation

  var r;
  var g;
  var b;

  switch (i) {
    default:
    case 6:
    case 0:
      r = v;
      g = n;
      b = wh;
      break;

    case 1:
      r = n;
      g = v;
      b = wh;
      break;

    case 2:
      r = wh;
      g = v;
      b = n;
      break;

    case 3:
      r = wh;
      g = n;
      b = v;
      break;

    case 4:
      r = n;
      g = wh;
      b = v;
      break;

    case 5:
      r = v;
      g = wh;
      b = n;
      break;
  }

  return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
  var c = cmyk[0] / 100;
  var m = cmyk[1] / 100;
  var y = cmyk[2] / 100;
  var k = cmyk[3] / 100;
  var r;
  var g;
  var b;
  r = 1 - Math.min(1, c * (1 - k) + k);
  g = 1 - Math.min(1, m * (1 - k) + k);
  b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
  var x = xyz[0] / 100;
  var y = xyz[1] / 100;
  var z = xyz[2] / 100;
  var r;
  var g;
  var b;
  r = x * 3.2406 + y * -1.5372 + z * -0.4986;
  g = x * -0.9689 + y * 1.8758 + z * 0.0415;
  b = x * 0.0557 + y * -0.2040 + z * 1.0570; // assume sRGB

  r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
  g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
  b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);
  return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
  var x = xyz[0];
  var y = xyz[1];
  var z = xyz[2];
  var l;
  var a;
  var b;
  x /= 95.047;
  y /= 100;
  z /= 108.883;
  x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
  y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
  z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
  l = 116 * y - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);
  return [l, a, b];
};

convert.lab.xyz = function (lab) {
  var l = lab[0];
  var a = lab[1];
  var b = lab[2];
  var x;
  var y;
  var z;
  y = (l + 16) / 116;
  x = a / 500 + y;
  z = y - b / 200;
  var y2 = Math.pow(y, 3);
  var x2 = Math.pow(x, 3);
  var z2 = Math.pow(z, 3);
  y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
  x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
  z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
  x *= 95.047;
  y *= 100;
  z *= 108.883;
  return [x, y, z];
};

convert.lab.lch = function (lab) {
  var l = lab[0];
  var a = lab[1];
  var b = lab[2];
  var hr;
  var h;
  var c;
  hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;

  if (h < 0) {
    h += 360;
  }

  c = Math.sqrt(a * a + b * b);
  return [l, c, h];
};

convert.lch.lab = function (lch) {
  var l = lch[0];
  var c = lch[1];
  var h = lch[2];
  var a;
  var b;
  var hr;
  hr = h / 360 * 2 * Math.PI;
  a = c * Math.cos(hr);
  b = c * Math.sin(hr);
  return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
  var r = args[0];
  var g = args[1];
  var b = args[2];
  var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

  value = Math.round(value / 50);

  if (value === 0) {
    return 30;
  }

  var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));

  if (value === 2) {
    ansi += 60;
  }

  return ansi;
};

convert.hsv.ansi16 = function (args) {
  // optimization here; we already know the value and don't need to get
  // it converted for us.
  return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
  var r = args[0];
  var g = args[1];
  var b = args[2]; // we use the extended greyscale palette here, with the exception of
  // black and white. normal palette only has 4 greyscale shades.

  if (r === g && g === b) {
    if (r < 8) {
      return 16;
    }

    if (r > 248) {
      return 231;
    }

    return Math.round((r - 8) / 247 * 24) + 232;
  }

  var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
  return ansi;
};

convert.ansi16.rgb = function (args) {
  var color = args % 10; // handle greyscale

  if (color === 0 || color === 7) {
    if (args > 50) {
      color += 3.5;
    }

    color = color / 10.5 * 255;
    return [color, color, color];
  }

  var mult = (~~(args > 50) + 1) * 0.5;
  var r = (color & 1) * mult * 255;
  var g = (color >> 1 & 1) * mult * 255;
  var b = (color >> 2 & 1) * mult * 255;
  return [r, g, b];
};

convert.ansi256.rgb = function (args) {
  // handle greyscale
  if (args >= 232) {
    var c = (args - 232) * 10 + 8;
    return [c, c, c];
  }

  args -= 16;
  var rem;
  var r = Math.floor(args / 36) / 5 * 255;
  var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
  var b = rem % 6 / 5 * 255;
  return [r, g, b];
};

convert.rgb.hex = function (args) {
  var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
  var string = integer.toString(16).toUpperCase();
  return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
  var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);

  if (!match) {
    return [0, 0, 0];
  }

  var colorString = match[0];

  if (match[0].length === 3) {
    colorString = colorString.split('').map(function (char) {
      return char + char;
    }).join('');
  }

  var integer = parseInt(colorString, 16);
  var r = integer >> 16 & 0xFF;
  var g = integer >> 8 & 0xFF;
  var b = integer & 0xFF;
  return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
  var r = rgb[0] / 255;
  var g = rgb[1] / 255;
  var b = rgb[2] / 255;
  var max = Math.max(Math.max(r, g), b);
  var min = Math.min(Math.min(r, g), b);
  var chroma = max - min;
  var grayscale;
  var hue;

  if (chroma < 1) {
    grayscale = min / (1 - chroma);
  } else {
    grayscale = 0;
  }

  if (chroma <= 0) {
    hue = 0;
  } else if (max === r) {
    hue = (g - b) / chroma % 6;
  } else if (max === g) {
    hue = 2 + (b - r) / chroma;
  } else {
    hue = 4 + (r - g) / chroma + 4;
  }

  hue /= 6;
  hue %= 1;
  return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
  var s = hsl[1] / 100;
  var l = hsl[2] / 100;
  var c = 1;
  var f = 0;

  if (l < 0.5) {
    c = 2.0 * s * l;
  } else {
    c = 2.0 * s * (1.0 - l);
  }

  if (c < 1.0) {
    f = (l - 0.5 * c) / (1.0 - c);
  }

  return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
  var s = hsv[1] / 100;
  var v = hsv[2] / 100;
  var c = s * v;
  var f = 0;

  if (c < 1.0) {
    f = (v - c) / (1 - c);
  }

  return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
  var h = hcg[0] / 360;
  var c = hcg[1] / 100;
  var g = hcg[2] / 100;

  if (c === 0.0) {
    return [g * 255, g * 255, g * 255];
  }

  var pure = [0, 0, 0];
  var hi = h % 1 * 6;
  var v = hi % 1;
  var w = 1 - v;
  var mg = 0;

  switch (Math.floor(hi)) {
    case 0:
      pure[0] = 1;
      pure[1] = v;
      pure[2] = 0;
      break;

    case 1:
      pure[0] = w;
      pure[1] = 1;
      pure[2] = 0;
      break;

    case 2:
      pure[0] = 0;
      pure[1] = 1;
      pure[2] = v;
      break;

    case 3:
      pure[0] = 0;
      pure[1] = w;
      pure[2] = 1;
      break;

    case 4:
      pure[0] = v;
      pure[1] = 0;
      pure[2] = 1;
      break;

    default:
      pure[0] = 1;
      pure[1] = 0;
      pure[2] = w;
  }

  mg = (1.0 - c) * g;
  return [(c * pure[0] + mg) * 255, (c * pure[1] + mg) * 255, (c * pure[2] + mg) * 255];
};

convert.hcg.hsv = function (hcg) {
  var c = hcg[1] / 100;
  var g = hcg[2] / 100;
  var v = c + g * (1.0 - c);
  var f = 0;

  if (v > 0.0) {
    f = c / v;
  }

  return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
  var c = hcg[1] / 100;
  var g = hcg[2] / 100;
  var l = g * (1.0 - c) + 0.5 * c;
  var s = 0;

  if (l > 0.0 && l < 0.5) {
    s = c / (2 * l);
  } else if (l >= 0.5 && l < 1.0) {
    s = c / (2 * (1 - l));
  }

  return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
  var c = hcg[1] / 100;
  var g = hcg[2] / 100;
  var v = c + g * (1.0 - c);
  return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
  var w = hwb[1] / 100;
  var b = hwb[2] / 100;
  var v = 1 - b;
  var c = v - w;
  var g = 0;

  if (c < 1) {
    g = (v - c) / (1 - c);
  }

  return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
  return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
};

convert.rgb.apple = function (rgb) {
  return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
};

convert.gray.rgb = function (args) {
  return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
  return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
  return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
  return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
  return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
  var val = Math.round(gray[0] / 100 * 255) & 0xFF;
  var integer = (val << 16) + (val << 8) + val;
  var string = integer.toString(16).toUpperCase();
  return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
  var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
  return [val / 255 * 100];
};
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/


function buildGraph() {
  var graph = {}; // https://jsperf.com/object-keys-vs-for-in-with-closure/3

  var models = Object.keys(conversions);

  for (var len = models.length, i = 0; i < len; i++) {
    graph[models[i]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  }

  return graph;
} // https://en.wikipedia.org/wiki/Breadth-first_search


function deriveBFS(fromModel) {
  var graph = buildGraph();
  var queue = [fromModel]; // unshift -> queue -> pop

  graph[fromModel].distance = 0;

  while (queue.length) {
    var current = queue.pop();
    var adjacents = Object.keys(conversions[current]);

    for (var len = adjacents.length, i = 0; i < len; i++) {
      var adjacent = adjacents[i];
      var node = graph[adjacent];

      if (node.distance === -1) {
        node.distance = graph[current].distance + 1;
        node.parent = current;
        queue.unshift(adjacent);
      }
    }
  }

  return graph;
}

function link(from, to) {
  return function (args) {
    return to(from(args));
  };
}

function wrapConversion(toModel, graph) {
  var path = [graph[toModel].parent, toModel];
  var fn = conversions[graph[toModel].parent][toModel];
  var cur = graph[toModel].parent;

  while (graph[cur].parent) {
    path.unshift(graph[cur].parent);
    fn = link(conversions[graph[cur].parent][cur], fn);
    cur = graph[cur].parent;
  }

  fn.conversion = path;
  return fn;
}

var route = function (fromModel) {
  var graph = deriveBFS(fromModel);
  var conversion = {};
  var models = Object.keys(graph);

  for (var len = models.length, i = 0; i < len; i++) {
    var toModel = models[i];
    var node = graph[toModel];

    if (node.parent === null) {
      // no possible conversion, or this node is the source model.
      continue;
    }

    conversion[toModel] = wrapConversion(toModel, graph);
  }

  return conversion;
};

var convert = {};
var models = Object.keys(conversions);

function wrapRaw(fn) {
  var wrappedFn = function (args) {
    if (args === undefined || args === null) {
      return args;
    }

    if (arguments.length > 1) {
      args = Array.prototype.slice.call(arguments);
    }

    return fn(args);
  }; // preserve .conversion property if there is one


  if ('conversion' in fn) {
    wrappedFn.conversion = fn.conversion;
  }

  return wrappedFn;
}

function wrapRounded(fn) {
  var wrappedFn = function (args) {
    if (args === undefined || args === null) {
      return args;
    }

    if (arguments.length > 1) {
      args = Array.prototype.slice.call(arguments);
    }

    var result = fn(args); // we're assuming the result is an array here.
    // see notice in conversions.js; don't use box types
    // in conversion functions.

    if (typeof result === 'object') {
      for (var len = result.length, i = 0; i < len; i++) {
        result[i] = Math.round(result[i]);
      }
    }

    return result;
  }; // preserve .conversion property if there is one


  if ('conversion' in fn) {
    wrappedFn.conversion = fn.conversion;
  }

  return wrappedFn;
}

models.forEach(function (fromModel) {
  convert[fromModel] = {};
  Object.defineProperty(convert[fromModel], 'channels', {
    value: conversions[fromModel].channels
  });
  Object.defineProperty(convert[fromModel], 'labels', {
    value: conversions[fromModel].labels
  });
  var routes = route(fromModel);
  var routeModels = Object.keys(routes);
  routeModels.forEach(function (toModel) {
    var fn = routes[toModel];
    convert[fromModel][toModel] = wrapRounded(fn);
    convert[fromModel][toModel].raw = wrapRaw(fn);
  });
});
var colorConvert = convert;

var _slice = [].slice;
var skippedModels = [// to be honest, I don't really feel like keyword belongs in color convert, but eh.
'keyword', // gray conflicts with some method names, and has its own method defined.
'gray', // shouldn't really be in color-convert either...
'hex'];
var hashedModelKeys = {};
Object.keys(colorConvert).forEach(function (model) {
  hashedModelKeys[_slice.call(colorConvert[model].labels).sort().join('')] = model;
});
var limiters = {};

function Color(obj, model) {
  if (!(this instanceof Color)) {
    return new Color(obj, model);
  }

  if (model && model in skippedModels) {
    model = null;
  }

  if (model && !(model in colorConvert)) {
    throw new Error('Unknown model: ' + model);
  }

  var i;
  var channels;

  if (obj == null) {
    // eslint-disable-line no-eq-null,eqeqeq
    this.model = 'rgb';
    this.color = [0, 0, 0];
    this.valpha = 1;
  } else if (obj instanceof Color) {
    this.model = obj.model;
    this.color = obj.color.slice();
    this.valpha = obj.valpha;
  } else if (typeof obj === 'string') {
    var result = colorString.get(obj);

    if (result === null) {
      throw new Error('Unable to parse color from string: ' + obj);
    }

    this.model = result.model;
    channels = colorConvert[this.model].channels;
    this.color = result.value.slice(0, channels);
    this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
  } else if (obj.length) {
    this.model = model || 'rgb';
    channels = colorConvert[this.model].channels;

    var newArr = _slice.call(obj, 0, channels);

    this.color = zeroArray(newArr, channels);
    this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
  } else if (typeof obj === 'number') {
    // this is always RGB - can be converted later on.
    obj &= 0xFFFFFF;
    this.model = 'rgb';
    this.color = [obj >> 16 & 0xFF, obj >> 8 & 0xFF, obj & 0xFF];
    this.valpha = 1;
  } else {
    this.valpha = 1;
    var keys = Object.keys(obj);

    if ('alpha' in obj) {
      keys.splice(keys.indexOf('alpha'), 1);
      this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
    }

    var hashedKeys = keys.sort().join('');

    if (!(hashedKeys in hashedModelKeys)) {
      throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
    }

    this.model = hashedModelKeys[hashedKeys];
    var labels = colorConvert[this.model].labels;
    var color = [];

    for (i = 0; i < labels.length; i++) {
      color.push(obj[labels[i]]);
    }

    this.color = zeroArray(color);
  } // perform limitations (clamping, etc.)


  if (limiters[this.model]) {
    channels = colorConvert[this.model].channels;

    for (i = 0; i < channels; i++) {
      var limit = limiters[this.model][i];

      if (limit) {
        this.color[i] = limit(this.color[i]);
      }
    }
  }

  this.valpha = Math.max(0, Math.min(1, this.valpha));

  if (Object.freeze) {
    Object.freeze(this);
  }
}

Color.prototype = {
  toString: function () {
    return this.string();
  },
  toJSON: function () {
    return this[this.model]();
  },
  string: function (places) {
    var self = this.model in colorString.to ? this : this.rgb();
    self = self.round(typeof places === 'number' ? places : 1);
    var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
    return colorString.to[self.model](args);
  },
  percentString: function (places) {
    var self = this.rgb().round(typeof places === 'number' ? places : 1);
    var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
    return colorString.to.rgb.percent(args);
  },
  array: function () {
    return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
  },
  object: function () {
    var result = {};
    var channels = colorConvert[this.model].channels;
    var labels = colorConvert[this.model].labels;

    for (var i = 0; i < channels; i++) {
      result[labels[i]] = this.color[i];
    }

    if (this.valpha !== 1) {
      result.alpha = this.valpha;
    }

    return result;
  },
  unitArray: function () {
    var rgb = this.rgb().color;
    rgb[0] /= 255;
    rgb[1] /= 255;
    rgb[2] /= 255;

    if (this.valpha !== 1) {
      rgb.push(this.valpha);
    }

    return rgb;
  },
  unitObject: function () {
    var rgb = this.rgb().object();
    rgb.r /= 255;
    rgb.g /= 255;
    rgb.b /= 255;

    if (this.valpha !== 1) {
      rgb.alpha = this.valpha;
    }

    return rgb;
  },
  round: function (places) {
    places = Math.max(places || 0, 0);
    return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
  },
  alpha: function (val) {
    if (arguments.length) {
      return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
    }

    return this.valpha;
  },
  // rgb
  red: getset('rgb', 0, maxfn(255)),
  green: getset('rgb', 1, maxfn(255)),
  blue: getset('rgb', 2, maxfn(255)),
  hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) {
    return (val % 360 + 360) % 360;
  }),
  // eslint-disable-line brace-style
  saturationl: getset('hsl', 1, maxfn(100)),
  lightness: getset('hsl', 2, maxfn(100)),
  saturationv: getset('hsv', 1, maxfn(100)),
  value: getset('hsv', 2, maxfn(100)),
  chroma: getset('hcg', 1, maxfn(100)),
  gray: getset('hcg', 2, maxfn(100)),
  white: getset('hwb', 1, maxfn(100)),
  wblack: getset('hwb', 2, maxfn(100)),
  cyan: getset('cmyk', 0, maxfn(100)),
  magenta: getset('cmyk', 1, maxfn(100)),
  yellow: getset('cmyk', 2, maxfn(100)),
  black: getset('cmyk', 3, maxfn(100)),
  x: getset('xyz', 0, maxfn(100)),
  y: getset('xyz', 1, maxfn(100)),
  z: getset('xyz', 2, maxfn(100)),
  l: getset('lab', 0, maxfn(100)),
  a: getset('lab', 1),
  b: getset('lab', 2),
  keyword: function (val) {
    if (arguments.length) {
      return new Color(val);
    }

    return colorConvert[this.model].keyword(this.color);
  },
  hex: function (val) {
    if (arguments.length) {
      return new Color(val);
    }

    return colorString.to.hex(this.rgb().round().color);
  },
  rgbNumber: function () {
    var rgb = this.rgb().color;
    return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
  },
  luminosity: function () {
    // http://www.w3.org/TR/WCAG20/#relativeluminancedef
    var rgb = this.rgb().color;
    var lum = [];

    for (var i = 0; i < rgb.length; i++) {
      var chan = rgb[i] / 255;
      lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
    }

    return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
  },
  contrast: function (color2) {
    // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
    var lum1 = this.luminosity();
    var lum2 = color2.luminosity();

    if (lum1 > lum2) {
      return (lum1 + 0.05) / (lum2 + 0.05);
    }

    return (lum2 + 0.05) / (lum1 + 0.05);
  },
  level: function (color2) {
    var contrastRatio = this.contrast(color2);

    if (contrastRatio >= 7.1) {
      return 'AAA';
    }

    return contrastRatio >= 4.5 ? 'AA' : '';
  },
  isDark: function () {
    // YIQ equation from http://24ways.org/2010/calculating-color-contrast
    var rgb = this.rgb().color;
    var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
    return yiq < 128;
  },
  isLight: function () {
    return !this.isDark();
  },
  negate: function () {
    var rgb = this.rgb();

    for (var i = 0; i < 3; i++) {
      rgb.color[i] = 255 - rgb.color[i];
    }

    return rgb;
  },
  lighten: function (ratio) {
    var hsl = this.hsl();
    hsl.color[2] += hsl.color[2] * ratio;
    return hsl;
  },
  darken: function (ratio) {
    var hsl = this.hsl();
    hsl.color[2] -= hsl.color[2] * ratio;
    return hsl;
  },
  saturate: function (ratio) {
    var hsl = this.hsl();
    hsl.color[1] += hsl.color[1] * ratio;
    return hsl;
  },
  desaturate: function (ratio) {
    var hsl = this.hsl();
    hsl.color[1] -= hsl.color[1] * ratio;
    return hsl;
  },
  whiten: function (ratio) {
    var hwb = this.hwb();
    hwb.color[1] += hwb.color[1] * ratio;
    return hwb;
  },
  blacken: function (ratio) {
    var hwb = this.hwb();
    hwb.color[2] += hwb.color[2] * ratio;
    return hwb;
  },
  grayscale: function () {
    // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
    var rgb = this.rgb().color;
    var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
    return Color.rgb(val, val, val);
  },
  fade: function (ratio) {
    return this.alpha(this.valpha - this.valpha * ratio);
  },
  opaquer: function (ratio) {
    return this.alpha(this.valpha + this.valpha * ratio);
  },
  rotate: function (degrees) {
    var hsl = this.hsl();
    var hue = hsl.color[0];
    hue = (hue + degrees) % 360;
    hue = hue < 0 ? 360 + hue : hue;
    hsl.color[0] = hue;
    return hsl;
  },
  mix: function (mixinColor, weight) {
    // ported from sass implementation in C
    // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
    if (!mixinColor || !mixinColor.rgb) {
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
    }

    var color1 = mixinColor.rgb();
    var color2 = this.rgb();
    var p = weight === undefined ? 0.5 : weight;
    var w = 2 * p - 1;
    var a = color1.alpha() - color2.alpha();
    var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
    var w2 = 1 - w1;
    return Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
  }
}; // model conversion methods and static constructors

Object.keys(colorConvert).forEach(function (model) {
  if (skippedModels.indexOf(model) !== -1) {
    return;
  }

  var channels = colorConvert[model].channels; // conversion methods

  Color.prototype[model] = function () {
    if (this.model === model) {
      return new Color(this);
    }

    if (arguments.length) {
      return new Color(arguments, model);
    }

    var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
    return new Color(assertArray(colorConvert[this.model][model].raw(this.color)).concat(newAlpha), model);
  }; // 'static' construction methods


  Color[model] = function (color) {
    if (typeof color === 'number') {
      color = zeroArray(_slice.call(arguments), channels);
    }

    return new Color(color, model);
  };
});

function roundTo(num, places) {
  return Number(num.toFixed(places));
}

function roundToPlace(places) {
  return function (num) {
    return roundTo(num, places);
  };
}

function getset(model, channel, modifier) {
  model = Array.isArray(model) ? model : [model];
  model.forEach(function (m) {
    (limiters[m] || (limiters[m] = []))[channel] = modifier;
  });
  model = model[0];
  return function (val) {
    var result;

    if (arguments.length) {
      if (modifier) {
        val = modifier(val);
      }

      result = this[model]();
      result.color[channel] = val;
      return result;
    }

    result = this[model]().color[channel];

    if (modifier) {
      result = modifier(result);
    }

    return result;
  };
}

function maxfn(max) {
  return function (v) {
    return Math.max(0, Math.min(max, v));
  };
}

function assertArray(val) {
  return Array.isArray(val) ? val : [val];
}

function zeroArray(arr, length) {
  for (var i = 0; i < length; i++) {
    if (typeof arr[i] !== 'number') {
      arr[i] = 0;
    }
  }

  return arr;
}

var color$1 = Color;

var fonts = {
  sans: "'futura-pt', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  serif: "'le-monde-livre-std', Georgia, 'Times New Roman', Times, serif"
};
var timing = {
  fast: '.25s',
  slow: '.5s',
  slower: '.75s'
};
var fontWeight = {
  light: '300',
  normal: '400',
  medium: '500',
  bold: '700'
};
var tracking = {
  none: '0',
  negTiny: '-0.5px',
  tiny: '0.5px',
  small: '1px',
  medium: '3px',
  large: '5px'
};
var colors = {
  baseBlack: '#000000',
  baseInherit: 'inherit',
  baseTransparent: 'transparent',
  baseWhite: '#FFFFFF',
  gardenBackground: '#FFFFFF',
  studioBackground: '#8F8E8D',
  gardenText: '#8F8E8D',
  studioText: '#EEEEEE',
  gardenMenu: '#BABABA',
  studioMenu: '#FFFFFF',
  brandBase: '#093660',
  brandPrimary: '#028595',
  brandSecondary: '#03C8E0',
  textBrand: '#093660',
  textBody: '#E8E8E8',
  textBlack: '#000000',
  textWhite: '#FFFFFF',
  textDark: '#808B98',
  btnBrand: '#093660',
  btnBrandHover: '#062038',
  btnPrimary: '#FFFFFF',
  btnPrimaryHover: '#FFFFFF',
  btnSecondary: '#03C8E0',
  btnSecondaryHover: '#03A1B4',
  btnAlternative: '#ffffff',
  btnAlternativeHover: '#093660',
  borderBase: 'rgba(255,255,255,0.25)',
  borderSecondary: '#03C8E0',
  borderBlack: '#000000',
  borderLight: 'rgba(215,220,226,0.50)',
  borderDark: '#828282',
  borderWhite: '#FFFFFF',
  borderShadow: '0 0 15px 2px rgba(0,0,0,0.1), 0 5px 22px 4px rgba(0,0,0,0.12), 0 7px 8px 0 rgba(0,0,0,0.14);',
  bgLight: '#F7F7F7',
  bgBlack: '#000000',
  bgDark: '#D9EDEF',
  bgWhite: '#FFFFFF',
  bgWhiteO: 'rgba(255,255,255,0.70)',
  bgLightO: 'rgba(216,216,216,0.1)',
  statusDanger: '#B0153C',
  statusInfo: '#85CEFF',
  statusNeutral: '#333333',
  statusSuccess: '#52A74B',
  statusWarning: '#F5A623',
  modalBackground: '#222222',
  modalText: '#FFFFFF'
};
var opacity = {
  solid: '1',
  hover: '.75',
  transparent: '0'
};
var spacingFactor = 8;
var spacing = {
  space0: "".concat(spacingFactor * 0, "px"),
  // 0
  space05: "".concat(spacingFactor / 2, "px"),
  // 4
  space1: "".concat(spacingFactor * 1, "px"),
  // 8
  space2: "".concat(spacingFactor * 2, "px"),
  // 16
  space3: "".concat(spacingFactor * 3, "px"),
  // 24
  space4: "".concat(spacingFactor * 4, "px"),
  // 32
  space5: "".concat(spacingFactor * 5, "px"),
  // 40
  space6: "".concat(spacingFactor * 6, "px"),
  // 48
  space7: "".concat(spacingFactor * 7, "px"),
  // 56
  space8: "".concat(spacingFactor * 8, "px"),
  // 64
  space9: "".concat(spacingFactor * 9, "px"),
  // 72
  space10: "".concat(spacingFactor * 10, "px"),
  // 80
  space11: "".concat(spacingFactor * 11, "px"),
  // 88
  space12: "".concat(spacingFactor * 12, "px"),
  // 96
  space13: "".concat(spacingFactor * 13, "px"),
  // 104
  space14: "".concat(spacingFactor * 14, "px"),
  // 168
  space15: "".concat(spacingFactor * 15, "px") // 120

};

var displayStyles = function displayStyles(display, theme) {
  var styles = {
    primary: {
      color: theme.colors.text,
      borderColor: theme.colors.underline,
      // For CSS hover
      borderColorHover: theme.colors.underlineHover,
      //For State
      hover: {
        borderColor: theme.colors.underlineHover,
        color: theme.colors.text
      }
    },
    heroButton: {
      color: theme.colors.heroText,
      borderColor: theme.colors.underline,
      // For CSS hover
      borderColorHover: theme.colors.underlineHover,
      hover: {
        borderColor: theme.colors.underlineHover,
        color: theme.colors.heroText
      }
    }
  };
  return styles[display];
};
var sizeStyles = {
  medium: {
    fontSize: '12px'
  }
};

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-right: ", ";\n  margin-left: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  background: none;\n  padding: 0px 0px 2px 0px;\n  cursor: pointer;\n  display: flex;\n  flex-shrink: 0;\n  font-family: ", ";\n  font-weight: ", ";\n  transition: all ", ";\n  display: ", ";\n  letter-spacing: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n    color: ", " !important;\n    border: none;\n    border-bottom: 1px solid transparent;\n    text-transform: ", ";\n    border-color: ", ";\n    :focus,\n    :hover {\n      border-color: ", ";\n      outline: 0;\n      text-decoration: none;\n      color: ", ";\n    }\n  "]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var css$1 = require('styled-components').css;

var display$2 = function display(props) {
  var style = displayStyles(props.display, props.theme);

  if (props.hover) {
    style = _objectSpread2(_objectSpread2({}, style), displayStyles(props.display, props.theme).hover);
  }

  return css$1(_templateObject$3(), style.color, function (props) {
    return props.uppercase ? 'uppercase' : 'none';
  }, style.borderColor, style.borderColorHover, style.color);
};

var size = function size(props) {
  var style = sizeStyles[props.size];
  return css$1(_templateObject2(), style.fontSize, style.lineHeight);
};

var Button = function Button(_ref) {
  var B = _ref.as,
      props = _objectWithoutProperties(_ref, ["as"]);

  return /*#__PURE__*/React__default.createElement(B, props);
};

var StyledButtonText = styled(Button)(_templateObject3(), display$2, size, fonts.sans, fontWeight.normal, timing.fast, function (props) {
  return props.block ? 'block' : 'inline';
}, tracking.medium);
var StyledIcon = styled.i(_templateObject4(), function (props) {
  return props.iconBefore ? '0.5rem' : '0';
}, function (props) {
  return props.iconAfter ? '0.5rem' : '0';
});

/** ButtonText Component for most commonly used text buttons */

var ButtonText = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonText, _React$Component);

  var _super = _createSuper(ButtonText);

  function ButtonText() {
    _classCallCheck(this, ButtonText);

    return _super.apply(this, arguments);
  }

  _createClass(ButtonText, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          display = _this$props.display,
          block = _this$props.block,
          size = _this$props.size,
          uppercase = _this$props.uppercase,
          onClick = _this$props.onClick,
          hover = _this$props.hover,
          iconBefore = _this$props.iconBefore,
          iconAfter = _this$props.iconAfter,
          as = _this$props.as,
          props = _objectWithoutProperties(_this$props, ["children", "display", "block", "size", "uppercase", "onClick", "hover", "iconBefore", "iconAfter", "as"]);

      return /*#__PURE__*/React__default.createElement(StyledButtonText, _extends({
        onClick: onClick,
        hover: hover,
        display: display,
        uppercase: uppercase,
        as: as,
        block: block,
        size: size,
        iconBefore: iconBefore,
        iconAfter: iconAfter
      }, props), iconBefore && /*#__PURE__*/React__default.createElement(StyledIcon, {
        iconBefore: iconBefore,
        className: "icon icon-".concat(iconBefore)
      }), children && children, iconAfter && /*#__PURE__*/React__default.createElement(StyledIcon, {
        iconAfter: iconAfter,
        className: "icon icon-".concat(iconAfter)
      }));
    }
  }]);

  return ButtonText;
}(React__default.Component);
ButtonText.propTypes = {
  /** Sets the display style */
  size: propTypes.oneOf(['medium', 'small']).isRequired,

  /** Sets the size of the component */
  display: propTypes.oneOf(['primary', 'heroButton']).isRequired,

  /** Contents of the Box */
  children: propTypes.node.isRequired,

  /** Renders the Title */
  block: propTypes.bool,

  /** Transform text to uppercase */
  uppercase: propTypes.bool,

  /** Click action */
  onClick: propTypes.func,

  /** Hover action */
  hover: propTypes.bool,

  /** Icon on the left of the button */
  iconBefore: propTypes.string,

  /** Icon on the right of the button */
  iconAfter: propTypes.string,

  /** Change the HTML element that is rendered */
  as: propTypes.oneOfType([propTypes.string, propTypes.func])
};
ButtonText.defaultProps = {
  display: 'primary',
  size: 'medium',
  uppercase: true,
  children: null,
  block: false,
  hover: false,
  iconBefore: null,
  iconAfter: null,
  as: 'a',
  onClick: function onClick() {}
};

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  flex: none;\n  width: ", ";\n  height: ", ";\n  max-width: 100%;\n  display: ", ";\n  border-radius: ", ";\n  background-image: url(", ");\n  background-position: center center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  ", ";\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n    padding-bottom: ", ";\n  "]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var css$2 = require('styled-components').css;

var display$3 = function display(props) {
  var displayStyles = {
    landscape: {
      paddingBottom: '60%'
    },
    portrait: {
      paddingBottom: '120%'
    },
    square: {
      paddingBottom: '100%'
    },
    cinamatic: {
      paddingBottom: '50%'
    },
    cover: {
      paddingBottom: 'inherit '
    }
  };
  var style = displayStyles[props.display];
  return css$2(_templateObject$4(), style.paddingBottom);
};

var StyledImageBox = styled.div(_templateObject2$1(), function (props) {
  return props.fluid === true ? '100%' : props.width;
}, function (props) {
  return props.display === 'cover' ? '100vh' : 'auto';
}, function (props) {
  return props.fixed ? 'inline-block' : 'block';
}, function (props) {
  return props.round ? '50%' : '0';
}, function (props) {
  return props.src ? props.src : null;
}, display$3);
var ImageBox = function ImageBox(props) {
  var width = props.width,
      src = props.src,
      alt = props.alt,
      fixed = props.fixed,
      fluid = props.fluid,
      display = props.display;
  return /*#__PURE__*/React__default.createElement(LazyLoad, {
    debounce: false,
    offsetVertical: 500
  }, /*#__PURE__*/React__default.createElement(StyledImageBox, {
    fixed: fixed,
    src: src,
    alt: alt,
    fluid: fluid,
    display: display,
    width: width
  }));
};
ImageBox.defaultProps = {
  fixed: false,
  src: null,
  fluid: true,
  display: 'landscape',
  width: null
};
ImageBox.propTypes = {
  /** Alt text for the image */
  alt: propTypes.string,

  /** Image src */
  src: propTypes.string.isRequired,

  /** Is this image not fluid */
  fixed: propTypes.bool,

  /** Is the Image responsive? */
  fluid: propTypes.bool,

  /** What is orientation of image? */
  display: propTypes.oneOf(['portrait', 'landscape', 'square', 'cinamatic', 'cover']),

  /** If the width is fixed, define the value with px */
  width: propTypes.bool
};

var marginStyle = function marginStyle(property, size, dimensions) {
  var forDimension = function forDimension(dimension) {
    return dimensions.includes(dimension) ? spacing[size] || size : '0';
  };

  return _defineProperty({}, property, [forDimension('top'), forDimension('right'), forDimension('bottom'), forDimension('left')].join(' '));
};
/**
 * Space component to add padding and margins.
 */


var Space = function Space(props) {
  var padding = props.padding,
      size = props.size,
      top = props.top,
      right = props.right,
      bottom = props.bottom,
      left = props.left,
      inline = props.inline,
      overrides = props.style,
      className = props.className,
      children = props.children,
      proxyProps = _objectWithoutProperties(props, ["padding", "size", "top", "right", "bottom", "left", "inline", "style", "className", "children"]);

  var property = padding ? 'padding' : 'margin';
  var dimensions = [top && 'top', right && 'right', bottom && 'bottom', left && 'left'].filter(Boolean);

  var style = _objectSpread2(_objectSpread2({}, marginStyle(property, size, dimensions)), overrides);

  if (inline) {
    return /*#__PURE__*/React__default.createElement("span", _extends({
      style: style,
      className: className
    }, proxyProps), children);
  }

  return /*#__PURE__*/React__default.createElement("div", _extends({
    style: style,
    className: className
  }, proxyProps), children);
};
Space.propTypes = {
  /** Will padding create the Space? */
  padding: propTypes.bool,

  /** Will margin create the Space? */
  margin: propTypes.bool,

  /** Size of the space - using spacing variables */
  size: propTypes.string,

  /** Is the space at the top? */
  top: propTypes.bool,

  /** Is the space at the right? */
  right: propTypes.bool,

  /** Is the space at the bottom? */
  bottom: propTypes.bool,

  /** Is the space at the left? */
  left: propTypes.bool,

  /** Is the spacing inline? Wrap in a span, not a div */
  inline: propTypes.bool,

  /** Style adds css to divs/spans */
  style: propTypes.object,

  /** Contents of Space*/
  children: propTypes.any,

  /** ClassName for layout - allowing Bootstrap classes to be added to wrapping divs (only if needed)*/
  className: propTypes.object
};
Space.defaultProps = {
  padding: false,
  size: 'default',
  top: false,
  right: false,
  bottom: false,
  left: false,
  inline: false,
  style: {},
  children: null,
  className: null
};

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: none !important;\n  color: inherit !important;\n  &:focus,\n  &:hover,\n  &:visited,\n  &:link,\n  &:active {\n    text-decoration: none !important;\n    color: inherit !important;\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLink = styled.div(_templateObject$5());
StyledLink.propTypes = {
  active: propTypes.bool
};
StyledLink.defaultProps = {
  active: false
};
var StyledLink$1 = (function (props) {
  return /*#__PURE__*/React__default.createElement(StyledLink, props);
});

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 1px solid;\n  border-bottom-color: ", ";\n  transition: all ", ";\n  text-align: center;\n  display: inline;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  vertical-align: top;\n  padding-left: ", ";\n  padding-right: ", ";\n  transition: all ", ";\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 0 auto;\n  padding-left: ", ";\n  padding-right: ", ";\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
/** Card Component for displaying a card with brief info and image of a person or company */

var StyledCard = styled(rebass.Box)(_templateObject$6(), spacing.space0, spacing.space0);
var StyledTextContainer = styled.div(_templateObject2$2(), function (props) {
  return props.height;
}, spacing.space0, spacing.space0, timing.slow);
var StyledTitle = styled(Element)(_templateObject3$1(), function (props) {
  return props.hover ? 'inherit' : 'transparent';
}, timing.slow);
var StyledSubTitle = styled(Element)(_templateObject4$1(), function (props) {
  return props.theme.colors.subTitle;
});
var Card = /*#__PURE__*/function (_React$Component) {
  _inherits(Card, _React$Component);

  var _super = _createSuper(Card);

  function Card(props) {
    var _this;

    _classCallCheck(this, Card);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleItem", function () {
      _this.setState({
        hover: !_this.state.hover
      });
    });

    _this.state = {
      hover: false
    };
    return _this;
  }

  _createClass(Card, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.updateHeight && this.element && this.props.updateHeight(this.element.clientHeight);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          description = _this$props.description,
          renderVisual = _this$props.renderVisual;
      return /*#__PURE__*/React__default.createElement(StyledCard, {
        onMouseEnter: function onMouseEnter() {
          return _this2.toggleItem();
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.toggleItem();
        },
        hover: this.state.hover,
        mb: [4, 7]
      }, renderVisual && /*#__PURE__*/React__default.createElement(rebass.Box, {
        width: "100%",
        css: {
          height: '100%'
        },
        mb: [1, 2]
      }, renderVisual), /*#__PURE__*/React__default.createElement(StyledTextContainer, {
        className: "stc text-center",
        ref: function ref(element) {
          return _this2.element = element;
        },
        height: this.props.max ? this.props.max > 0 ? "".concat(this.props.max, "px") : '100%' : '100%'
      }, subtitle && /*#__PURE__*/React__default.createElement(StyledSubTitle, {
        size: "meta",
        textAlign: "center",
        my: [0, 1]
      }, subtitle), title && /*#__PURE__*/React__default.createElement(StyledTitle, {
        size: "titleCard",
        html: title,
        hover: this.state.hover
      }), description && /*#__PURE__*/React__default.createElement(Element, {
        size: "description",
        textAlign: "center",
        mt: [1, 2]
      }, description), children && children));
    }
  }]);

  return Card;
}(React__default.Component);
Card.propTypes = {
  /** Meta text to categorise the content - above the Title */
  subtitle: propTypes.string,

  /** Description text to add more details - below the Title */
  description: propTypes.string,

  /** Title of the card */
  title: propTypes.string,

  /** Contents of the Card - for Text, display="bodySmall" is recommended */
  children: propTypes.node,

  /** Render Prop to display Visual like videos, gifs and images */
  renderVisual: propTypes.object
};
Card.defaultProps = {
  children: null,
  subtitle: null,
  description: null,
  title: null,
  renderVisual: null
};

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  padding: 0px;\n  background: ", ";\n  border-radius: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  position: absolute;\n  top: 50%;\n  margin-top: ", ";\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n\n  &.pagerLeft {\n    left: ", ";\n    @media (min-width: 768px) {\n      left: ", ";\n    }\n  }\n  &.pagerRight {\n    right: ", ";\n    @media (min-width: 768px) {\n      right: ", ";\n    }\n  }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: block;\n  opacity: ", ";\n  z-index: ", ";\n  transition: opacity ", ";\n  overflow: ", ";\n  &:hover {\n    opacity: 1;\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var css$3 = require('styled-components').css;

var StyledPagerWrapper = styled.span(_templateObject$7(), function (props) {
  return props.pagerType === 'round' ? '1' : '1';
}, function (props) {
  return props.pagerType === 'round' ? '1' : '9';
}, timing.slow, function (props) {
  return props.pagerType === 'arrow' ? 'hidden' : 'inherit';
});
var StyledPager = styled.span(_templateObject2$3());
var StyledIcon$1 = styled.span(_templateObject3$2(), function (props) {
  return props.pagerType === 'arrow' ? '1.6em' : '1em';
}, function (props) {
  return props.pagerType === 'arrow' ? colors.textDark : colors.baseWhite;
}, function (props) {
  return props.pagerType === 'arrow' ? colors.baseWhite : colors.baseTransparent;
}, function (props) {
  return props.pagerType === 'arrow' ? '0%' : '50%';
}, spacing.space6, function (props) {
  return props.pagerType === 'arrow' ? spacing.space9 : spacing.space6;
}, function (props) {
  return props.pagerType === 'arrow' ? "-".concat(spacing.space4) : "-".concat(spacing.space3);
}, colors.baseWhite, function (props) {
  return props.pagerType === 'arrow' ? '0px' : '-0.5rem';
}, function (props) {
  return props.pagerType === 'arrow' ? '0px' : '-5rem';
}, function (props) {
  return props.pagerType === 'arrow' ? '0px' : '-0.5rem';
}, function (props) {
  return props.pagerType === 'arrow' ? '0px' : '-5rem';
});

var Pager = /*#__PURE__*/function (_React$Component) {
  _inherits(Pager, _React$Component);

  var _super = _createSuper(Pager);

  function Pager() {
    _classCallCheck(this, Pager);

    return _super.apply(this, arguments);
  }

  _createClass(Pager, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          pagerType = _this$props.pagerType,
          borderRadius = _this$props.borderRadius;
      return /*#__PURE__*/React__default.createElement(StyledPagerWrapper, {
        pagerType: pagerType
      }, /*#__PURE__*/React__default.createElement(StyledPager, {
        onClick: function onClick() {
          return _this.props.onPrev();
        },
        pagerType: pagerType
      }, /*#__PURE__*/React__default.createElement(StyledIcon$1, {
        className: "pagerLeft",
        pagerType: pagerType
      }, /*#__PURE__*/React__default.createElement("i", {
        className: "icon icon-angle-left"
      }))), /*#__PURE__*/React__default.createElement(StyledPager, {
        onClick: function onClick() {
          return _this.props.onNext();
        },
        pagerType: pagerType
      }, /*#__PURE__*/React__default.createElement(StyledIcon$1, {
        className: "pagerRight",
        pagerType: pagerType
      }, /*#__PURE__*/React__default.createElement("i", {
        className: "icon icon-angle-right"
      }))));
    }
  }]);

  return Pager;
}(React__default.Component);

Pager.defaultProps = {
  pagerType: 'round'
};
Pager.propTypes = {
  pagerType: propTypes.oneOf(['round', 'arrow'])
};

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  z-index: 9;\n  min-width: 0;\n  min-height: 0;\n  display: grid;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  & * {\n    min-height: 0;\n    min-width: 0;\n  }\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledSlider = styled.div(_templateObject$8());
var StyledSliderContainer = styled.div(_templateObject2$4());
var SliderWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(SliderWrapper, _React$Component);

  var _super = _createSuper(SliderWrapper);

  function SliderWrapper() {
    var _this;

    _classCallCheck(this, SliderWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "next", function () {
      _this.slider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "previous", function () {
      _this.slider.slickPrev();
    });

    return _this;
  }

  _createClass(SliderWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          pager = _this$props.pager,
          children = _this$props.children,
          slidesToShow = _this$props.slidesToShow,
          adaptiveHeight = _this$props.adaptiveHeight,
          fade = _this$props.fade,
          asNavFor = _this$props.asNavFor,
          pagerType = _this$props.pagerType,
          dots = _this$props.dots;
      var settings = {
        dots: dots,
        arrows: false,
        infinite: false,
        lazyLoad: false,
        fade: fade,
        touchMove: true,
        speed: 1000,
        slidesToScroll: 1,
        swipeToSlide: true,
        centerMode: false,
        slidesToShow: slidesToShow,
        asNavFor: asNavFor,
        adaptiveHeight: adaptiveHeight,
        centerPadding: '100px'
      };
      return /*#__PURE__*/React__default.createElement(StyledSlider, null, /*#__PURE__*/React__default.createElement(StyledSliderContainer, null, /*#__PURE__*/React__default.createElement(Slider, _extends({
        ref: function ref(c) {
          return _this2.slider = c;
        }
      }, settings), children)), pager && /*#__PURE__*/React__default.createElement(Pager, {
        pagerType: pagerType,
        onPrev: this.previous,
        onNext: this.next
      }));
    }
  }]);

  return SliderWrapper;
}(React__default.Component);
SliderWrapper.defaultProps = {
  fade: true,
  dots: false,
  vertical: false,
  slidesToShow: 1,
  pager: true,
  asNavFor: null,
  pagerType: 'arrow',
  adaptiveHeight: true
};
SliderWrapper.propTypes = {
  fade: propTypes.bool,
  slidesToShow: propTypes.number,
  pager: propTypes.bool,
  asNavFor: propTypes.string,
  dots: propTypes.bool,
  adaptiveHeight: propTypes.bool,
  pagerType: propTypes.oneOf(['round', 'arrow'])
};

var Wistia = /*#__PURE__*/function (_Component) {
  _inherits(Wistia, _Component);

  var _super = _createSuper(Wistia);

  function Wistia(props) {
    var _this;

    _classCallCheck(this, Wistia);

    _this = _super.call(this, props);

    var _this$props = _objectSpread2({}, _this.props),
        video = _this$props.video,
        embedOptions = _objectWithoutProperties(_this$props, ["video"]);

    if (process.browser === true) {
      window._wq = window._wq || [];

      window._wq.push({
        id: video,
        options: embedOptions
      });
    }

    return _this;
  }

  _createClass(Wistia, [{
    key: "render",
    value: function render() {
      if (this.props.popover) {
        return /*#__PURE__*/React__default.createElement("span", {
          "class": "wistia_embed wistia_async_".concat(this.props.video, " popover=true popoverContent=link"),
          style: {
            display: 'inline',
            position: 'relative'
          }
        }, this.props.title);
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "wistia_embed wistia_async_".concat(this.props.video, " videoFoam=true")
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!document.getElementById('wistia_script')) {
        var wistiaScript = document.createElement('script');
        wistiaScript.id = 'wistia_script';
        wistiaScript.type = 'text/javascript';
        wistiaScript.src = 'https://fast.wistia.com/assets/external/E-v1.js';
        wistiaScript.async = true;
        document.body.appendChild(wistiaScript);
      }

      if (process.browser === true) {
        window._wq = window._wq || [];

        window._wq.push({
          id: this.props.video,
          onEmbedded: function onEmbedded(video) {
            _this2.handle = video;
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handle && this.handle.remove();
    }
  }]);

  return Wistia;
}(React.Component);

Wistia.defaultProps = {
  popover: false,
  controlsVisibleOnLoad: false
};

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n  ::before {\n    padding-top: 56.25%;\n    display: block;\n    content: '';\n  }\n  &.wistia {\n    ::before {\n      padding-top: 0;\n    }\n  }\n  iframe {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var HeroComponents = {
  vimeo: Vimeo,
  youtube: YouTube,
  wistia: Wistia
};
var StyledVideoWrapper = styled.div(_templateObject$9());
var VideoContainer = /*#__PURE__*/function (_Component) {
  _inherits(VideoContainer, _Component);

  var _super = _createSuper(VideoContainer);

  function VideoContainer() {
    _classCallCheck(this, VideoContainer);

    return _super.apply(this, arguments);
  }

  _createClass(VideoContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          videoID = _this$props.videoID,
          videoType = _this$props.videoType,
          videoCaption = _this$props.videoCaption;
      var VideoComponent = HeroComponents[videoType];
      return VideoComponent ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledVideoWrapper, {
        className: videoType
      }, /*#__PURE__*/React__default.createElement(VideoComponent, {
        video: videoID
      })), videoCaption && /*#__PURE__*/React__default.createElement(Element$1, {
        size: "bodySmall"
      }, videoCaption)) : null;
    }
  }]);

  return VideoContainer;
}(React.Component);

var ModalContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalContainer, _React$Component);

  var _super = _createSuper(ModalContainer);

  function ModalContainer() {
    var _content;

    var _this;

    _classCallCheck(this, ModalContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isopen: false
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        isopen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      _this.setState(function (state) {
        return {
          isopen: !state.isopen
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "bigStyles", {
      overlay: {
        backgroundColor: 'rgba(255, 255, 255, 1)',
        zIndex: 999
      },
      content: (_content = {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%'
      }, _defineProperty(_content, "marginRight", '-50%'), _defineProperty(_content, "transform", 'translate(-50%, -50%)'), _defineProperty(_content, "width", '100%'), _defineProperty(_content, "overlfow", 'auto'), _defineProperty(_content, "height", '100%'), _defineProperty(_content, "padding", '0px'), _defineProperty(_content, "border", 'none'), _defineProperty(_content, "borderRadius", '0px'), _defineProperty(_content, "backgroundColor", _this.props.customBG ? _this.props.customBG : colors.modalBackground), _content)
    });

    return _this;
  }

  _createClass(ModalContainer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, this.props.triggerRender ? this.props.triggerRender(this.toggleModal) : /*#__PURE__*/React__default.createElement(ButtonText, {
        onClick: this.toggleModal
      }, this.props.title), /*#__PURE__*/React__default.createElement(Modal, {
        style: this.bigStyles,
        isOpen: this.state.isopen
      }, this.props.render ? this.props.render(this.closeModal) : null));
    }
  }]);

  return ModalContainer;
}(React__default.Component);

function getButton(data, isHeroButton, as, content) {
  switch (data.type) {
    case 'video':
      return /*#__PURE__*/React__default.createElement(ModalContainer, {
        key: data.label,
        title: data.label,
        triggerRender: function triggerRender(toggleModal) {
          return /*#__PURE__*/React__default.createElement(ButtonText, {
            display: isHeroButton ? 'heroButton' : 'primary',
            onClick: toggleModal
          }, data.label);
        },
        render: function render(closeModal) {
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Space, {
            top: true,
            bottom: true,
            size: spacing.space3
          }, /*#__PURE__*/React__default.createElement("div", {
            className: "container"
          }, /*#__PURE__*/React__default.createElement("div", {
            className: "d-flex justify-content-end align-items-center mr-3"
          }, closeModal && /*#__PURE__*/React__default.createElement("div", {
            className: "d-flex"
          }, /*#__PURE__*/React__default.createElement(ButtonText, {
            onClick: closeModal,
            iconAfter: "close"
          }, "Close"))), /*#__PURE__*/React__default.createElement(VideoContainer, {
            videoID: data.video_id,
            videoType: data.video_type
          }))));
        }
      });

    case 'page':
      var pageType = function pageType(data) {
        if (data.page.post_type !== 'page') {
          return "/".concat(data.page.post_type, "/");
        } else {
          return '/';
        }
      };

      if (data.parent) {
        return data.page && /*#__PURE__*/React__default.createElement(StyledLink$1, {
          to: "/".concat(data.parent).concat(pageType(data)).concat(data.page.post_name),
          title: data.page.post_title,
          as: as
        }, /*#__PURE__*/React__default.createElement(ButtonText, {
          display: isHeroButton ? 'heroButton' : 'primary',
          as: "span"
        }, data.label));
      }

      return data.page && /*#__PURE__*/React__default.createElement(StyledLink$1, {
        to: "".concat(pageType(data)).concat(data.page.post_name),
        title: data.page.post_title,
        as: as
      }, /*#__PURE__*/React__default.createElement(ButtonText, {
        display: isHeroButton ? 'heroButton' : 'primary',
        as: "span"
      }, data.label));

    case 'url':
      return data.url && /*#__PURE__*/React__default.createElement(ButtonText, {
        as: "a",
        href: data.url,
        target: data.target,
        display: isHeroButton ? 'heroButton' : 'primary'
      }, data.label);

    case 'file':
      return data.file && /*#__PURE__*/React__default.createElement(ButtonText, {
        as: "a",
        href: data.file.url,
        target: "_blank",
        rel: "noopener noreferrer",
        title: data.file.title,
        display: isHeroButton ? 'heroButton' : 'primary'
      }, data.label);

    case 'modal':
      return /*#__PURE__*/React__default.createElement(ModalContainer, {
        key: data.label,
        title: data.label,
        customBG: data.customBG,
        triggerRender: function triggerRender(toggleModal) {
          return /*#__PURE__*/React__default.createElement(ButtonText, {
            display: isHeroButton ? 'heroButton' : 'primary',
            onClick: toggleModal
          }, data.label);
        },
        render: function render(closeModal) {
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Space, {
            top: true,
            bottom: true,
            size: spacing.space3
          }, /*#__PURE__*/React__default.createElement("div", {
            className: "d-flex justify-content-end align-items-center mr-3"
          }, closeModal && /*#__PURE__*/React__default.createElement("div", {
            className: "d-flex"
          }, /*#__PURE__*/React__default.createElement(ButtonText, {
            onClick: closeModal,
            iconAfter: "close"
          }, "Close"))), content && content));
        }
      });

    default:
      return null;
  }
}
function getCardLink(data, parent, linkAs) {
  var CardComponent = /*#__PURE__*/React__default.createElement(Card, {
    renderVisual: getCardVisual(data.visual),
    meta: data.subtitle,
    subtitle: data.subtitle,
    title: data.title
  });
  var link = data.link;

  switch (link.type) {
    case 'video':
      return /*#__PURE__*/React__default.createElement(ModalContainer, {
        key: link.label,
        title: link.label,
        triggerRender: function triggerRender(toggleModal) {
          return /*#__PURE__*/React__default.createElement("div", {
            onClick: toggleModal,
            style: {
              cursor: 'pointer'
            }
          }, CardComponent);
        },
        render: function render(closeModal) {
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Space, {
            top: true,
            bottom: true,
            size: spacing.space3
          }, /*#__PURE__*/React__default.createElement("div", {
            className: "container"
          }, /*#__PURE__*/React__default.createElement("div", {
            className: "d-flex justify-content-end align-items-center mr-3"
          }, closeModal && /*#__PURE__*/React__default.createElement("div", {
            className: "d-flex"
          }, /*#__PURE__*/React__default.createElement(ButtonText, {
            onClick: closeModal,
            iconAfter: "close"
          }, "Close"))), /*#__PURE__*/React__default.createElement(VideoContainer, {
            videoID: link.video_id,
            videoType: link.video_type
          }))));
        }
      });

    case 'page':
      if (link.page) {
        if (link.page.post_type === 'page') {
          return /*#__PURE__*/React__default.createElement(StyledLink$1, {
            to: parent ? "/".concat(parent, "/").concat(link.page.post_name) : "/".concat(link.page.post_name),
            title: link.page.post_title,
            as: linkAs
          }, CardComponent);
        }

        return /*#__PURE__*/React__default.createElement(StyledLink$1, {
          to: parent ? "/".concat(parent, "/").concat(link.page.post_type, "/").concat(link.page.post_name) : "/".concat(link.page.post_type, "/").concat(link.page.post_name),
          title: link.page.post_title,
          as: linkAs
        }, CardComponent);
      }

    case 'file':
      if (link.type === 'file') {
        return link.file && /*#__PURE__*/React__default.createElement("a", {
          className: "cardLink",
          href: link.file.url,
          target: link.type == 'file' ? '_blank' : link.target,
          rel: "noopener noreferrer",
          title: link.type == 'file' ? link.file.title : data.title
        }, CardComponent);
      }

    case 'url':
      if (link.type === 'url') {
        return link.url && /*#__PURE__*/React__default.createElement("a", {
          className: "cardLink",
          href: link.url,
          target: link.type == 'file' ? '_blank' : link.target,
          rel: "noopener noreferrer",
          title: link.type == 'file' ? link.file.title : data.title
        }, CardComponent);
      }

    default:
      return CardComponent;
  }
}
var getHeroVisual = function getHeroVisual(data) {
  var type = data.type,
      gallery = data.gallery,
      source_url = data.source_url,
      video_id = data.video_id,
      video_type = data.video_type,
      title = data.title,
      video_caption = data.video_caption;

  if (type === 'gallery') {
    if (gallery.length > 1) {
      return /*#__PURE__*/React__default.createElement(SliderWrapper, null, gallery.map(function (v, index) {
        return /*#__PURE__*/React__default.createElement(ImageBox, {
          key: index,
          display: "cinamatic",
          src: v.url
        });
      }));
    }

    if (gallery.length === 1) {
      return /*#__PURE__*/React__default.createElement(ImageBox, {
        display: "cinamatic",
        src: gallery[0].url
      });
    }
  }

  if (type === 'video') {
    return /*#__PURE__*/React__default.createElement(VideoContainer, {
      videoID: video_id,
      videoType: video_type,
      videoCaption: video_caption
    });
  }

  if (source_url) {
    return /*#__PURE__*/React__default.createElement(LazyLoad, {
      debounce: false,
      offsetVertical: 500
    }, /*#__PURE__*/React__default.createElement("img", {
      className: "img-fluid",
      alt: title,
      src: source_url
    }));
  }

  return null;
};
var getCardVisual = function getCardVisual(data) {
  if (data && data.type === 'gallery') {
    if (data.gallery && data.gallery.length > 1) {
      return /*#__PURE__*/React__default.createElement(SliderWrapper, null, data.gallery.map(function (v, index) {
        return /*#__PURE__*/React__default.createElement("div", {
          key: index
        }, /*#__PURE__*/React__default.createElement("img", {
          style: {
            width: '100%'
          },
          className: "img-fluid",
          key: index,
          src: v.url,
          alt: v.title
        }));
      }));
    }

    if (data.gallery && data.gallery.length === 1) {
      return /*#__PURE__*/React__default.createElement(LazyLoad, {
        debounce: false,
        offsetVertical: 500
      }, /*#__PURE__*/React__default.createElement("img", {
        className: "img-fluid",
        alt: data.gallery[0].title,
        src: data.gallery[0].url
      }));
    }
  }

  if (data && data.type === 'video') {
    if (data.video_thumbnail) {
      return /*#__PURE__*/React__default.createElement(LazyLoad, {
        debounce: false,
        offsetVertical: 500
      }, /*#__PURE__*/React__default.createElement("img", {
        className: "img-fluid",
        alt: "Video Thumbnail",
        src: data.video_thumbnail
      }));
    }
  }

  if (data && data.type === 'product') {
    return /*#__PURE__*/React__default.createElement("img", {
      className: "img-fluid",
      alt: data.title ? data.title : null,
      src: data.imgSrc
    });
  } //featured media


  if (data && data.source_url) {
    return /*#__PURE__*/React__default.createElement(LazyLoad, {
      debounce: false,
      offsetVertical: 500
    }, /*#__PURE__*/React__default.createElement("img", {
      className: "img-fluid",
      alt: data.title,
      src: data.source_url
    }));
  }

  return null;
};
function getHeroDetails(data) {
  var heroDetails = {};
  var hero = data.acf.hero,
      title = data.title;

  if (hero) {
    hero.map(function (h) {
      var headline = h.headline,
          subtitle = h.subtitle,
          content = h.content,
          visual = h.visual,
          buttons = h.buttons,
          description = h.description,
          noCrop = h.noCrop;

      if (headline) {
        heroDetails.title = headline;
      }

      if (subtitle) {
        heroDetails.subtitle = subtitle;
      }

      if (description) {
        heroDetails.description = description;
      }

      if (content) {
        heroDetails.content = content;
      }

      if (visual) {
        heroDetails.visual = visual ? getHeroVisual(visual) : null;
      }

      if (noCrop) {
        heroDetails.noCrop = noCrop;
      }

      if (buttons) {
        heroDetails.buttons = buttons;
      }
    });
  }

  if (!heroDetails.title) {
    heroDetails.title = title;
  }

  return heroDetails;
}
function globalSpringProps(inView) {
  var springProps = reactSpring.useSpring({
    opacity: inView ? 1 : 0,
    // transform: inView ? "scale(1)" : "scale(0.9)",
    marginTop: inView ? '0px' : '64px' //config: { duration: 2000 }

  });
  return springProps;
}
var formatCurrency = function formatCurrency(value, unit) {
  var includeVat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var calculatedToFormat = value;

  if (includeVat) {
    calculatedToFormat = value * 1.15;
  }

  return new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: unit
  }).format(calculatedToFormat);
};
var convertCmToIn = function convertCmToIn(cm) {
  if (cm) return Math.round(cm / 2.54);
  return null;
};
var convertKgToLb = function convertKgToLb(kg) {
  if (kg) return Math.round(kg / 0.45359237);
  return null;
};
var size$1 = {
  small: 576,
  medium: 768,
  large: 992,
  xlarge: 1200
};
var mediaQuery = {
  small: "@media (min-width: ".concat(size$1.small, "px)"),
  medium: "@media (min-width: ".concat(size$1.medium, "px)"),
  large: "@media (min-width: ".concat(size$1.large, "px)"),
  xlarge: "@media (min-width: ".concat(size$1.xlarge, "px)")
};
/** Convert Hex to RGBA */

var rgba = function rgba(hex, opacity) {
  return color$1(hex).alpha(opacity).string();
};

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  padding: 0px ", "px;\n  font-size: ", ";\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  align-items: flex-start;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var StyledWrapper = styled(rebass.Flex)(_templateObject$a());
var StyledIcon$2 = styled.i(_templateObject2$5(), function (props) {
  return props.color;
}, baseTheme.space[1], baseTheme.fontSizes.body);
var getStatusScheme = {
  success: {
    color: baseTheme.colors.statusSuccess,
    bg: rgba(baseTheme.colors.statusSuccess, 0.1),
    icon: baseTheme.icons.success
  },
  info: {
    color: baseTheme.colors.statusInfo,
    bg: rgba(baseTheme.colors.statusInfo, 0.1),
    icon: baseTheme.icons.info
  },
  warning: {
    color: baseTheme.colors.statusWarning,
    bg: rgba(baseTheme.colors.statusWarning, 0.1),
    icon: baseTheme.icons.warning
  },
  error: {
    color: baseTheme.colors.statusError,
    bg: rgba(baseTheme.colors.statusError, 0.1),
    icon: baseTheme.icons.error
  }
};

var Alert = function Alert(props) {
  var text = props.text,
      status = props.status,
      icon = props.icon,
      rest = _objectWithoutProperties(props, ["text", "status", "icon"]);

  return /*#__PURE__*/React__default.createElement(StyledWrapper, _extends({
    p: [1]
  }, rest, {
    bg: getStatusScheme[status].bg
  }), /*#__PURE__*/React__default.createElement(StyledIcon$2, {
    className: icon ? "icon icon-".concat(baseTheme.icons[icon]) : "icon icon-".concat(getStatusScheme[status].icon),
    color: getStatusScheme[status].color
  }), /*#__PURE__*/React__default.createElement(rebass.Box, {
    className: "Alert_Box"
  }, /*#__PURE__*/React__default.createElement(Element$1, {
    size: "alert",
    color: getStatusScheme[status].color,
    html: text
  })));
};
Alert.propTypes = {
  /** Status of the Alert */
  status: propTypes.oneOf(Object.keys(getStatusScheme)).isRequired,

  /** Text as content */
  text: propTypes.string.isRequired,

  /** Icon can be overwritten by a custom one from theme */
  icon: propTypes.oneOf(Object.keys(baseTheme.icons)),

  /** Icon can be overwritten by a custom one from theme */
  color: propTypes.oneOf(Object.keys(baseTheme.colors))
};
Alert.defaultProps = {
  text: null,
  status: 'error',
  color: '#222222'
};

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  :hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 14px;\n  letter-spacing: 4px;\n  font-weight: ", ";\n  color: ", ";\n  @media (min-width: 700px) {\n    letter-spacing: 7.7px;\n  }\n  :hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 14px;\n  font-weight: ", ";\n  display: block;\n  color: ", ";\n  :hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  text-transform: uppercase;\n  font-size: 16px;\n  letter-spacing: 4px;\n  transition: all 0.3s;\n\n  @media (min-width: 700px) {\n    letter-spacing: 7.4px;\n    font-size: 20px;\n  }\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var StyledLogo = styled.span(_templateObject$b(), fonts.sans);
var StyledDylan = styled.span(_templateObject2$6(), fontWeight.normal, function (props) {
  return props.template === 'studio' ? colors.studioText : colors.gardenText;
});
var StyledGarden = styled.span(_templateObject3$3(), function (props) {
  return props.active && fontWeight.bold;
}, colors.gardenText);
var StyledStudio = styled.span(_templateObject4$2(), function (props) {
  return props.active && fontWeight.bold;
}, function (props) {
  return props.template === 'studio' ? colors.studioText : colors.gardenText;
});
var Logo = /*#__PURE__*/function (_Component) {
  _inherits(Logo, _Component);

  var _super = _createSuper(Logo);

  function Logo(props) {
    var _this;

    _classCallCheck(this, Logo);

    _this = _super.call(this, props);
    _this.state = {
      hovered: false
    };
    return _this;
  }

  _createClass(Logo, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          template = _this$props.template,
          isopen = _this$props.isopen,
          isDisplay = _this$props.isDisplay;
      return /*#__PURE__*/React__default.createElement(StyledLogo, {
        style: {
          display: isDisplay ? 'block' : 'none'
        }
      }, isopen ? /*#__PURE__*/React__default.createElement(StyledDylan, {
        template: template
      }, "Dylan Lewis") : null, template === 'garden' ? /*#__PURE__*/React__default.createElement(StyledGarden, {
        active: isopen
      }, "Sculpture Garden") : /*#__PURE__*/React__default.createElement(StyledStudio, {
        template: template,
        active: isopen
      }, "Studio"));
    }
  }]);

  return Logo;
}(React.Component);
Logo.defaultProps = {
  template: 'studio',
  isDisplay: true
};
Logo.propTypes = {// template: PropTypes.oneOf[("studio", "garden", "portfolio")]
};

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n\n  /* If device width is <= breakAt, then ... */\n  @media (max-width: ", "px) {\n    display: none;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n\n  /* If device width is >= breakAt, then ... */\n  @media (min-width: ", "px) {\n    display: none;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  ", " {\n    display: none;\n  }\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  ", " {\n    display: none;\n  }\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    display: ", ";\n  }\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  ", " {\n    display: none;\n  }\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  ", " {\n    display: none;\n  }\n  ", " {\n    display: none;\n  }\n  ", " {\n    display: ", ";\n  }\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var ShowAtLarge = styled.div(_templateObject$c(), mediaQuery.small, mediaQuery.medium, mediaQuery.large, function (props) {
  return props.flex ? 'flex' : 'block';
});
var ShowAtMedium = styled.div(_templateObject2$7(), mediaQuery.small, mediaQuery.medium, function (props) {
  return props.flex ? 'flex' : 'block';
}, mediaQuery.large);
var ShowAtMediumAndBelow = styled.div(_templateObject3$4(), function (props) {
  return props.flex ? 'flex' : 'block';
}, mediaQuery.small, function (props) {
  return props.flex ? 'flex' : 'block';
}, mediaQuery.medium, function (props) {
  return props.flex ? 'flex' : 'block';
}, mediaQuery.large);
var ShowAtMediumAndAbove = styled.div(_templateObject4$3(), mediaQuery.small, mediaQuery.medium, function (props) {
  return props.flex ? 'flex' : 'block';
}, mediaQuery.large, function (props) {
  return props.flex ? 'flex' : 'block';
});
var ShowAtSmall = styled.div(_templateObject5(), function (props) {
  return props.flex ? 'flex' : 'block';
}, mediaQuery.medium, mediaQuery.large);
var ShowAtCustomMin = styled.div(_templateObject6(), function (props) {
  return props.flex ? 'flex' : 'block';
}, function (props) {
  return props.breakAt;
});
var ShowAtCustomMax = styled.div(_templateObject7(), function (props) {
  return props.flex ? 'flex' : 'block';
}, function (props) {
  return props.breakAt;
});
function ShowAt(_ref) {
  var breakpoint = _ref.breakpoint,
      flex = _ref.flex,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["breakpoint", "flex", "children"]);

  var Component;

  switch (breakpoint) {
    case 'small':
      Component = ShowAtSmall;
      break;

    case 'medium':
      Component = ShowAtMedium;
      break;

    case 'mediumAndBelow':
      Component = ShowAtMediumAndBelow;
      break;

    case 'mediumAndAbove':
      Component = ShowAtMediumAndAbove;
      break;

    case 'large':
      Component = ShowAtLarge;
      break;

    case 'customMin':
      Component = ShowAtCustomMin;
      break;

    case 'customMax':
      Component = ShowAtCustomMax;
      break;

    default:
      Component = React__default.Fragment;
  }

  return /*#__PURE__*/React__default.createElement(Component, _extends({
    flex: flex
  }, rest), children);
}
ShowAt.propTypes = {
  /** Breakpoint for various viewports */
  breakpoint: propTypes.string,

  /** Should the display be flex? else set to block */
  flex: propTypes.string,

  /** Children node wrapper */
  children: propTypes.node
};

function _templateObject4$4() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  padding-right: ", ";\n  position: absolute;\n  display: flex;\n  width: 100%;\n  height: 100vh;\n  background-color: ", ";\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9;\n  li {\n    margin-left: 0px;\n  }\n  /* a {\n    width: 100%;\n  } */\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin: 0;\n  padding-top: 40px;\n  padding: 0;\n  list-style: none;\n  display: ", ";\n  flex-direction: row;\n  align-items: left;\n  justify-content: flex-start;\n  flex-shrink: 0;\n  @media (max-width: 1310px) {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n  li {\n    margin: 0;\n    margin-left: 29px;\n    margin-right: 29px;\n    font-family: ", ";\n    font-size: 16px;\n    line-height: 35px;\n    font-weight: ", ";\n    letter-spacing: ", ";\n    display: flex;\n    &:last-child {\n      margin-right: 0px;\n    }\n    a {\n      transition: all ", ";\n      text-decoration: none;\n      padding-bottom: ", ";\n      color: ", ";\n      border-bottom: 1px solid transparent;\n      &.active,\n      :hover,\n      :focus,\n      :active {\n        color: ", ";\n        text-decoration: none;\n        border-bottom: 1px solid ", ";\n      }\n    }\n  }\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  border: ", ";\n  padding: ", "; \n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  z-index: 99;\n  position: relative;\n  color: ", ";\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var PrimaryMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(PrimaryMenu, _React$Component);

  var _super = _createSuper(PrimaryMenu);

  function PrimaryMenu() {
    var _this;

    _classCallCheck(this, PrimaryMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isopen: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      if (_this.props.setAnimate) {
        _this.props.setAnimate(false);
      }

      _this.setState({
        isopen: !_this.state.isopen
      });
    });

    return _this;
  }

  _createClass(PrimaryMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          items = _this$props.items,
          sticky = _this$props.sticky,
          template = _this$props.template,
          isParentOpen = _this$props.isParentOpen,
          as = _this$props.as;

      var MenuToggle = function MenuToggle(props) {
        var items = props.items,
            as = props.as;
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledButton, {
          iconBefore: _this2.state.isopen ? baseTheme.icons.close : baseTheme.icons.menu,
          onClick: _this2.toggleOpen
        }, _this2.state.isopen ? 'Close' : 'Menu'), _this2.state.isopen && /*#__PURE__*/React.createElement(StyledMenuMobile, {
          className: "StyledMenuMobile"
        }, /*#__PURE__*/React.createElement(Menu, {
          items: items,
          as: as
        })));
      };

      var Menu = function Menu(props) {
        var items = props.items;
        return items.map(function (p, index) {
          var LinkComponent = p.as || 'a';
          return /*#__PURE__*/React.createElement(StyledMenuItem, {
            key: index,
            hightlight: p.hightlight
          }, /*#__PURE__*/React.createElement(LinkComponent, _extends({
            to: p.url
          }, p, {
            activeClassName: "active",
            onClick: _this2.toggleOpen
          }), p.label));
        });
      };

      return /*#__PURE__*/React.createElement(StyledPrimaryMenu, {
        className: "StyledPrimaryMenu",
        sticky: sticky,
        template: template,
        isParentOpen: isParentOpen
      }, /*#__PURE__*/React.createElement(ShowAt, {
        breakpoint: template === 'garden' ? 'customMin' : 'mediumAndBelow',
        breakAt: '1211'
      }, /*#__PURE__*/React.createElement(MenuToggle, {
        items: items,
        as: as
      })), /*#__PURE__*/React.createElement(ShowAt, {
        breakpoint: template === 'garden' ? 'customMax' : 'large',
        breakAt: '1210',
        flex: true
      }, /*#__PURE__*/React.createElement(Menu, {
        items: items,
        as: as
      })));
    }
  }]);

  return PrimaryMenu;
}(React.Component);
PrimaryMenu.propTypes = {};
PrimaryMenu.defaultProps = {};
var StyledButton = styled(ButtonText)(_templateObject$d(), function (props) {
  return props.theme.colors.menu;
});
var StyledMenuItem = styled.li(_templateObject2$8(), function (props) {
  return props.hightlight ? "1px solid ".concat(props.theme.colors.menu) : null;
}, function (props) {
  return props.hightlight ? "0px 32px !important" : null;
});
var StyledPrimaryMenu = styled.ul(_templateObject3$5(), function (props) {
  return props.isParentOpen ? 'flex' : 'none';
}, fonts.sans, fontWeight.normal, tracking.small, timing.fast, spacing.space0, function (props) {
  return props.theme.colors.menu;
}, function (props) {
  return props.theme.colors.menu;
}, colors.textBody);
var StyledMenuMobile = styled(StyledPrimaryMenu)(_templateObject4$4(), spacing.space3, spacing.space15, function (props) {
  return props.theme.colors.mobileMenuBG;
});

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  background-color: ", ";\n  color: ", ";\n  width: 100%;\n  padding: ", " 0;\n  transition: background-color 1s;\n  @media (min-width: 700px) {\n    padding: ", " 0;\n  }\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var StyledHeader = styled.div(_templateObject$e(), function (props) {
  return props.theme.colors.bg;
}, function (_ref) {
  var template = _ref.template;
  return template === 'garden' ? colors.gardenText : colors.studioText;
}, function (props) {
  return props.isopen ? spacing.space2 : spacing.space4;
}, spacing.space4);
var Header = /*#__PURE__*/function (_React$Component) {
  _inherits(Header, _React$Component);

  var _super = _createSuper(Header);

  function Header() {
    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isSticky: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleStateChange", function (status) {
      if (status.status === Sticky.STATUS_FIXED) {
        _this.setState({
          isSticky: true
        });
      } else {
        _this.setState({
          isSticky: false
        });
      }
    });

    return _this;
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var isSticky = this.state.isSticky;
      var _this$props = this.props,
          primaryMenuItems = _this$props.primaryMenuItems,
          enableSticky = _this$props.enableSticky,
          template = _this$props.template,
          isopen = _this$props.isopen,
          theme = _this$props.theme,
          setAnimate = _this$props.setAnimate,
          linkAs = _this$props.linkAs;
      var headerComponent = /*#__PURE__*/React__default.createElement(StyledHeader, {
        sticky: isSticky,
        className: isSticky ? 'isSticky' : 'notSticky',
        template: template,
        theme: theme,
        isopen: isopen
      }, /*#__PURE__*/React__default.createElement(Container, {
        maxWidth: "1440px",
        px: ['15px', '48px']
      }, /*#__PURE__*/React__default.createElement(rebass.Flex, {
        alignItems: "center",
        justifyContent: "space-between"
      }, /*#__PURE__*/React__default.createElement(rebass.Flex, {
        alignItems: "center"
      }, /*#__PURE__*/React__default.createElement(StyledLink$1, {
        to: "/".concat(template),
        as: linkAs
      }, /*#__PURE__*/React__default.createElement(Logo, {
        template: template,
        isopen: isopen
      }))), /*#__PURE__*/React__default.createElement(rebass.Flex, {
        alignItems: "center"
      }, primaryMenuItems && /*#__PURE__*/React__default.createElement(PrimaryMenu, {
        isParentOpen: isopen,
        sticky: this.state.isSticky,
        items: primaryMenuItems.map(function (items) {
          return _objectSpread2(_objectSpread2({}, items), {}, {
            as: linkAs
          });
        }),
        template: template,
        setAnimate: setAnimate
      })))));

      if (enableSticky) {
        return /*#__PURE__*/React__default.createElement(Sticky, {
          enabled: enableSticky,
          top: 0,
          onStateChange: this.handleStateChange,
          innerZ: 99
        }, headerComponent);
      }

      return /*#__PURE__*/React__default.createElement("div", null, headerComponent);
    }
  }]);

  return Header;
}(React__default.Component);
Header.propTypes = {};
Header.defaultProps = {
  enableSticky: false
};

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  border-top: 1px solid\n    ", ";\n  margin: 0px;\n  padding: 0px;\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var StyledBorder = styled.hr(_templateObject$f(), function (props) {
  return props.border ? props.theme.colors.hr : 'transparent';
});
var Border = function Border(props) {
  return /*#__PURE__*/React__default.createElement(StyledBorder, {
    border: props.border
  });
};
Border.defaultProps = {
  border: true
};
Border.propTypes = {
  /** Is there a border? */
  border: propTypes.bool.isRequired
};

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  transition: all ", ";\n  :hover {\n    opacity: 0.8;\n  }\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}
var StyledImageBox$1 = styled.div(_templateObject$g(), timing.fast);

var InstagramContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(InstagramContainer, _React$Component);

  var _super = _createSuper(InstagramContainer);

  function InstagramContainer() {
    var _this;

    _classCallCheck(this, InstagramContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: true,
      results: [],
      error: null
    });

    return _this;
  }

  _createClass(InstagramContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      fetch('https://www.instagram.com/dylanlewissculpturegarden/?__a=1').then(function (resp) {
        return resp.json();
      }).then(function (result) {
        _this2.setState({
          loading: false,
          results: result.graphql.user.edge_owner_to_timeline_media.edges
        });
      })["catch"](function (err) {
        _this2.setState({
          loading: false,
          error: err.mesage
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          results = _this$state.results,
          loading = _this$state.loading,
          error = _this$state.error;

      if (error || results.length === 0) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Row, {
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column"
      }, /*#__PURE__*/React__default.createElement(ButtonText, {
        display: "primary",
        as: "a",
        target: "_blank",
        rel: "noopener noreferrer",
        href: "https://www.instagram.com/dylanlewissculpturegarden/"
      }, /*#__PURE__*/React__default.createElement("i", {
        className: "icon icon-instagram"
      }), "dylanlewissculpturegarden"))), /*#__PURE__*/React__default.createElement(Container, {
        maxWidth: '100%',
        mb: [5, 10],
        mt: [5, 7]
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React__default.createElement(Media, {
        query: {
          maxWidth: 700
        }
      }, function (matches) {
        return results && results.slice(0, matches ? 3 : 7).map(function (item, index) {
          var image = item.node;
          return /*#__PURE__*/React__default.createElement("div", {
            className: "col",
            key: index
          }, /*#__PURE__*/React__default.createElement("a", {
            href: "https://www.instagram.com/p/".concat(item.node.shortcode),
            target: "_blank",
            rel: "noopener noreferrer",
            key: index
          }, /*#__PURE__*/React__default.createElement(StyledImageBox$1, null, /*#__PURE__*/React__default.createElement(ImageBox, {
            key: index,
            display: "square",
            src: image.display_url,
            url: image.display_url
          }))));
        });
      }))));
    }
  }]);

  return InstagramContainer;
}(React__default.Component);

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 10px;\n  line-height: 16px;\n  letter-spacing: ", ";\n  color: ", ";\n  text-transform: uppercase;\n  a {\n    color: ", ";\n  }\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}
var StyledFooter = styled(rebass.Box)(_templateObject$h());
var StyledLegal = styled.small(_templateObject2$9(), fonts.sans, tracking.small, function (props) {
  return props.theme.colors.menu;
}, function (props) {
  return props.theme.colors.menu;
});
var Footer = function Footer(props) {
  var template = props.template,
      children = props.children;
  return /*#__PURE__*/React.createElement(rebass.Box, null, /*#__PURE__*/React.createElement(Border, null), /*#__PURE__*/React.createElement(StyledFooter, {
    pt: [3, 5],
    pb: [1, 3]
  }, template === 'garden' && /*#__PURE__*/React.createElement(InstagramContainer, null), /*#__PURE__*/React.createElement(Container, null, children && children, /*#__PURE__*/React.createElement(LegalFooter, null))));
};
var LegalFooter = function LegalFooter() {
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(StyledLegal, null, "\xA9 ", new Date().getFullYear(), " all rights reserved. Pardus Fine Art CC. Crafted by", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://www.plusplusminus.co.za/?utm_source=DylanLewisWebsite&utm_medium=Footer&utm_campaign=Credit",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "PlusPlusMinus"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: "https://dylanlewis.com/garden/privacy-policy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy"))));
};
Footer.propTypes = {};
Footer.defaultProps = {};

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: ", ";\n  @media (min-width: 992px) {\n  }\n  li {\n    margin: 0;\n    font-family: ", ";\n    font-size: 16px;\n    line-height: 25px;\n    font-weight: ", ";\n    letter-spacing: ", ";\n    display: inline;\n    a {\n      text-decoration: none;\n      color: ", ";\n      border-bottom: 1px solid transparent;\n      transition: all ", ";\n      :hover,\n      :focus,\n      :active {\n        color: ", ";\n        text-decoration: none;\n        border-bottom: 1px solid ", ";\n      }\n    }\n  }\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  font-family: ", ";\n  line-height: 25px;\n  font-weight: ", ";\n  letter-spacing: ", ";\n  display: flex;\n  color: ", ";\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$i() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16px !important;\n  font-weight: ", ";\n  letter-spacing: ", ";\n  color: ", ";\n  margin-bottom: ", ";\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}

var Menu = function Menu(props) {
  var items = props.items,
      menuTitle = props.menuTitle,
      titleUrl = props.titleUrl,
      className = props.className,
      _props$as = props.as,
      as = _props$as === void 0 ? null : _props$as;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, menuTitle && (titleUrl ? /*#__PURE__*/React.createElement(StyledLink$1, {
    to: titleUrl,
    title: menuTitle,
    as: as
  }, /*#__PURE__*/React.createElement(StyledTitle$1, null, menuTitle)) : /*#__PURE__*/React.createElement(StyledTitle$1, null, menuTitle)), /*#__PURE__*/React.createElement(StyledFooterMenu, null, items.map(function (p) {
    return /*#__PURE__*/React.createElement("li", {
      key: p.label
    }, p.url ? /*#__PURE__*/React.createElement("a", {
      href: p.url,
      title: p.label,
      target: p.externalLink ? '_blank' : null,
      rel: p.externalLink ? 'noopener noreferrer' : null,
      as: p.as ? p.as : null
    }, /*#__PURE__*/React.createElement(rebass.Flex, {
      alignItems: "center"
    }, p.icon && /*#__PURE__*/React.createElement("i", {
      className: "icon icon-fw icon-".concat(p.icon, " mr-1")
    }), /*#__PURE__*/React.createElement(StyledText, {
      size: "body",
      html: p.label
    }))) : p.to ? /*#__PURE__*/React.createElement("a", {
      to: p.to,
      title: p.label,
      target: p.externalLink ? '_blank' : null,
      rel: p.externalLink ? 'noopener noreferrer' : null,
      as: p.as ? p.as : null
    }, /*#__PURE__*/React.createElement(rebass.Flex, {
      alignItems: "center"
    }, p.icon && /*#__PURE__*/React.createElement("i", {
      className: "icon icon-fw icon-".concat(p.icon, " mr-1")
    }), /*#__PURE__*/React.createElement(StyledText, {
      size: "body",
      html: p.label
    }))) : /*#__PURE__*/React.createElement(StyledText, {
      size: "body",
      html: p.label
    }));
  })));
};

var StyledTitle$1 = styled.h6(_templateObject$i(), fonts.sans, fontWeight.medium, tracking.small, function (props) {
  return props.theme.colors.text;
}, spacing.space2);
var StyledText = styled(Element$1)(_templateObject2$a(), fonts.sans, fontWeight.normal, tracking.small, function (props) {
  return props.theme.colors.text;
});
var StyledFooterMenu = styled.ul(_templateObject3$6(), spacing.space4, fonts.sans, fontWeight.normal, tracking.small, function (props) {
  return props.theme.colors.text;
}, timing.fast, function (props) {
  return props.theme.colors.text;
}, function (props) {
  return props.theme.colors.text;
});

function _templateObject2$b() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$j() {
  var data = _taggedTemplateLiteral(["\n  display: inherit;\n  line-height: 1;\n  min-height: ", ";\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}
var StyledWrapper$1 = styled.div(_templateObject$j(), function (props) {
  return props.minHeight ? props.minHeight : '40vh';
});
var AnimatedLoader = styled(reactSpring.animated.div)(_templateObject2$b());
var Loading = /*#__PURE__*/function (_Component) {
  _inherits(Loading, _Component);

  var _super = _createSuper(Loading);

  function Loading() {
    var _this;

    _classCallCheck(this, Loading);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isVisible: true
    });

    return _this;
  }

  _createClass(Loading, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setInterval(function () {
        _this2.setState({
          isVisible: !_this2.state.isVisible
        });
      }, 700);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.countdown);
    }
  }, {
    key: "render",
    value: function render() {
      var isVisible = this.state.isVisible;
      return /*#__PURE__*/React__default.createElement(LoaderX, _extends({
        isVisible: isVisible
      }, this.props));
    }
  }]);

  return Loading;
}(React.Component);

var LoaderX = function LoaderX(props) {
  var title = props.title,
      minHeight = props.minHeight;
  var springProps = reactSpring.useSpring({
    opacity: props.isVisible ? 1 : 0.2,
    from: {
      opacity: props.isVisible ? 0.2 : 1
    }
  });
  return /*#__PURE__*/React__default.createElement(StyledWrapper$1, {
    minheight: minHeight
  }, /*#__PURE__*/React__default.createElement(AnimatedLoader, {
    style: springProps
  }, /*#__PURE__*/React__default.createElement(Element$1, {
    size: "body"
  }, title)));
};

Loading.defaultProps = {
  title: 'Loading',
  color: colors.brandSecondary,
  minHeight: '70vh'
};
Loading.propTypes = {
  title: propTypes.string,
  minHeight: propTypes.string,
  loading: propTypes.bool
};

function _templateObject3$7() {
  var data = _taggedTemplateLiteral(["\n  margin-right: ", ";\n  margin-left: ", ";\n  color: ", ";\n  margin-top: ", ";\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  font-size: 12px;\n  background: none;\n  padding: 0px 0px 2px 0px;\n  cursor: pointer;\n  flex-shrink: 0;\n  font-family: ", ";\n  font-weight: ", ";\n  transition: all ", ";\n  display: ", ";\n  letter-spacing: ", ";\n  margin: ", ";\n  justify-content: ", ";\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$k() {
  var data = _taggedTemplateLiteral(["\n    color: ", " !important;\n    border: none;\n    border-bottom: 1px solid transparent;\n    text-transform: ", ";\n    :focus,\n    :hover {\n      border-color: ", ";\n      outline: 0;\n      text-decoration: none;\n      color: ", ";\n    }\n  "]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}

var css$4 = require('styled-components').css;

var display$4 = function display(props) {
  return css$4(_templateObject$k(), function (props) {
    return props.theme.colors.text;
  }, function (props) {
    return props.uppercase ? 'uppercase' : 'none';
  }, function (props) {
    return props.hasHover ? props.theme.colors.underlineHover : 'transparent';
  }, function (props) {
    return props.theme.colors.text;
  });
};

var Button$1 = function Button(_ref) {
  var B = _ref.as,
      props = _objectWithoutProperties(_ref, ["as"]);

  return /*#__PURE__*/React__default.createElement(B, props);
};

var StyledButtonIcon = styled(Button$1)(_templateObject2$c(), display$4, baseTheme.fonts.sans, baseTheme.fontWeight.normal, baseTheme.speed["default"], function (props) {
  return props.display ? props.display : 'table';
}, baseTheme.tracking.medium, function (props) {
  return props.margin ? props.margin : '22px 0px';
}, function (props) {
  return props.justifyContent ? props.justifyContent : null;
});
var StyledIcon$3 = styled.i(_templateObject3$7(), function (props) {
  return props.iconBefore ? '0.5rem' : '0';
}, function (props) {
  return props.iconAfter ? '0.5rem' : '0';
}, function (props) {
  return props.iconColor ? props.iconColor : props.theme.colors.text;
}, function (props) {
  return props.display ? '3px' : '0px';
});

var ButtonIcon = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonIcon, _React$Component);

  var _super = _createSuper(ButtonIcon);

  function ButtonIcon() {
    _classCallCheck(this, ButtonIcon);

    return _super.apply(this, arguments);
  }

  _createClass(ButtonIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          uppercase = _this$props.uppercase,
          onClick = _this$props.onClick,
          iconBefore = _this$props.iconBefore,
          iconAfter = _this$props.iconAfter,
          iconColor = _this$props.iconColor,
          as = _this$props.as,
          rest = _objectWithoutProperties(_this$props, ["children", "uppercase", "onClick", "iconBefore", "iconAfter", "iconColor", "as"]);

      return /*#__PURE__*/React__default.createElement(StyledButtonIcon, _extends({
        onClick: onClick,
        uppercase: uppercase,
        as: as,
        iconBefore: iconBefore,
        iconAfter: iconAfter
      }, rest), iconBefore && /*#__PURE__*/React__default.createElement(StyledIcon$3, _extends({
        iconBefore: iconBefore,
        iconColor: iconColor,
        className: "icon icon-".concat(iconBefore)
      }, rest)), children && children, iconAfter && /*#__PURE__*/React__default.createElement(StyledIcon$3, _extends({
        iconAfter: iconAfter,
        iconColor: iconColor,
        className: "icon icon-".concat(iconAfter)
      }, rest)));
    }
  }]);

  return ButtonIcon;
}(React__default.Component);
ButtonIcon.propTypes = {
  children: propTypes.node.isRequired,
  uppercase: propTypes.bool,
  onClick: propTypes.func,
  iconBefore: propTypes.string,
  iconAfter: propTypes.string,
  iconColor: propTypes.string,
  as: propTypes.oneOfType([propTypes.string, propTypes.func])
};
ButtonIcon.defaultProps = {
  uppercase: true,
  children: null,
  iconBefore: null,
  iconAfter: null,
  iconColor: baseTheme.colors.baseBlack,
  as: 'a',
  onClick: function onClick() {}
};

function _templateObject4$5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 99;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.2);\n  &:hover {\n    background: rgba(0, 0, 0, 0.4);\n  }\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$8() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$d() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  :after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  }\n"]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$l() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  line-height: 0;\n  display: inline-block;\n  overflow: hidden;\n  min-width: 50px;\n  min-height: 50px;\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}
var StyledImageIconOverlay = styled(rebass.Box)(_templateObject$l());
var StyledImage = styled.img(_templateObject2$d());
var StyledIcon$4 = styled.i(_templateObject3$8(), function (props) {
  return props.iconColor ? props.iconColor : props.theme.colors.text;
});
var StyledButtonWrapper = styled(rebass.Flex)(_templateObject4$5());

var ImageIconOverlay = function ImageIconOverlay(_ref) {
  var icon = _ref.icon,
      imgSrc = _ref.imgSrc,
      className = _ref.className,
      iconColor = _ref.iconColor;
  return /*#__PURE__*/React__default.createElement(StyledImageIconOverlay, {
    className: 'StyledImageIconOverlay'
  }, /*#__PURE__*/React__default.createElement(StyledButtonWrapper, null, /*#__PURE__*/React__default.createElement(StyledIcon$4, {
    className: "icon icon-".concat(icon),
    iconColor: iconColor
  })), /*#__PURE__*/React__default.createElement(StyledImage, {
    src: imgSrc,
    pb: "60%",
    className: className
  }));
};

ImageIconOverlay.propTypes = {
  imgSrc: propTypes.string.isRequired,
  icon: propTypes.string.isRequired,
  iconColor: propTypes.string
};
ImageIconOverlay.defaultProps = {
  imgSrc: '',
  icon: '',
  iconColor: '#FFFFFF'
};

var baseStyles$1 = {
  cursor: 'pointer',
  opacity: 1,
  alignItems: 'center',
  borderRadius: 0,
  textTransform: 'uppercase',
  fontSize: baseTheme.fontSizes.tiny,
  fontFamily: baseTheme.fonts.sans,
  flex: '0 0 auto',
  lineHeight: 1,
  minWidth: '180px',
  minHeight: '42px',
  transition: "all ".concat(baseTheme.speed["default"], " ease"),
  letterSpacing: baseTheme.tracking.medium,
  fontWeight: baseTheme.fontWeight.normal
};
var Button$2 = styled(rebass.Button)(function () {
  return _objectSpread2({}, baseStyles$1);
});
var ButtonPrimary = styled(rebass.Button)(function (props) {
  return _objectSpread2(_objectSpread2({}, baseStyles$1), {}, {
    color: props.inverse ? props.theme.colors.buttonLight + '!important' : props.theme.colors.buttonDark + '!important',
    background: props.inverse ? props.theme.colors.buttonDark : props.theme.colors.buttonLight,
    borderColor: props.inverse ? props.theme.colors.buttonDark : props.theme.colors.buttonLight,
    ':hover': {
      opacity: '0.8'
    }
  });
});
var ButtonSecondary = styled(rebass.Button)(function (props) {
  return _objectSpread2(_objectSpread2({}, baseStyles$1), {}, {
    color: props.inverse ? props.theme.colors.buttonDark + '!important' : props.theme.colors.buttonLight + '!important',
    borderColor: props.inverse ? props.theme.colors.buttonDark : props.theme.colors.buttonLight,
    background: baseTheme.colors.transparent,
    ':hover': {
      opacity: '0.8'
    }
  });
});
var buttons = {
  rebass: Button$2,
  primary: ButtonPrimary,
  secondary: ButtonSecondary
};

var getButtonProps = function getButtonProps(props) {
  props.className = 'styledButton';
  return props;
};

var Element$3 = function Element(_ref) {
  var variant = _ref.variant,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["variant", "children"]);

  return /*#__PURE__*/React.createElement(buttons[variant], getButtonProps(props), children);
};

Element$3.defaultProps = {
  variant: 'primary',
  px: [5],
  py: ['14px'],
  border: '1px solid'
};
Element$3.propTypes = {
  variant: propTypes.oneOf(['primary', 'secondary'])
};

var _smallStyles;
var bigStyles = {
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  overlfow: 'auto',
  height: '100%',
  padding: spacing.space0,
  border: 'none',
  borderRadius: spacing.space0,
  backgroundColor: colors.modalBackground
};
var modeStyles = {
  light: {
    backgroundColor: 'rgba(255, 255, 255, 0.6)'
  },
  dark: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)'
  }
};
var smallStyles = (_smallStyles = {
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%'
}, _defineProperty(_smallStyles, "marginRight", '-50%'), _defineProperty(_smallStyles, "transform", 'translate(-50%, -50%)'), _defineProperty(_smallStyles, "width", '90%'), _defineProperty(_smallStyles, "maxWidth", '560px'), _defineProperty(_smallStyles, "overlfow", 'auto'), _defineProperty(_smallStyles, "height", 'auto'), _defineProperty(_smallStyles, "padding", spacing.space0), _defineProperty(_smallStyles, "border", 'none'), _defineProperty(_smallStyles, "borderRadius", spacing.space0), _defineProperty(_smallStyles, "backgroundColor", colors.modalBackground), _smallStyles);

var ContentModal = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentModal, _React$Component);

  var _super = _createSuper(ContentModal);

  function ContentModal() {
    _classCallCheck(this, ContentModal);

    return _super.apply(this, arguments);
  }

  _createClass(ContentModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          hasClose = _this$props.hasClose,
          mode = _this$props.mode,
          size = _this$props.size,
          render = _this$props.render,
          closeModal = _this$props.closeModal;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Modal, {
        isOpen: isOpen,
        onRequestClose: closeModal,
        style: {
          content: size === 'large' ? bigStyles : smallStyles,
          overlay: modeStyles[mode]
        }
      }, /*#__PURE__*/React__default.createElement(rebass.Box, {
        display: "border"
      }, /*#__PURE__*/React__default.createElement(Space, {
        top: true,
        left: true,
        right: true,
        size: spacing.space1
      }, hasClose && /*#__PURE__*/React__default.createElement(rebass.Flex, {
        justifyContent: "flex-end"
      }, /*#__PURE__*/React__default.createElement(ButtonIcon, {
        display: "flex",
        margin: '8px 8px 0 0',
        iconBefore: baseTheme.icons.close,
        iconColor: baseTheme.colors.baseWhite,
        onClick: closeModal
      }, /*#__PURE__*/React__default.createElement(Element$1, {
        size: "collapseBody",
        as: "span",
        color: baseTheme.colors.baseWhite
      }, "Close"))), /*#__PURE__*/React__default.createElement(rebass.Box, {
        mb: [2, 7],
        mt: hasClose ? [2, 3] : [2, 7],
        mx: [2, 7]
      }, render ? render() : null)))));
    }
  }]);

  return ContentModal;
}(React__default.Component);
ContentModal.defaultProps = {
  size: 'large',
  closeModal: function closeModal() {},
  mode: 'dark',
  hasClose: false,
  isOpen: true
};
ContentModal.propTypes = {
  mode: propTypes.oneOf(['light', 'dark']).isRequired,
  size: propTypes.oneOf(['large', 'small']).isRequired,
  closeModal: propTypes.func,
  hasClose: propTypes.bool,
  isOpen: propTypes.bool
};

var STATE_KEY = 'showNotice';
var isClient = typeof window !== 'undefined';

var SingleShowModal = function SingleShowModal(_ref) {
  var props = _extends({}, _ref);

  var storage = isClient ? window && window.sessionStorage && JSON.parse(window.sessionStorage.getItem(STATE_KEY)) : null;

  if (storage === null) {
    storage = true;
  }

  var _useState = React.useState(storage),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  React.useEffect(function () {
    isClient && window.sessionStorage && window.sessionStorage.setItem(STATE_KEY, isOpen);
  }, [isOpen]);
  var title = props.title,
      content = props.content,
      renderCta = props.renderCta,
      hasClose = props.hasClose,
      size = props.size,
      mode = props.mode;
  return /*#__PURE__*/React__default.createElement(ContentModal, {
    size: size,
    mode: mode,
    isOpen: isOpen,
    hasClose: hasClose,
    render: function render() {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, title && /*#__PURE__*/React__default.createElement(Element, {
        pb: [3],
        size: "titleSmall",
        textAlign: "center",
        html: title,
        color: colors.modalText
      }), content && /*#__PURE__*/React__default.createElement(Element$1, {
        pb: [4],
        size: "bodySmall",
        textAlign: "center",
        html: content,
        color: colors.modalText
      }), renderCta && /*#__PURE__*/React__default.createElement(rebass.Flex, {
        className: "SingleShowModal_RenderCta_Flex",
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: ['column', 'row']
      }, renderCta(function () {
        return setIsOpen(false);
      })));
    }
  });
};
SingleShowModal.defaultProps = {
  title: null,
  content: null,
  renderCta: null,
  hasClose: false,
  size: 'small',
  mode: 'light'
};

/** Section Heading */

var SectionHeading = function SectionHeading(props) {
  var title = props.title,
      subtitle = props.subtitle;
  return /*#__PURE__*/React__default.createElement(rebass.Box, {
    pt: [5, 10],
    pb: [3, 8]
  }, subtitle && /*#__PURE__*/React__default.createElement(Element, {
    as: "h5",
    size: "meta",
    textAlign: "center",
    mb: !title ? '0px' : [1, 2]
  }, subtitle), title && /*#__PURE__*/React__default.createElement(Element, {
    size: "headline",
    textAlign: "center",
    mb: [2, 5]
  }, title));
};
SectionHeading.propTypes = {
  /** Section Title */
  title: propTypes.string,

  /** Section Subtitle */
  subtitle: propTypes.string
};
SectionHeading.defaultProps = {
  title: null,
  subtitle: null
};

function _templateObject2$e() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n"]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$m() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}

var css$5 = require('styled-components').css;
/** Section Preview */


var StyledSection = styled(rebass.Box)(_templateObject$m());
var StyledButtons = styled(rebass.Box)(_templateObject2$e());
var SectionPreview = function SectionPreview(props) {
  var title = props.title,
      excerpt = props.excerpt,
      buttons = props.buttons,
      template = props.template,
      renderCta = props.renderCta;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Border, null), /*#__PURE__*/React__default.createElement(StyledSection, {
    my: [5, 15]
  }, /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Row, {
    flexDirection: "column"
  }, /*#__PURE__*/React__default.createElement(Column, {
    width: [1, 8 / 12],
    mx: "auto"
  }, title && /*#__PURE__*/React__default.createElement(Element, {
    as: "h5",
    size: "meta",
    textAlign: "center",
    mb: [1, 2]
  }, title), /*#__PURE__*/React__default.createElement(Element$1, {
    size: "bodyBig",
    textAlign: "center",
    as: "span",
    html: excerpt
  }), renderCta && /*#__PURE__*/React__default.createElement("div", null, renderCta))))));
};
SectionPreview.propTypes = {
  /** Section Title */
  title: propTypes.string,

  /** Section Subtitle */
  subtitle: propTypes.string,

  /** Section Subtitle */
  isHeroButton: propTypes.bool
};
SectionPreview.defaultProps = {
  title: null,
  subtitle: null,
  isHeroButton: false
};

function _templateObject$n() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}
/** CardCta Component for displaying a cardCta with brief info and image of a person or company */

var StyledContent = styled(rebass.Flex)(_templateObject$n());
var CardCta = /*#__PURE__*/function (_React$Component) {
  _inherits(CardCta, _React$Component);

  var _super = _createSuper(CardCta);

  function CardCta() {
    _classCallCheck(this, CardCta);

    return _super.apply(this, arguments);
  }

  _createClass(CardCta, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          content = _this$props.content,
          title = _this$props.title,
          meta = _this$props.meta,
          renderVisual = _this$props.renderVisual,
          renderCta = _this$props.renderCta,
          isAlt = _this$props.isAlt;
      return /*#__PURE__*/React__default.createElement(Row, {
        flexDirection: renderVisual ? ['column', 'row'] : 'column'
      }, !isAlt && renderVisual && /*#__PURE__*/React__default.createElement(Column, {
        width: [1, 6 / 12],
        mx: "auto"
      }, /*#__PURE__*/React__default.createElement(rebass.Box, {
        mb: [3, 0]
      }, renderVisual)), /*#__PURE__*/React__default.createElement(Column, {
        width: [1, 6 / 12],
        mx: "auto",
        px: [2, 7]
      }, /*#__PURE__*/React__default.createElement(StyledContent, {
        alignItems: !renderVisual ? 'center' : 'flex-start'
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: 'block',
          maxWidth: '100%'
        }
      }, meta && /*#__PURE__*/React__default.createElement(Element, {
        pb: [1],
        size: "meta",
        textTransform: "uppercase",
        html: meta,
        textAlign: "".concat(!renderVisual ? 'center' : 'left')
      }), title && /*#__PURE__*/React__default.createElement(Element, {
        mb: [2],
        size: "title",
        html: title,
        textAlign: "".concat(!renderVisual ? 'center' : 'left')
      }), content && /*#__PURE__*/React__default.createElement(Element$1, {
        mb: [4],
        size: "body",
        html: content,
        textAlign: "".concat(!renderVisual ? 'center' : 'left')
      }), renderCta && /*#__PURE__*/React__default.createElement(rebass.Box, {
        pb: [2]
      }, renderCta)))), isAlt && renderVisual && /*#__PURE__*/React__default.createElement(Column, {
        width: [1, 6 / 12],
        mx: "auto"
      }, /*#__PURE__*/React__default.createElement(rebass.Box, {
        mb: [3, 0]
      }, renderVisual)));
    }
  }]);

  return CardCta;
}(React__default.Component);
CardCta.propTypes = {
  /** Meta text to categorise the content - above the Title */
  meta: propTypes.string,

  /** Title of the cardCta */
  title: propTypes.string,

  /** Contents of the CardCta - for Text, display="bodySmall" is recommended */
  children: propTypes.node,

  /** Render Prop to display Visual like videos, gifs and images */
  renderVisual: propTypes.object,

  /** Render Prop to display the Buttons or Links - add .map if more than one CTA is possible */
  renderCta: propTypes.array,

  /**  Swap the image and the content */
  isAlt: propTypes.bool
};
CardCta.defaultProps = {
  children: null,
  meta: null,
  title: null,
  renderVisual: null,
  renderCta: null,
  isAlt: false
};

var constants = {
  printPortfolio: 'Print Portfolio',
  printSelection: 'Print Selection',
  printDetails: 'Print Details',
  print: 'Print',
  viewPortfolio: 'View Portfolio',
  viewSelection: 'View Selection',
  shareSelection: 'Submit Selection',
  addToSelection: 'Add to Selection',
  yourSelection: 'Your Selection',
  emptySelection: 'No artwork selected',
  emptyCart: 'To select a sculpture, click "ENQUIRE" on the relevant sculpture page. Click "SUBMIT SELECTION" for an enquiry of your selection to be emailed to a sales representative',
  info: 'Information',
  infoClose: 'Close Information',
  viewScale: 'View Scale',
  rotatingImage: '360 View',
  galleryView: 'Catalogue Image',
  studioView: 'Studio View',
  video: 'Video',
  remove: 'Remove',
  curatedForYou: 'Curated For You',
  dear: 'Dear',
  code: 'Code',
  exclVAT: 'excl. VAT',
  inclVAT: 'incl. South African VAT',
  height: 'H',
  width: 'W',
  length: 'L',
  inches: 'in',
  centimeters: 'cm',
  enquire: 'Enquire',
  pounds: 'lbs',
  kilograms: 'kgs',
  buy: 'Buy Now',
  watchVideo: 'Watch video',
  galleryHeading: 'Sculpture Gallery',
  terms: {
    title: 'Terms and Conditions',
    content: "This is a private microsite specially curated for you.<br/><br/>\n      The information displayed on this microsite, including prices, is correct and current at the time we send you the link. Please note, however, that it is subject to change over time.<br/>\n      By proceeding, you acknowledge that you have read and understood that the prices quoted and availability, are subject to change over time.<br/><br/>\n      \xA9\uFE0F 2020 All rights reserved. Pardus Fine Art CC<br/>\n      No part of this microsite may be reproduced, or transmitted in any form other than the original context, without the prior written permission of Pardus Fine Art CC.",
    btnAgree: 'Agree & Continue',
    btnViewTsCs: 'View Ts & Cs'
  },
  loading: 'Loading...',
  readMore: 'Read more',
  readLess: 'Read less',
  readEssay: 'Read essay',
  readEssayClose: 'Close essay',
  studioBaseURL: 'https://www.dylanlewis.com/studio',
  gardenBaseURL: 'https://www.dylanlewis.com/garden',
  ogSiteName: 'Dylan Lewis Curated Portfolio',
  ogType: 'website'
};

function _templateObject$o() {
  var data = _taggedTemplateLiteral(["\n  width: '100%';\n  border-bottom: 0.5px solid ", ";\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}
var StyledCard$1 = styled(rebass.Flex)(_templateObject$o(), colors.borderLight);
var CardSelection = /*#__PURE__*/function (_React$Component) {
  _inherits(CardSelection, _React$Component);

  var _super = _createSuper(CardSelection);

  function CardSelection() {
    _classCallCheck(this, CardSelection);

    return _super.apply(this, arguments);
  }

  _createClass(CardSelection, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props$item = this.props.item,
          title = _this$props$item.title,
          subTitle = _this$props$item.subTitle,
          price = _this$props$item.price,
          priceIncl = _this$props$item.priceIncl,
          imgSrc = _this$props$item.imgSrc,
          link = _this$props$item.link;
      var index = this.props.index;
      return /*#__PURE__*/React__default.createElement(StyledCard$1, {
        className: "CardSelection_StyledCard"
      }, /*#__PURE__*/React__default.createElement(Row, {
        flexDirection: ['column', 'row'],
        my: [4, 6],
        alignItems: ['flex-start']
      }, /*#__PURE__*/React__default.createElement(Column, {
        width: [1, 1, 4 / 12, 4 / 12]
      }, /*#__PURE__*/React__default.createElement("img", {
        className: "img-fluid",
        alt: title,
        src: imgSrc
      })), /*#__PURE__*/React__default.createElement(Column, {
        width: [1, 1, 8 / 12]
      }, /*#__PURE__*/React__default.createElement(Row, null, /*#__PURE__*/React__default.createElement(rebass.Flex, {
        mx: [2],
        width: [1],
        justifyContent: ['center', 'flex-start', 'space-between'],
        flexDirection: ['column', 'column', 'row', 'row']
      }, /*#__PURE__*/React__default.createElement(rebass.Box, {
        className: "FlexBox"
      }, title && /*#__PURE__*/React__default.createElement(StyledLink$1, {
        to: (link === null || link === void 0 ? void 0 : link.to) && link.to,
        as: (link === null || link === void 0 ? void 0 : link.as) && link.as
      }, /*#__PURE__*/React__default.createElement(Element, {
        flex: ['0 1 auto'],
        size: "titleSmall",
        html: title
      })), subTitle && /*#__PURE__*/React__default.createElement(Element, {
        as: "h5",
        size: "description",
        my: [0, 1]
      }, subTitle)), priceIncl && /*#__PURE__*/React__default.createElement(rebass.Box, null, /*#__PURE__*/React__default.createElement(Element$1, {
        size: "collapseBody",
        textAlign: ['left', 'left', 'right'],
        flex: ['1 0 auto'],
        mb: [2, 0],
        mr: [2]
      }, "".concat(formatCurrency(priceIncl, 'ZAR'), " ").concat(constants.inclVAT))))), this.props.onRemoveItem ? /*#__PURE__*/React__default.createElement(Row, null, /*#__PURE__*/React__default.createElement(rebass.Box, {
        mx: [2],
        mt: [1, 3],
        mb: [3]
      }, /*#__PURE__*/React__default.createElement(ButtonIcon, {
        iconBefore: baseTheme.icons.close,
        onClick: function onClick() {
          return _this.props.onRemoveItem(index);
        }
      }, constants.remove))) : null, this.props.children)));
    }
  }]);

  return CardSelection;
}(React__default.Component);
CardSelection.propTypes = {};
CardSelection.defaultProps = {
  items: [],
  index: 0
};

function _templateObject3$9() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$f() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n"]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$p() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}
/** CardPoster Component for displaying a cardPoster with brief info and image of a person or company */

var StyledCardPoster = styled(rebass.Flex)(_templateObject$p());
var StyledContent$1 = styled(rebass.Box)(_templateObject2$f());
var StyledVisual = styled(rebass.Flex)(_templateObject3$9());
var CardPoster = function CardPoster(props) {
  var children = props.children,
      title = props.title,
      subtitle = props.subtitle,
      visual = props.visual,
      renderCta = props.renderCta;
  return /*#__PURE__*/React__default.createElement(Container, {
    my: [5, 8]
  }, /*#__PURE__*/React__default.createElement(StyledCardPoster, null, visual && /*#__PURE__*/React__default.createElement(StyledVisual, null, /*#__PURE__*/React__default.createElement(LazyLoad, {
    debounce: false,
    offsetVertical: 500
  }, /*#__PURE__*/React__default.createElement(rebass.Image, {
    width: [1, 6 / 12],
    src: visual,
    mx: "auto",
    alt: title
  }))), /*#__PURE__*/React__default.createElement(StyledContent$1, {
    width: [1, 9 / 12]
  }, title && /*#__PURE__*/React__default.createElement(Element, {
    mb: [1, 4],
    size: "hero",
    textAlign: "center",
    html: title
  }), subtitle && /*#__PURE__*/React__default.createElement(Element, {
    mb: [1, 4],
    size: "title",
    textAlign: "center",
    html: subtitle
  }), children && {
    children: children
  }, renderCta && /*#__PURE__*/React__default.createElement(rebass.Flex, {
    justifyContent: 'center',
    textAlign: 'center',
    pb: [1, 2]
  }, renderCta))));
};
CardPoster.propTypes = {
  /** Description text to add more details - below the Title */
  description: propTypes.string,

  /** Title of the cardPoster */
  title: propTypes.string,

  /** Contents of the CardPoster - for Text, display="bodySmall" is recommended */
  children: propTypes.node,

  /** Visual is the URL of the image to display */
  visual: propTypes.string
};
CardPoster.defaultProps = {
  children: null,
  description: null,
  title: null,
  visual: null
};

function _templateObject4$6() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  transition: border-bottom ", ";\n  border-bottom: 1px solid transparent;\n  :hover {\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$a() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$g() {
  var data = _taggedTemplateLiteral(["\n  margin-right: ", ";\n  margin-bottom: ", ";\n  text-align: right;\n  flex: 0 0 auto;\n  @media (min-width: 768px) {\n    width: 180px;\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$q() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-direction: column;\n  @media (min-width: 768px) {\n    flex-direction: row;\n  }\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}

var css$6 = require('styled-components').css;
/** CardSmall Component for displaying a cardSmall with brief info and image of a person or company */


var StyledCardSmall = styled.div(_templateObject$q());
var StyledVisual$1 = styled.div(_templateObject2$g(), spacing.space4, spacing.space2, spacing.space0);
var StyledContent$2 = styled.div(_templateObject3$a());
var StyledTitle$2 = styled(Element)(_templateObject4$6(), timing.slow, colors.borderWhite);

var CardSmall = function CardSmall(props) {
  var children = props.children,
      title = props.title,
      description = props.description,
      renderVisual = props.renderVisual;
  return /*#__PURE__*/React__default.createElement(StyledCardSmall, null, renderVisual && /*#__PURE__*/React__default.createElement(StyledVisual$1, null, renderVisual), /*#__PURE__*/React__default.createElement(StyledContent$2, null, title && /*#__PURE__*/React__default.createElement(StyledTitle$2, {
    size: "title",
    html: title
  }), description && /*#__PURE__*/React__default.createElement(rebass.Box, null, /*#__PURE__*/React__default.createElement(Element$1, {
    size: "bodySmall",
    html: description
  })), children && /*#__PURE__*/React__default.createElement(rebass.Box, {
    mt: [2]
  }, children)));
};

CardSmall.propTypes = {
  /** Description text to add more details - below the Title */
  description: propTypes.string,

  /** Title of the cardSmall */
  title: propTypes.string,

  /** Contents of the CardSmall - Optional on CardSmall being used in Auctions and Exhipitions */
  children: propTypes.node,

  /** Render Prop to display Visual like videos, gifs and images. For CardSmall, the width of the visual should be set to 180px to achieve the dynamic layout */
  renderVisual: propTypes.object
};
CardSmall.defaultProps = {
  children: null,
  meta: null,
  description: null,
  title: null,
  renderVisual: null
};

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  background-color: ", ";\n  font-family: ", ";\n  color: ", ";\n  ul {\n    padding: 0;\n    margin: 0;\n    margin-left: ", ";\n    list-style: none;\n    li {\n      margin-bottom: ", ";\n      line-height: 1.2em;\n      &::before {\n        content: '\u2022';\n        color: ", ";\n        display: inline-block;\n        width: 1em;\n        margin-left: -", ";\n        padding-right: ", ";\n      }\n    }\n  }\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-size: 20px;\n  margin-right: ", ";\n  @media (min-width: 768px) {\n    margin-right: ", ";\n  }\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$b() {
  var data = _taggedTemplateLiteral(["\n      float: right;\n      clear: right;\n      margin-top: ", ";\n      padding-left: ", ";\n      padding-right: ", ";\n      @media (min-width: 768px) {\n        margin-top: ", ";\n        padding-left: ", ";\n      }\n      .dot {\n        left: -30px;\n        @media (min-width: 768px) {\n          left: -7px;\n        }\n      }\n    "]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$h() {
  var data = _taggedTemplateLiteral(["\n      clear: left;\n      float: left;\n      padding-right: ", ";\n      .dot {\n        left: -30px;\n        @media (min-width: 768px) {\n          left: unset;\n          right: -7px;\n        }\n      }\n    "]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$r() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  width: 100%;\n  margin-bottom: ", ";\n  ", "\n  ", "\n  @media (min-width: 768px) {\n    flex-direction: row;\n    width: 100%;\n    padding-right: ", ";\n    margin-bottom: ", ";\n  }\n  &:before {\n    content: ' ';\n    display: table;\n  }\n  &:after {\n    content: ' ';\n    display: table;\n    clear: both;\n  }\n  .dot {\n    border: 2px solid;\n    border-color: #fff;\n    background-color: #fff;\n    border-radius: 50%;\n    width: 14px;\n    height: 14px;\n    line-height: 50px;\n    text-align: center;\n    position: absolute;\n    top: 14px;\n    z-index: '100';\n  }\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}

var css$7 = require('styled-components').css;

var AnimatedMoment = styled(reactSpring.animated.li)(_templateObject$r(), spacing.space2, function (props) {
  return props.alignprop === 'left' && css$7(_templateObject2$h(), spacing.space0);
}, function (props) {
  return props.alignprop === 'right' && css$7(_templateObject3$b(), spacing.space0, spacing.space0, spacing.space0, spacing.space5, spacing.space8);
}, spacing.space8, spacing.space5);
var StyledDate = styled.p(_templateObject4$7(), fonts.sans, colors.textWhite, fontWeight.medium, spacing.space0, spacing.space4);
var StyledContent$3 = styled.div(_templateObject5$1(), spacing.space2, colors.bgLightO, fonts.sans, colors.textWhite, spacing.space2, spacing.space2, colors.textBody, spacing.space2, spacing.space2);
var Moment = function Moment(props) {
  var html = props.html,
      title = props.title,
      date = props.date,
      renderVisual = props.renderVisual,
      inView = props.inView,
      alignprop = props.alignprop;
  var springProps = reactSpring.useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : 'translateY(80px)',
    from: {
      opacity: 0,
      transform: 'translateY(80px)'
    }
  });
  return /*#__PURE__*/React__default.createElement(AnimatedMoment, {
    style: springProps,
    alignprop: alignprop
  }, /*#__PURE__*/React__default.createElement(StyledDate, null, date), /*#__PURE__*/React__default.createElement("span", {
    className: "dot"
  }), /*#__PURE__*/React__default.createElement("div", null, renderVisual && /*#__PURE__*/React__default.createElement(rebass.Box, {
    mb: [1, 3]
  }, renderVisual), title && /*#__PURE__*/React__default.createElement(Element$1, {
    mb: [0, 2],
    size: "body",
    html: title
  }), html && /*#__PURE__*/React__default.createElement(StyledContent$3, {
    dangerouslySetInnerHTML: {
      __html: html
    }
  })));
};
Moment.propTypes = {
  /** Meta text to categorise the content - above the Title */
  meta: propTypes.string,

  /** Description text to add more details - below the Title */
  description: propTypes.string,

  /** Title of the Moment */
  title: propTypes.string,

  /** Contents of the Moment - for Text, display="bodySmall" is recommended */
  children: propTypes.node,

  /** Render Prop to display Visual like videos, gifs and images */
  renderVisual: propTypes.object
};
Moment.defaultProps = {
  children: null,
  meta: null,
  description: null,
  title: null,
  renderVisual: null,
  inView: false
};

function _templateObject2$i() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  list-style: none;\n  position: relative;\n  margin: 0px;\n  padding: 0px;\n  padding-top: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n  @media (min-width: 768px) {\n    padding-top: ", ";\n    margin-right: ", ";\n    margin-left: ", ";\n    margin-top: ", ";\n  }\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -", ";\n    height: 100%;\n    bottom: 0;\n    width: 1px;\n    margin-left: -0.5px;\n    background: ", ";\n    @media (min-width: 768px) {\n      left: 50%;\n    }\n  }\n  &::after {\n    content: ' ';\n    display: table;\n    clear: both;\n  }\n"]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$s() {
  var data = _taggedTemplateLiteral(["\n  width: 50%;\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}
var StyledMomentWrapper = styled.div(_templateObject$s());
var StyledTimeline = styled.div(_templateObject2$i(), spacing.space3, spacing.space3, spacing.space2, spacing.space5, spacing.space0, spacing.space0, spacing.space5, spacing.space3, colors.borderBase);
var Timeline = function Timeline(props) {
  var moments = props.moments,
      headline = props.headline;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, headline && /*#__PURE__*/React__default.createElement(Element, {
    mt: [5],
    size: "title",
    textAlign: ['left', 'center']
  }, headline), /*#__PURE__*/React__default.createElement(StyledTimeline, null, moments.map(function (m, index) {
    return /*#__PURE__*/React__default.createElement(StyledMomentWrapper, {
      key: index
    }, /*#__PURE__*/React__default.createElement(InViewMonitor, {
      childPropsInView: {
        inView: true
      }
    }, /*#__PURE__*/React__default.createElement(Moment, {
      renderVisual: m.visual ? getCardVisual(m.visual) : null,
      title: m.title,
      date: m.year,
      html: m.content,
      alignprop: index % 2 ? 'right' : 'left'
    })));
  })));
};
Timeline.propTypes = {
  /** Items to be listed as moments in the Timeline */
  moments: propTypes.node.isRequired,

  /** Headline of the Timeline */
  headline: propTypes.node.isRequired
};
Timeline.defaultProps = {
  moments: null,
  inView: true,
  headline: 'Biography'
};

/** Banner */

var Banner = function Banner(props) {
  var hasBorderTop = props.hasBorderTop,
      hasBorderBottom = props.hasBorderBottom,
      title = props.title,
      subTitle = props.subTitle,
      description = props.description,
      renderCta = props.renderCta,
      image = props.image,
      isAlt = props.isAlt;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Border, {
    border: hasBorderTop
  }), /*#__PURE__*/React__default.createElement(rebass.Box, {
    pt: [3, 10],
    pb: [3, 10]
  }, /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(CardCta, {
    renderVisual: image ? /*#__PURE__*/React__default.createElement(ImageBox, {
      alt: title,
      src: image
    }) : null,
    title: title,
    meta: subTitle,
    content: description,
    renderCta: renderCta,
    isAlt: isAlt
  }))), /*#__PURE__*/React__default.createElement(Border, {
    border: hasBorderBottom
  }));
};
Banner.propTypes = {
  hasVisual: propTypes.bool,
  hasBorderTop: propTypes.bool,
  hasBorderBottom: propTypes.bool,
  isAlt: propTypes.bool
};
Banner.defaultProps = {
  hasBorderTop: true,
  hasBorderBottom: true,
  title: null,
  subTitle: null,
  description: null,
  image: null,
  isAlt: false
};

var SliderCards = /*#__PURE__*/function (_React$Component) {
  _inherits(SliderCards, _React$Component);

  var _super = _createSuper(SliderCards);

  function SliderCards(props) {
    var _this;

    _classCallCheck(this, SliderCards);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.calculateHeight();
    });

    _this.state = {
      height: null
    };
    return _this;
  }

  _createClass(SliderCards, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.calculateHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "calculateHeight",
    //Temporary fix to solve height issue on initial load.
    value: function calculateHeight() {
      var imgHeight = this.element.clientHeight;

      if (imgHeight === 0) {
        this.setState({
          height: '100%'
        });
      } else {
        if (imgHeight > this.state.height) {
          this.setState({
            height: imgHeight
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          items = _this$props.items,
          parent = _this$props.parent;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Space, {
        padding: true,
        top: true,
        size: spacing.space4
      }, /*#__PURE__*/React__default.createElement(Space, {
        padding: true,
        bottom: true,
        size: spacing.space15
      }, /*#__PURE__*/React__default.createElement(SliderWrapper, {
        slidesToShow: 4,
        pagerType: 'arrow',
        fade: false,
        adaptiveHeight: false
      }, items.map(function (data, index) {
        var heroDetails = getHeroDetails(data);
        return /*#__PURE__*/React__default.createElement(Space, {
          key: index,
          padding: true,
          left: true,
          right: true,
          size: spacing.space4
        }, /*#__PURE__*/React__default.createElement(StyledLink$1, {
          to: "/".concat(parent, "/").concat(data.type, "/").concat(data.slug),
          title: data.title
        }, /*#__PURE__*/React__default.createElement(Card, {
          subtitle: heroDetails.subtitle,
          content: heroDetails.content,
          title: heroDetails.title,
          renderVisual: /*#__PURE__*/React__default.createElement("div", {
            style: {
              height: _this2.state.height
            },
            className: "divSliderCard d-flex align-items-end flex-column justify-content-end"
          }, /*#__PURE__*/React__default.createElement("img", {
            alt: "" //ref={element => this.refCallback(element)}
            ,
            ref: function ref(element) {
              return _this2.element = element;
            },
            key: index,
            className: "img-fluid",
            src: data.featured_media ? data.featured_media.source_url : null
          }))
        })));
      })))));
    }
  }]);

  return SliderCards;
}(React__default.Component);

function _templateObject3$c() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: ", ";\n  left: 0;\n  right: 0;\n  text-align: center;\n  i {\n    color: ", ";\n  }\n"]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$j() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  max-height: ", ";\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  img {\n    object-fit: center;\n  }\n"]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$t() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}

var css$8 = require('styled-components').css;
/** Hero Component for displaying an introduction to the Page */


var StyledHero = styled(rebass.Box)(_templateObject$t());
var StyledVisual$2 = styled(rebass.Box)(_templateObject2$j(), function (props) {
  return props.noCrop ? '100%' : '70vh';
});
var StyledPrompt = styled.div(_templateObject3$c(), spacing.space3, function (props) {
  return props.theme.colors.heroText;
});
var Hero = function Hero(props) {
  var title = props.title,
      subtitle = props.subtitle,
      description = props.description,
      billboard = props.billboard,
      renderVisual = props.renderVisual,
      renderCta = props.renderCta,
      children = props.children,
      noCrop = props.noCrop;
  return /*#__PURE__*/React__default.createElement(StyledHero, {
    className: "Hero_Styled",
    pb: [5, 10]
  }, /*#__PURE__*/React__default.createElement(Row, {
    className: "Hero_Row",
    flexDirection: "column",
    alignItems: "center",
    mx: '0px'
  }, /*#__PURE__*/React__default.createElement(Column, {
    className: "Hero_Column",
    width: [1, 8 / 12]
  }, subtitle && /*#__PURE__*/React__default.createElement(Element, {
    mb: [1, 2],
    as: "h5",
    size: "meta",
    fontFamily: "sans",
    textAlign: "center",
    textTransform: "uppercase",
    html: subtitle
  }), title && /*#__PURE__*/React__default.createElement(Element, {
    as: "h1",
    size: "title",
    textAlign: "center",
    html: title
  }), description && /*#__PURE__*/React__default.createElement(Element, {
    as: "h5",
    size: "description",
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: "3px",
    mt: [2, 5],
    html: description
  })), renderVisual && /*#__PURE__*/React__default.createElement(Column, {
    className: "Hero_Visual",
    px: '0px',
    width: 1
  }, /*#__PURE__*/React__default.createElement(StyledVisual$2, {
    mt: [5],
    mb: [0],
    billboard: billboard ? 1 : 0,
    noCrop: noCrop
  }, renderVisual, !noCrop && /*#__PURE__*/React__default.createElement(StyledPrompt, null, /*#__PURE__*/React__default.createElement("i", {
    className: "icon icon-arrow-down"
  })))), children && /*#__PURE__*/React__default.createElement(Column, {
    className: "Hero_ChildrenColumn",
    width: [1, 8 / 12],
    mt: [2, 4]
  }, children), renderCta && /*#__PURE__*/React__default.createElement(rebass.Flex, {
    className: "Hero_RenderCta",
    mt: [2, 4],
    justifyContent: "center",
    alignItems: "center",
    flexDirection: ['column', 'row']
  }, renderCta)));
};
Hero.propTypes = {
  /** subtitle text to categorise the content - above the Title */
  subtitle: propTypes.string,

  /** Title of the Hero */
  title: propTypes.string,

  /** Description to appear below the title */
  description: propTypes.string,

  /** Render Prop to display Visual like videos, gifs and images */
  renderVisual: propTypes.object,

  /**Is this Hero a Billboard with large title and image offset? */
  billboard: propTypes.bool,

  /**Hero Children */
  children: propTypes.object,

  /** Should the image/video be cropped */
  noCrop: propTypes.bool
};
Hero.defaultProps = {
  subtitle: null,
  title: null,
  description: null,
  renderVisual: null,
  billboard: false,
  children: null,
  noCrop: false
};

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n  z-index: 9;\n  flex-direction: column;\n  justify-content: center;\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$8() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: ", ";\n  left: 0;\n  right: 0;\n  text-align: center;\n  i {\n    color: ", ";\n  }\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$d() {
  var data = _taggedTemplateLiteral(["\n  height: 80vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  width: 100%;\n"]);

  _templateObject3$d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$k() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n"]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$u() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  max-width: 100%;\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}

var css$9 = require('styled-components').css;
/** HeroLanding Component for displaying a HeroLanding with brief info and image of a person or company */


var StyledContainer = styled(Container)(_templateObject$u());
var StyledHeroLanding = styled.div(_templateObject2$k());
var StyledVisual$3 = styled(rebass.Card)(_templateObject3$d());
var StyledPrompt$1 = styled.div(_templateObject4$8(), spacing.space3, function (props) {
  return props.theme.colors.heroText;
});
var StyledContent$4 = styled(rebass.Flex)(_templateObject5$2());
var HeroLanding = function HeroLanding(props) {
  var children = props.children,
      title = props.title,
      visual = props.visual,
      renderCta = props.renderCta,
      subtitle = props.subtitle,
      template = props.template,
      description = props.description;
  return /*#__PURE__*/React__default.createElement(StyledContainer, {
    mb: template === 'studio' ? [10] : '0px',
    px: ['0px', 6, 6, 6, 15]
  }, /*#__PURE__*/React__default.createElement(Row, {
    flexDirection: "column"
  }, /*#__PURE__*/React__default.createElement(Column, {
    width: [1]
  }, /*#__PURE__*/React__default.createElement(StyledHeroLanding, null, visual && /*#__PURE__*/React__default.createElement(StyledVisual$3, {
    backgroundImage: "url(".concat(visual, ")"),
    backgroundSize: "cover",
    backgroundPosition: "center center"
  }, /*#__PURE__*/React__default.createElement(StyledContent$4, {
    p: [3, 5, 9]
  }, subtitle && /*#__PURE__*/React__default.createElement(Element$1, {
    size: "meta",
    html: subtitle
  }), title && /*#__PURE__*/React__default.createElement(Element, {
    mb: [1, 3],
    size: "hero",
    width: template === 'garden' ? [1, 1, 60 / 120] : [1, 1, 53 / 120],
    html: title,
    color: 'heroText'
  }), description && /*#__PURE__*/React__default.createElement(Element$1, {
    mb: [1, 3],
    size: "meta",
    html: description
  }), children && {
    children: children
  }, renderCta && /*#__PURE__*/React__default.createElement(rebass.Flex, {
    flexDirection: ['column', 'column', 'row'],
    mb: [2]
  }, renderCta))), /*#__PURE__*/React__default.createElement(StyledPrompt$1, null, /*#__PURE__*/React__default.createElement("i", {
    className: "icon icon-arrow-down"
  }))))));
};
HeroLanding.propTypes = {
  /** Meta text to categorise the content - above the Title */
  meta: propTypes.string,

  /** Description text to add more details - below the Title */
  description: propTypes.string,

  /** Title of the HeroLanding */
  title: propTypes.string,

  /** Content of the HeroLanding */
  content: propTypes.string,

  /** Contents of the HeroLanding - for Text, display="bodySmall" is recommended */
  children: propTypes.node,

  /** Render Prop to display Visual like videos, gifs and images */
  visual: propTypes.string,

  /** Template allows for differentiation between landing pages */
  template: propTypes.string
};
HeroLanding.defaultProps = {
  children: null,
  meta: null,
  description: null,
  title: null,
  visual: null,
  template: null
};

function _templateObject2$l() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  margin-top: ", ";\n  padding: 0;\n  list-style: none;\n  align-items: flex-start;\n  li {\n    margin: 0;\n    padding: 0;\n    margin-bottom: ", ";\n    display: inline-block;\n    & > * {\n      transition: all ", ";\n      &:hover,\n      &:active,\n      &:focus {\n        cursor: pointer;\n        outline: none;\n      }\n    }\n  }\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$v() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}
/** HeroMenu Component for displaying an introduction to the Page */

var StyledHeroMenu = styled(rebass.Box)(_templateObject$v());
var StyledMenu = styled.ul(_templateObject2$l(), spacing.space3, spacing.space1, timing.fast);
var HeroMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(HeroMenu, _React$Component);

  var _super = _createSuper(HeroMenu);

  function HeroMenu() {
    _classCallCheck(this, HeroMenu);

    return _super.apply(this, arguments);
  }

  _createClass(HeroMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          renderMenu = _this$props.renderMenu;
      return /*#__PURE__*/React__default.createElement(StyledHeroMenu, {
        pt: [5, 12],
        pb: [5, 10],
        px: [0, 0, 13]
      }, /*#__PURE__*/React__default.createElement(Row, null, /*#__PURE__*/React__default.createElement(Column, {
        width: [1, 1, 45 / 120]
      }, /*#__PURE__*/React__default.createElement(Element, {
        size: 'headline',
        html: title
      })), renderMenu && /*#__PURE__*/React__default.createElement(Column, {
        width: [1, 1, 8 / 12]
      }, renderMenu && /*#__PURE__*/React__default.createElement(StyledMenu, null, renderMenu))));
    }
  }]);

  return HeroMenu;
}(React__default.Component);
HeroMenu.propTypes = {
  /** Meta text to categorise the content - above the Title */
  meta: propTypes.string,

  /** Description text to add more details - below the Title */
  description: propTypes.string,

  /** Title of the HeroMenu */
  title: propTypes.string,

  /** Render Prop to display Visual like videos, gifs and images */
  renderMenu: propTypes.array,

  /**Is this HeroMenu a Billboard with large title and image offset? */
  billboard: propTypes.bool
};
HeroMenu.defaultProps = {
  meta: null,
  description: null,
  title: null,
  renderVisual: null,
  billboard: false
};

function _templateObject2$m() {
  var data = _taggedTemplateLiteral(["\n  background: red;\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$w() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}
var AnimatedCard = styled(reactSpring.animated(rebass.Box))(_templateObject$w());
var StyledInViewMonitor = styled(InViewMonitor)(_templateObject2$m());

var CardBlock = function CardBlock(props) {
  var inView = props.inView,
      content = props.content,
      parent = props.parent,
      linkAs = props.linkAs;
  var springProps = globalSpringProps(inView);
  return /*#__PURE__*/React__default.createElement(AnimatedCard, {
    style: springProps
  }, /*#__PURE__*/React__default.createElement(rebass.Box, {
    mb: [3, 5]
  }, getCardLink(content, parent, linkAs)));
};

var GridHomeGarden = function GridHomeGarden(props) {
  var items = props.items,
      parent = props.parent,
      linkAs = props.linkAs;
  var gridItems = {
    one: {
      content: items[0] || null,
      width: [1, 5 / 12] || null
    },
    two: {
      content: items[1] || null,
      width: [1, 6 / 12] || null
    },
    three: {
      content: items[2] || null,
      width: [1, 7 / 12] || null
    },
    four: {
      content: items[3] || null,
      width: [1, 9 / 12] || null
    },
    five: {
      content: items[4] || null
    },
    six: {
      content: items[5] || null,
      width: [1, 12 / 12] || null
    },
    seven: {
      content: items[6] || null,
      width: [1, 8 / 12] || null
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "flex-end",
    justifyContent: "space-between",
    my: '0px'
  }, gridItems.one.content && /*#__PURE__*/React__default.createElement(Column, {
    key: 1,
    width: gridItems.one.width,
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: gridItems.one.content,
    parent: parent,
    linkAs: linkAs
  }))), gridItems.two.content && /*#__PURE__*/React__default.createElement(Column, {
    key: 2,
    width: gridItems.two.width,
    flex: "0 0 auto",
    mb: [0, 6]
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: gridItems.two.content,
    parent: parent,
    linkAs: linkAs
  })))), gridItems.three.content && /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "center",
    justifyContent: "space-around",
    my: '0px',
    pr: [0, 9]
  }, /*#__PURE__*/React__default.createElement(Column, {
    key: 3,
    width: gridItems.three.width,
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: gridItems.three.content,
    parent: parent,
    linkAs: linkAs
  })))), /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "flex-start",
    justifyContent: "space-between",
    my: '0px'
  }, /*#__PURE__*/React__default.createElement(Column, {
    key: 4,
    width: [1, 6 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "flex-start",
    flexDirection: "column"
  }, gridItems.four.content && /*#__PURE__*/React__default.createElement(Column, {
    key: 4,
    width: gridItems.four.width,
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: gridItems.four.content,
    parent: parent,
    linkAs: linkAs
  }))), gridItems.five.content && /*#__PURE__*/React__default.createElement(Column, {
    key: 5,
    width: gridItems.five.width,
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: gridItems.five.content,
    parent: parent,
    linkAs: linkAs
  }))))), /*#__PURE__*/React__default.createElement(Column, {
    key: 6,
    width: [1, 5 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "flex-start",
    flexDirection: "column"
  }, gridItems.six.content && /*#__PURE__*/React__default.createElement(Column, {
    key: 4,
    width: gridItems.six.width,
    flex: "0 0 auto",
    mt: [2, 8]
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: gridItems.six.content,
    parent: parent,
    linkAs: linkAs
  }))), gridItems.seven.content && /*#__PURE__*/React__default.createElement(Column, {
    key: 7,
    width: gridItems.seven.width,
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: gridItems.seven.content,
    parent: parent,
    linkAs: linkAs
  })))))));
};
GridHomeGarden.defaultProps = {
  inView: false
};

function _templateObject2$n() {
  var data = _taggedTemplateLiteral(["\n  background: red;\n"]);

  _templateObject2$n = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$x() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}
var AnimatedCard$1 = styled(reactSpring.animated(rebass.Box))(_templateObject$x());
var StyledInViewMonitor$1 = styled(InViewMonitor)(_templateObject2$n());

var CardBlock$1 = function CardBlock(props) {
  var inView = props.inView,
      content = props.content,
      parent = props.parent,
      linkAs = props.linkAs;
  var springProps = globalSpringProps(inView);
  return /*#__PURE__*/React__default.createElement(AnimatedCard$1, {
    style: springProps
  }, /*#__PURE__*/React__default.createElement(rebass.Box, {
    mb: [3, 5]
  }, getCardLink(content, parent, linkAs)));
};

var GridHomeStudio = function GridHomeStudio(props) {
  var items = props.items,
      parent = props.parent,
      linkAs = props.linkAs;
  var gridItems = {
    one: {
      content: items[0] || null,
      width: [1, 12 / 12] || null
    },
    two: {
      content: items[1] || null,
      width: [1, 4 / 12] || null
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "flex-end",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React__default.createElement(Column, {
    key: 1,
    width: [0, 1 / 12],
    flex: "0 0 auto"
  }), /*#__PURE__*/React__default.createElement(Column, {
    key: 2,
    width: [1, 5 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$1, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$1, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: gridItems.one.content,
    parent: parent,
    linkAs: linkAs
  }))), /*#__PURE__*/React__default.createElement(Column, {
    key: 3,
    width: [1, 5 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$1, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$1, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: gridItems.two.content,
    parent: parent,
    linkAs: linkAs
  })))));
};
GridHomeStudio.defaultProps = {
  inView: false
};

function _templateObject2$o() {
  var data = _taggedTemplateLiteral(["\n  background: red;\n"]);

  _templateObject2$o = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$y() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject$y = function _templateObject() {
    return data;
  };

  return data;
}
var AnimatedCard$2 = styled(reactSpring.animated(rebass.Box))(_templateObject$y());
var StyledInViewMonitor$2 = styled(InViewMonitor)(_templateObject2$o());

var getCardProps = function getCardProps(data) {
  return getHeroDetails(data);
};

var CardBlock$2 = function CardBlock(props) {
  var inView = props.inView,
      data = props.data,
      parent = props.parent,
      linkAs = props.linkAs;
  var springProps = globalSpringProps(inView);

  var visualData = function visualData(data) {
    if (data.featured_media) {
      return getCardVisual(data.featured_media);
    }

    return null;
  };

  var cardProps = getCardProps(data);
  return /*#__PURE__*/React__default.createElement(AnimatedCard$2, {
    style: springProps
  }, /*#__PURE__*/React__default.createElement(StyledLink$1, {
    to: "/".concat(props.parent, "/").concat(data.type, "/").concat(data.slug),
    title: data.title,
    as: linkAs
  }, /*#__PURE__*/React__default.createElement(Card, {
    renderVisual: visualData(data),
    subtitle: cardProps.subtitle,
    title: cardProps.title,
    parent: parent
  })));
};

var GridGrouping = function GridGrouping(props) {
  var items = props.items,
      parent = props.parent,
      linkAs = props.linkAs;
  var gridItems = {
    one: {
      content: items[0] || null,
      width: [1, 5 / 12] || null
    },
    two: {
      content: items[1] || null,
      width: [1, 43 / 120] || null
    },
    three: {
      content: items[2] || null,
      width: [1, 6 / 12] || null
    },
    four: {
      content: items[3] || null,
      width: [1, 12 / 12] || null
    },
    five: {
      content: items[4] || null,
      width: [1, 5 / 6] || null
    },
    six: {
      content: items[5] || null,
      width: [1, 5 / 6] || null
    },
    seven: {
      content: items[6] || null,
      width: [1, 4 / 6] || null
    },
    eight: {
      content: items[7] || null,
      width: [1, 6 / 6] || null
    },
    nine: {
      content: items[8] || null,
      width: [1, 6 / 6] || null
    },
    ten: {
      content: items[9] || null,
      width: [1, 7 / 12] || null
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "flex-end",
    justifyContent: "space-between",
    my: '0px',
    mt: [4, 6]
  }, gridItems.one.content && /*#__PURE__*/React__default.createElement(Column, {
    key: 1,
    width: gridItems.one.width,
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$2, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$2, _extends({
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    data: gridItems.one.content,
    parent: parent,
    linkAs: linkAs
  }, props)))), gridItems.two.content && /*#__PURE__*/React__default.createElement(Column, {
    key: 2,
    width: gridItems.two.width,
    flex: "0 0 auto",
    mb: ['px', 10],
    mr: ['0px', 10],
    px: ['15px', '0px']
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$2, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$2, _extends({
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    data: gridItems.two.content,
    parent: parent,
    linkAs: linkAs
  }, props))))), gridItems.three.content && /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "center",
    justifyContent: "space-around",
    my: '0px'
  }, /*#__PURE__*/React__default.createElement(Column, {
    key: 3,
    width: gridItems.three.width,
    flex: "0 0 auto",
    ml: ['0px', '190px']
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$2, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$2, _extends({
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    data: gridItems.three.content,
    parent: parent,
    linkAs: linkAs
  }, props))))), gridItems.four.content && /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "flex-start",
    justifyContent: "space-between",
    my: '0px',
    flexDirection: ['column', 'row']
  }, /*#__PURE__*/React__default.createElement(Column, {
    width: [1, 6 / 12]
  }, /*#__PURE__*/React__default.createElement(Row, {
    flexDirection: "column",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React__default.createElement(Column, {
    key: 4,
    width: gridItems.four.width,
    flex: "0 0 auto",
    order: "1"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$2, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$2, _extends({
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    data: gridItems.four.content,
    parent: parent,
    linkAs: linkAs
  }, props)))), /*#__PURE__*/React__default.createElement(Column, {
    key: 5,
    width: gridItems.five.width,
    flex: "0 0 auto",
    mt: ['0px', 18],
    order: "3"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$2, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$2, _extends({
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    data: gridItems.five.content,
    parent: parent,
    linkAs: linkAs
  }, props)))), /*#__PURE__*/React__default.createElement(Column, {
    key: 6,
    width: gridItems.six.width,
    flex: "0 0 auto",
    order: "5"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$2, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$2, _extends({
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    data: gridItems.six.content,
    parent: parent,
    linkAs: linkAs
  }, props)))))), /*#__PURE__*/React__default.createElement(Column, {
    width: [1, 6 / 12]
  }, /*#__PURE__*/React__default.createElement(Row, {
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Column, {
    key: 7,
    width: gridItems.seven.width,
    flex: "0 0 auto",
    mt: [0, 17]
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$2, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$2, _extends({
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    data: gridItems.seven.content,
    parent: parent,
    linkAs: linkAs
  }, props)))), /*#__PURE__*/React__default.createElement(Column, {
    key: 8,
    width: gridItems.eight.width,
    flex: "0 0 auto",
    mt: [0, 10]
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$2, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$2, _extends({
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    data: gridItems.eight.content,
    parent: parent,
    linkAs: linkAs
  }, props)))), /*#__PURE__*/React__default.createElement(Column, {
    key: 9,
    width: gridItems.nine.width,
    flex: "0 0 auto",
    mt: [0, 10]
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$2, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$2, _extends({
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    data: gridItems.nine.content,
    parent: parent,
    linkAs: linkAs
  }, props))))))), gridItems.ten.content && /*#__PURE__*/React__default.createElement(Row, {
    my: '0px'
  }, /*#__PURE__*/React__default.createElement(Column, {
    key: 30,
    width: gridItems.ten.width,
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$2, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$2, _extends({
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    data: gridItems.ten.content,
    parent: parent,
    linkAs: linkAs
  }, props))))));
};
GridGrouping.defaultProps = {
  inView: false
};

function _templateObject2$p() {
  var data = _taggedTemplateLiteral(["\n  background: red;\n"]);

  _templateObject2$p = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$z() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject$z = function _templateObject() {
    return data;
  };

  return data;
}
var AnimatedCard$3 = styled(reactSpring.animated(rebass.Box))(_templateObject$z());
var StyledInViewMonitor$3 = styled(InViewMonitor)(_templateObject2$p());

var CardBlock$3 = function CardBlock(props) {
  var inView = props.inView,
      content = props.content,
      parent = props.parent,
      linkAs = props.linkAs;
  var springProps = globalSpringProps(inView);
  return /*#__PURE__*/React__default.createElement(AnimatedCard$3, {
    style: springProps
  }, /*#__PURE__*/React__default.createElement(rebass.Box, {
    mb: [3, 5]
  }, getCardLink(content, parent, linkAs)));
};

var GridExplore = function GridExplore(props) {
  var items = props.items,
      parent = props.parent,
      linkAs = props.linkAs;
  var one = items[0] || null;
  var two = items[1] || null;
  var three = items[2] || null;
  var four = items[3] || null;
  var five = items[4] || null;
  var six = items[5] || null;
  var seven = items[6] || null;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "flex-start",
    justifyContent: "space-between",
    my: '0px'
  }, /*#__PURE__*/React__default.createElement(Column, {
    key: 4,
    width: [1, 6 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "flex-start",
    flexDirection: "column"
  }, one && /*#__PURE__*/React__default.createElement(Column, {
    key: 4,
    width: [1, 9 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$3, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$3, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: one,
    parent: parent,
    linkAs: linkAs
  }))), two && /*#__PURE__*/React__default.createElement(Column, {
    key: 4,
    width: [1, 10 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$3, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$3, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: two,
    parent: parent,
    linkAs: linkAs
  }))))), /*#__PURE__*/React__default.createElement(Column, {
    key: 5,
    width: [1, 6 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "flex-start",
    flexDirection: "column"
  }, three && /*#__PURE__*/React__default.createElement(Column, {
    key: 4,
    width: [1, 12 / 12],
    flex: "0 0 auto",
    mt: [2, 8]
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$3, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$3, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: three,
    parent: parent,
    linkAs: linkAs
  }))), four && /*#__PURE__*/React__default.createElement(Column, {
    key: 4,
    width: [1, 8 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$3, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$3, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: four,
    parent: parent,
    linkAs: linkAs
  })))))), /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "center",
    justifyContent: "space-between",
    my: '0px'
  }, five && /*#__PURE__*/React__default.createElement(Column, {
    key: 1,
    width: [1, 5 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$3, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$3, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: five,
    parent: parent,
    linkAs: linkAs
  }))), six && /*#__PURE__*/React__default.createElement(Column, {
    key: 2,
    width: [1, 6 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$3, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$3, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: six,
    parent: parent,
    linkAs: linkAs
  })))), seven && /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "center",
    justifyContent: "space-around",
    my: '0px'
  }, /*#__PURE__*/React__default.createElement(Column, {
    key: 3,
    width: [1, 7 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$3, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$3, {
    className: "CardBlock",
    style: {
      cursor: 'pointer'
    },
    content: seven,
    parent: parent,
    linkAs: linkAs
  })))));
};
GridExplore.defaultProps = {
  inView: false
};

function _templateObject2$q() {
  var data = _taggedTemplateLiteral(["\n  background: red;\n"]);

  _templateObject2$q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$A() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject$A = function _templateObject() {
    return data;
  };

  return data;
}
var AnimatedCard$4 = styled(reactSpring.animated(rebass.Box))(_templateObject$A());
var StyledInViewMonitor$4 = styled(InViewMonitor)(_templateObject2$q());

var CardBlock$4 = function CardBlock(props) {
  var inView = props.inView,
      content = props.content,
      parent = props.parent,
      linkAs = props.linkAs;
  var springProps = globalSpringProps(inView);
  return /*#__PURE__*/React__default.createElement(AnimatedCard$4, {
    style: springProps
  }, /*#__PURE__*/React__default.createElement(rebass.Box, {
    mb: [3, 5]
  }, getCardLink(content, parent, linkAs)));
};

var GridSculpture = function GridSculpture(props) {
  var items = props.items,
      parent = props.parent,
      linkAs = props.linkAs;
  var one = items[0] || null;
  var two = items[1] || null;
  var three = items[2] || null;
  var four = items[3] || null;
  var five = items[4] || null;
  var six = items[5] || null;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "center",
    justifyContent: "space-between",
    my: '0px'
  }, /*#__PURE__*/React__default.createElement(Column, {
    key: 1,
    width: [1, 7 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "center",
    justifyContent: "space-between",
    my: '0px'
  }, three && /*#__PURE__*/React__default.createElement(Column, {
    key: 2,
    width: [1, 12 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$4, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$4, {
    className: "CardBlock 3 chthonios",
    style: {
      cursor: 'pointer'
    },
    content: three,
    parent: parent,
    linkAs: linkAs
  })))), two && /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "center",
    justifyContent: "flex-end",
    my: '0px'
  }, /*#__PURE__*/React__default.createElement(Column, {
    key: 3,
    width: [1, 10 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$4, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$4, {
    className: "CardBlock 2 Mini",
    style: {
      cursor: 'pointer'
    },
    content: two,
    parent: parent,
    linkAs: linkAs
  })))), five && /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "center",
    justifyContent: "flex-end",
    my: '0px'
  }, /*#__PURE__*/React__default.createElement(Column, {
    key: 3,
    width: [1, 12 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$4, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$4, {
    className: "CardBlock shamanic",
    style: {
      cursor: 'pointer'
    },
    content: five,
    parent: parent,
    linkAs: linkAs
  }))))), one && /*#__PURE__*/React__default.createElement(Column, {
    key: 4,
    width: [1, 4 / 12],
    flex: "0 0 auto"
  }, /*#__PURE__*/React__default.createElement(StyledInViewMonitor$4, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$4, {
    className: "CardBlock Apex",
    style: {
      cursor: 'pointer'
    },
    content: one,
    parent: parent,
    linkAs: linkAs
  })), four && /*#__PURE__*/React__default.createElement(StyledInViewMonitor$4, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$4, {
    className: "CardBlock fragmented",
    style: {
      cursor: 'pointer'
    },
    content: four,
    parent: parent,
    linkAs: linkAs
  })), six && /*#__PURE__*/React__default.createElement(StyledInViewMonitor$4, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(CardBlock$4, {
    className: "CardBlock wild cats",
    style: {
      cursor: 'pointer'
    },
    content: six,
    parent: parent,
    linkAs: linkAs
  })))));
};
GridSculpture.defaultProps = {
  inView: false
};

function _templateObject$B() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  a {\n    text-decoration: none;\n    &:hover {\n      text-decoration: none;\n    }\n  }\n"]);

  _templateObject$B = function _templateObject() {
    return data;
  };

  return data;
}
var AnimatedCard$5 = styled(reactSpring.animated.div)(_templateObject$B());

var getCardProps$1 = function getCardProps(data) {
  if (data.type === 'auctions_exhibitions') {
    return {
      subtitle: data.acf && data.acf.description ? data.acf.description : null,
      title: data.title ? data.title : null,
      description: data.date.length ? data.date[0].name : null
    };
  }

  if (data.type === 'work') {
    return {
      title: data.title ? data.title : null,
      subtitle: getHeroDetails(data).subtitle
    };
  }

  if (data.type === 'product') {
    return {
      title: data.title ? data.title : null,
      subtitle: data.subTitle ? data.subTitle : null
    };
  }

  return getHeroDetails(data);
};

function SetLinkType(_ref) {
  var link = _ref.link,
      children = _ref.children,
      to = _ref.to,
      linkAs = _ref.linkAs,
      props = _objectWithoutProperties(_ref, ["link", "children", "to", "linkAs"]);

  var Component;
  var obj = {};

  switch (link) {
    case 'a':
      Component = 'a';
      obj.href = to;
      break;

    case 'link':
      Component = StyledLink$1;
      obj.as = linkAs;
      obj.to = to;
      break;

    default:
      Component = StyledLink$1;
      obj.as = linkAs;
      obj.to = to;
  }

  return /*#__PURE__*/React__default.createElement(Component, _extends({}, obj, props), children);
}

var CardBlock$5 = function CardBlock(props) {
  var inView = props.inView,
      data = props.data,
      linkType = props.linkType,
      linkAs = props.linkAs; // const springProps = globalSpringProps(inView);

  var springProps = null;

  var visualData = function visualData(data) {
    if (data.visualItem && data.visualItem.type) {
      return getCardVisual(data.visualItem);
    }

    if (data.featured_media) {
      return getCardVisual(data.featured_media);
    }

    if (data.imgSrc) {
      return getCardVisual(data);
    }

    return null;
  };

  var cardProps = getCardProps$1(data);
  return /*#__PURE__*/React__default.createElement(AnimatedCard$5, {
    style: springProps
  }, /*#__PURE__*/React__default.createElement(SetLinkType, {
    link: linkType,
    to: "/".concat(props.parent, "/").concat(data.type, "/").concat(data.slug),
    title: data.title,
    linkAs: linkAs
  }, /*#__PURE__*/React__default.createElement(Card, {
    renderVisual: visualData(data),
    subtitle: cardProps.subtitle,
    title: cardProps.title,
    description: cardProps.description,
    updateHeight: props.updateHeight,
    max: props.max
  })));
};

var GridItems = /*#__PURE__*/function (_React$Component) {
  _inherits(GridItems, _React$Component);

  var _super = _createSuper(GridItems);

  function GridItems() {
    var _this;

    _classCallCheck(this, GridItems);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      max: 0
    });

    _defineProperty(_assertThisInitialized(_this), "updateHeight", function (height) {
      _this.setState(function (state) {
        return {
          max: height > state.max ? height : state.max
        };
      });
    });

    return _this;
  }

  _createClass(GridItems, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          items = _this$props.items,
          linkType = _this$props.linkType,
          linkAs = _this$props.linkAs;
      return /*#__PURE__*/React__default.createElement(Container, {
        maxWidth: '1055px'
      }, /*#__PURE__*/React__default.createElement(Row, {
        alignItems: "flex-end",
        justifyContent: "center",
        flexWrap: "wrap"
      }, items.map(function (data, index) {
        return /*#__PURE__*/React__default.createElement(Column, {
          key: index,
          width: [1, 6 / 12, 4 / 12],
          px: ['15px', '30px'],
          flex: "0 0 auto"
        }, /*#__PURE__*/React__default.createElement(InViewMonitor, {
          childPropsInView: {
            inView: true
          }
        }, /*#__PURE__*/React__default.createElement(CardBlock$5, _extends({
          className: "CardBlock",
          updateHeight: _this2.updateHeight,
          max: _this2.state.max,
          data: data,
          linkType: linkType,
          linkAs: linkAs
        }, _this2.props))));
      })));
    }
  }]);

  return GridItems;
}(React__default.Component);
GridItems.defaultProps = {
  inView: false,
  // linkType prop sets how the link will work for the cards. Link is preferred, but due to redirects being set up, a had to be added as an option
  linkType: 'link'
};

function _templateObject$C() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  a {\n    text-decoration: none;\n    &:hover {\n      text-decoration: none;\n    }\n  }\n"]);

  _templateObject$C = function _templateObject() {
    return data;
  };

  return data;
}
var AnimatedCard$6 = styled(reactSpring.animated.div)(_templateObject$C());

var CardBlock$6 = function CardBlock(_ref) {
  var inView = _ref.inView,
      link = _ref.link,
      cardType = _ref.cardType,
      rotateEnabled = _ref.rotateEnabled,
      card = _objectWithoutProperties(_ref, ["inView", "link", "cardType", "rotateEnabled"]);

  var springProps = globalSpringProps(inView);
  var LinkWrapper = link ? link.as : React__default.Fragment;
  return /*#__PURE__*/React__default.createElement(AnimatedCard$6, {
    style: springProps
  }, /*#__PURE__*/React__default.createElement(LinkWrapper, link, /*#__PURE__*/React__default.createElement(Card, card, cardType === 'product' ? /*#__PURE__*/React__default.createElement(ButtonIcon, {
    display: "flex",
    justifyContent: "center",
    hasHover: false,
    iconBefore: rotateEnabled ? baseTheme.icons.rotate : baseTheme.icons.plus,
    sx: {
      borderBottom: 'none!important'
    }
  }, rotateEnabled ? "View in 360 + Information" : "Information") : null)));
};

var GridCards = function GridCards(_ref2) {
  var _ref2$items = _ref2.items,
      items = _ref2$items === void 0 ? [] : _ref2$items,
      cardType = _ref2.cardType;

  var _useState = React.useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      max = _useState2[0],
      setMax = _useState2[1];

  var updateHeight = function updateHeight(height) {
    setMax(height > max ? height : max);
  };

  return /*#__PURE__*/React__default.createElement(Container, {
    maxWidth: '1010px',
    width: [1, 9 / 12]
  }, /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "flex-end",
    justifyContent: "center",
    flexWrap: "wrap"
  }, items.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(Column, {
      key: index,
      width: [1, 6 / 12, 4 / 12],
      px: ['15px', '30px'],
      flex: "0 0 auto"
    }, /*#__PURE__*/React__default.createElement(InViewMonitor, {
      childPropsInView: {
        inView: true
      }
    }, /*#__PURE__*/React__default.createElement(CardBlock$6, _extends({
      cardType: cardType,
      updateHeight: updateHeight,
      max: max
    }, item))));
  })));
};

function _templateObject$D() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 80vh;\n"]);

  _templateObject$D = function _templateObject() {
    return data;
  };

  return data;
}
var StyledPoem = styled(rebass.Box)(_templateObject$D());
var Poem = /*#__PURE__*/function (_React$Component) {
  _inherits(Poem, _React$Component);

  var _super = _createSuper(Poem);

  function Poem() {
    _classCallCheck(this, Poem);

    return _super.apply(this, arguments);
  }

  _createClass(Poem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          content = _this$props.content,
          background_image = _this$props.background_image;
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          position: 'relative',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/React__default.createElement(StyledPoem, null, /*#__PURE__*/React__default.createElement(reactParallax.Parallax, {
        strength: -1100,
        style: {
          width: '100%',
          height: '100%',
          backgroundImage: "url(".concat(background_image, ")")
        }
      }, /*#__PURE__*/React__default.createElement(reactParallax.Background, null, /*#__PURE__*/React__default.createElement(rebass.Box, {
        mt: ['75%', '50%']
      }, /*#__PURE__*/React__default.createElement(Element, {
        my: [3],
        size: "meta",
        textAlign: "center",
        color: "#fff"
      }, title), /*#__PURE__*/React__default.createElement(Element$1, {
        size: "bodyBig",
        textAlign: "center",
        as: "span",
        color: "#f1f1f1",
        html: content
      }))))));
    }
  }]);

  return Poem;
}(React__default.Component);

function _templateObject$E() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  padding: ", " ", ";\n  width: 100%;\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n  animation: fadein ", ";\n  @keyframes fadein {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  small {\n    animation: fadein ", ";\n    @keyframes fadein {\n      0% {\n        opacity: 0;\n      }\n      100% {\n        opacity: 1;\n      }\n    }\n  }\n"]);

  _templateObject$E = function _templateObject() {
    return data;
  };

  return data;
}
var StyledCaptionWrapper = styled.div(_templateObject$E(), spacing.space3, spacing.space4, timing.slow, timing.slow);

var AnimatedBlockImage = function AnimatedBlockImage(props) {
  var inView = props.inView,
      block = props.block,
      fullWidth = props.fullWidth;
  var springProps = globalSpringProps(inView);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hoverImage = _useState2[0],
      setHoverImage = _useState2[1];

  var renderCaptionText = function renderCaptionText(matches) {
    return /*#__PURE__*/React__default.createElement(Element$1, {
      as: "small",
      fontSize: fullWidth ? 'bodyBig' : 'bodySmall',
      px: fullWidth ? spacing.space2 : spacing.space0,
      lineHeight: '1.3',
      color: matches ? '#8F8E8D' : '#FFFFFF'
    }, block.image_file.caption);
  };

  return /*#__PURE__*/React__default.createElement(reactSpring.animated.div, {
    style: springProps
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'relative'
    },
    className: "grid-box",
    onMouseEnter: function onMouseEnter() {
      return setHoverImage(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHoverImage(false);
    }
  }, /*#__PURE__*/React__default.createElement(LazyLoad, {
    debounce: false,
    offsetVertical: 500
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "100%",
    className: "img-fluid",
    alt: block.image_file.title,
    src: block.image_file.url
  })), block.image_file.caption && block.image_file.caption && /*#__PURE__*/React__default.createElement(Media, {
    query: {
      maxWidth: 900
    }
  }, function (matches) {
    return matches ? renderCaptionText(matches) : hoverImage && /*#__PURE__*/React__default.createElement(StyledCaptionWrapper, null, renderCaptionText(matches));
  })));
};

AnimatedBlockImage.defaultProps = {
  inView: false
};

var BuilderLayout = function BuilderLayout(props) {
  var rowAlignItems = props.rowAlignItems,
      rowMarginBottom = props.rowMarginBottom,
      rowJustifyContent = props.rowJustifyContent,
      containerWidth = props.containerWidth,
      fullWidth = props.fullWidth;
  return /*#__PURE__*/React__default.createElement(Container, {
    maxWidth: fullWidth ? '100%' : containerWidth
  }, /*#__PURE__*/React__default.createElement(Row, {
    mb: rowMarginBottom ? eval(rowMarginBottom) : [2, 9] // mb={rowMarginBottom ? rowMarginBottom.split(',') : [2, 9]}
    ,
    alignItems: rowAlignItems,
    justifyContent: rowJustifyContent
  }, /*#__PURE__*/React__default.createElement(LayoutBuilder, {
    blocks: props,
    fullWidth: fullWidth
  })));
};

var LayoutBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(LayoutBuilder, _React$Component);

  var _super = _createSuper(LayoutBuilder);

  function LayoutBuilder() {
    _classCallCheck(this, LayoutBuilder);

    return _super.apply(this, arguments);
  }

  _createClass(LayoutBuilder, [{
    key: "getLayoutComponent",
    value: function getLayoutComponent(block, index) {
      switch (block.acf_fc_layout) {
        case 'image':
          return /*#__PURE__*/React__default.createElement(BlockImage, _extends({}, block, {
            key: index,
            fullWidth: this.props.fullWidth
          }));

        case 'column':
          return /*#__PURE__*/React__default.createElement(BlockColumn, _extends({}, block, {
            key: index,
            fullWidth: this.props.fullWidth
          }));

        case 'row':
          return /*#__PURE__*/React__default.createElement(BlockRow, _extends({}, block, {
            key: index,
            fullWidth: this.props.fullWidth
          }));

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          fullWidth = _this$props.fullWidth,
          _this$props$blocks$bu = _this$props.blocks.builder,
          builder = _this$props$blocks$bu === void 0 ? [] : _this$props$blocks$bu;

      if (builder.length) {
        return builder.map(function (block, index) {
          return _this.getLayoutComponent(block, fullWidth, index);
        });
      }

      return null;
    }
  }]);

  return LayoutBuilder;
}(React__default.Component);

function BlockImage(props) {
  return /*#__PURE__*/React__default.createElement(rebass.Box, {
    mt: eval(props.imageWrapperMarginT),
    mb: eval(props.imageWrapperMarginB),
    width: eval(props.imageWrapperWidth) // mt={props.imageWrapperMarginT.split(',')}
    // mb={props.imageWrapperMarginB.split(',')}
    // width={props.imageWrapperWidth.split(',')}
    ,
    flex: props.fullWidth ? '1 1 auto' : '0 1 auto',
    px: props.fullWidth ? '0px' : '15px'
  }, /*#__PURE__*/React__default.createElement(InViewMonitor, {
    childPropsInView: {
      inView: true
    }
  }, /*#__PURE__*/React__default.createElement(AnimatedBlockImage, {
    block: props,
    fullWidth: props.fullWidth
  })));
}

function BlockColumn(props) {
  return /*#__PURE__*/React__default.createElement(Column, {
    width: eval(props.columnWidth),
    flex: '0 1 auto'
  }, /*#__PURE__*/React__default.createElement(LayoutBuilder, {
    blocks: props.builder_col
  }));
}

function BlockRow(props) {
  return /*#__PURE__*/React__default.createElement(Row, {
    mb: props.rowMarginBottom ? eval(props.rowMarginBottom) : [2, 9] // mb={props.rowMarginBottom ? props.rowMarginBottom.split(',') : [2, 9]}
    ,
    justifyContent: props.rowJustifyContent,
    alignItems: props.rowAlignItems
  }, /*#__PURE__*/React__default.createElement(LayoutBuilder, {
    blocks: props.builder_row
  }));
}

BuilderLayout.propTypes = {
  containerWidth: propTypes.string,
  fullWidth: propTypes.bool
};
BuilderLayout.defaultProps = {
  containerWidth: '1230px',
  fullWidth: false
};

function _templateObject2$r() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  cursor: pointer;\n  width: 100%;\n  margin-bottom: ", ";\n  img {\n    width: 100%;\n  }\n  &:hover {\n    cursor: zoom-in;\n  }\n"]);

  _templateObject2$r = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$F() {
  var data = _taggedTemplateLiteral(["\n  column-count: 2;\n  column-gap: ", ";\n  orphans: 1;\n  widows: 1;\n  @media (min-width: 768px) {\n    column-count: 3;\n  }\n"]);

  _templateObject$F = function _templateObject() {
    return data;
  };

  return data;
}

var StyledColumns = styled(rebass.Box)(_templateObject$F(), spacing.space2);
var StyledImageWrapper = styled(rebass.Box)(_templateObject2$r(), spacing.space2);

var AnimatedImageBlock = function AnimatedImageBlock(props) {
  var inView = props.inView,
      index = props.index,
      i = props.i,
      imagesArr = props.imagesArr;
  var springProps = globalSpringProps(inView);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isopen = _useState2[0],
      toggleIsOpen = _useState2[1];

  var handleClick = function handleClick() {
    return toggleIsOpen(!isopen);
  };

  var _useState3 = React.useState(index),
      _useState4 = _slicedToArray(_useState3, 2),
      currentItem = _useState4[0],
      setCurrentItem = _useState4[1];

  var handlePagingNext = function handlePagingNext() {
    return setCurrentItem((currentItem + 1) % imagesArr.length);
  };

  var handlePagingPrev = function handlePagingPrev() {
    return setCurrentItem((currentItem + imagesArr.length - 1) % imagesArr.length);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(reactSpring.animated.div, {
    style: springProps
  }, /*#__PURE__*/React__default.createElement(StyledImageWrapper, {
    key: index
  }, /*#__PURE__*/React__default.createElement("img", {
    key: index,
    className: 'img-fluid',
    onClick: handleClick,
    src: i.url,
    alt: i.title
  }))), isopen && /*#__PURE__*/React__default.createElement(Lightbox, {
    mainSrc: imagesArr[currentItem],
    prevSrc: imagesArr[(currentItem + imagesArr.length - 1) % imagesArr.length],
    onCloseRequest: handleClick,
    onMovePrevRequest: handlePagingPrev,
    nextSrc: imagesArr[(currentItem + 1) % imagesArr.length],
    onMoveNextRequest: handlePagingNext
  }));
};

AnimatedImageBlock.defaultProps = {
  inView: false
};

var GalleryZoom = function GalleryZoom(props) {
  var images = props.images,
      imagesArr = props.imagesArr;
  return /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(StyledColumns, {
    my: [2, 5]
  }, images && images.map(function (i, index) {
    return /*#__PURE__*/React__default.createElement(InViewMonitor, {
      key: index,
      childPropsInView: {
        inView: true
      }
    }, /*#__PURE__*/React__default.createElement(AnimatedImageBlock, {
      key: index,
      index: index,
      i: i,
      imagesArr: imagesArr
    }));
  })));
};

GalleryZoom.propTypes = {
  images: propTypes.array
};
GalleryZoom.defaultProps = {
  images: null
};

var Collapse = function Collapse(_ref) {
  var renderHeader = _ref.renderHeader,
      renderBody = _ref.renderBody,
      _ref$hasBorder = _ref.hasBorder,
      hasBorder = _ref$hasBorder === void 0 ? true : _ref$hasBorder;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isopen = _useState2[0],
      toggle = _useState2[1];

  var clickHandler = React.useCallback(function () {
    return toggle(!isopen);
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "accordion",
    style: {
      position: 'relative',
      borderBottom: hasBorder ? '1px solid rgba(224,224,224, 0.5)' : null
    }
  }, renderHeader ? renderHeader(isopen, clickHandler) : null, /*#__PURE__*/React__default.createElement(renderprops.Spring, {
    force: true,
    to: {
      height: isopen ? 'auto' : 0,
      opacity: isopen ? 1 : 0,
      overflow: !isopen ? 'hidden' : 'visible'
    }
  }, function (style) {
    return /*#__PURE__*/React__default.createElement("div", {
      style: style
    }, /*#__PURE__*/React__default.createElement("div", null, isopen && renderBody));
  }));
};

var CollapseWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(CollapseWrapper, _React$Component);

  var _super = _createSuper(CollapseWrapper);

  function CollapseWrapper(props) {
    var _this;

    _classCallCheck(this, CollapseWrapper);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleCollapse", function (id) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          allowMultipleOpen = _assertThisInitialize.props.allowMultipleOpen,
          openSections = _assertThisInitialize.state.openSections;

      var isopen = openSections[id];

      if (allowMultipleOpen) {
        _this.setState({
          openSections: _objectSpread2(_objectSpread2({}, openSections), {}, _defineProperty({}, id, !isopen))
        });
      } else {
        _this.setState({
          openSections: _defineProperty({}, id, !isopen)
        }, function () {
          return console.log(_this.state.openSections);
        });
      }
    });

    var _openSections = {};
    _this.state = {
      openSections: _openSections
    };
    return _this;
  }

  _createClass(CollapseWrapper, [{
    key: "render",
    value: function render() {
      var renderCollapse = this.props.renderCollapse,
          openSections = this.state.openSections;
      return /*#__PURE__*/React__default.createElement("div", null, renderCollapse && renderCollapse({
        handleCollapse: this.handleCollapse,
        openSections: openSections
      }));
    }
  }]);

  return CollapseWrapper;
}(React__default.Component);

_defineProperty(CollapseWrapper, "propTypes", {
  allowMultipleOpen: propTypes.bool
});

_defineProperty(CollapseWrapper, "defaultProps", {
  allowMultipleOpen: false
});

function _templateObject2$s() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject2$s = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$G() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  top: ", ";\n  height: ", ";\n  overflow: hidden;\n  background-color: ", ";\n  box-shadow: 0 0px 10px 3px rgba(0, 0, 0, 0.1);\n\n  transition: top 0.2s;\n\n  &:hover {\n    ", "\n  }\n"]);

  _templateObject$G = function _templateObject() {
    return data;
  };

  return data;
}
var AnimatedNav = styled(reactSpring.animated.div)(_templateObject$G(), function (props) {
  return props.isopen ? '50px' : '0px';
}, function (props) {
  return props.isopen ? 'auto' : '70px';
}, function (props) {
  return props.theme.colors.bg;
}, function (props) {
  return !props.isopen && props.hover && 'top: -10px !important;';
});
var Collapse$1 = styled.div(_templateObject2$s());

var CollapseBody = function CollapseBody(props) {
  var renderBody = props.renderBody;
  return /*#__PURE__*/React__default.createElement(Collapse$1, null, renderBody);
};

var NavSwitch = function NavSwitch(props) {
  var isopen = props.isopen,
      renderHeader = props.renderHeader,
      renderBody = props.renderBody,
      theme = props.theme,
      animate = props.animate,
      id = props.id;

  var _useState = React.useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1];
  /* monitor the isopen flag for changes. If it shifts we want
     the hover effect to be temporarily disabled, and for animation
     to be enabled */


  React.useEffect(function () {
    return function () {
      if (isopen) {
        setHover(false);
        setTimeout(function () {
          return setHover(true);
        }, 500);
      } else {
        setHover(false);
      }
    };
  }, [isopen]);

  var onClick = function onClick() {
    if (!isopen) props.handleCollapse();
  };

  var springProps = reactSpring.useSpring(_objectSpread2(_objectSpread2(_objectSpread2({
    from: {
      top: 0
    }
  }, !isopen && {
    to: [{
      top: 1000,
      height: 1000,
      zIndex: 0
    }, {
      top: 0,
      height: 70
    }]
  }), isopen && {
    to: {
      top: 50,
      height: 'auto',
      zIndex: 1
    }
  }), {}, {
    config: {
      duration: 500
    }
  }));
  return /*#__PURE__*/React__default.createElement(AnimatedNav, {
    isopen: isopen ? 1 : 0,
    style: animate ? springProps : {},
    theme: theme,
    hover: hover ? 1 : 0
  }, /*#__PURE__*/React__default.createElement("div", {
    onClick: onClick,
    style: {
      cursor: 'pointer'
    }
  }, renderHeader && renderHeader({
    isopen: isopen
  })), /*#__PURE__*/React__default.createElement(CollapseBody, {
    renderBody: renderBody
  }));
};

function _templateObject$H() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject$H = function _templateObject() {
    return data;
  };

  return data;
}
var StyledNavWrapper = styled.div(_templateObject$H());
var NavSwitchWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(NavSwitchWrapper, _React$Component);

  var _super = _createSuper(NavSwitchWrapper);

  function NavSwitchWrapper(props) {
    var _this;

    _classCallCheck(this, NavSwitchWrapper);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleCollapse", function (active, inactive) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          allowMultipleOpen = _assertThisInitialize.props.allowMultipleOpen,
          openSections = _assertThisInitialize.state.openSections;

      if (allowMultipleOpen) {
        var _openSections2;

        _this.setState({
          openSections: (_openSections2 = {}, _defineProperty(_openSections2, active, !openSections[active]), _defineProperty(_openSections2, inactive, !openSections[inactive]), _openSections2)
        });
      } else {
        var _openSections3;

        _this.setState({
          openSections: (_openSections3 = {}, _defineProperty(_openSections3, active, !openSections[active]), _defineProperty(_openSections3, inactive, !openSections[inactive]), _openSections3)
        });
      }
    });

    var _openSections = props.defaultState;
    _this.state = {
      openSections: _openSections
    };
    return _this;
  }

  _createClass(NavSwitchWrapper, [{
    key: "render",
    value: function render() {
      var renderCollapse = this.props.renderCollapse,
          openSections = this.state.openSections;
      return /*#__PURE__*/React__default.createElement(StyledNavWrapper, null, renderCollapse && renderCollapse({
        handleCollapse: this.handleCollapse,
        openSections: openSections
      }));
    }
  }]);

  return NavSwitchWrapper;
}(React__default.Component);

_defineProperty(NavSwitchWrapper, "propTypes", {
  allowMultipleOpen: propTypes.bool
});

_defineProperty(NavSwitchWrapper, "defaultProps", {
  allowMultipleOpen: false
});

function _templateObject3$e() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  transition: all 0.3s;\n  margin-left: ", ";\n  opacity: ", ";\n  z-index: 1;\n"]);

  _templateObject3$e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$t() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  z-index: 2;\n"]);

  _templateObject2$t = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$I() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject$I = function _templateObject() {
    return data;
  };

  return data;
}
var StyledShare = styled.div(_templateObject$I());
var StyledButton$1 = styled(ButtonText)(_templateObject2$t());
var StyledOptions = styled.div(_templateObject3$e(), function (props) {
  return props.isHidden ? '-36px' : '0';
}, function (props) {
  return props.isHidden ? '0' : '1';
});

var Share = function Share(props) {
  var title = props.title;

  var _useState = React.useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isHidden = _useState2[0],
      toggleHidden = _useState2[1];

  var shareUrl = null;

  if (process.browser) {
    shareUrl = String(window.location.href);
  }

  return /*#__PURE__*/React__default.createElement(Space, {
    bottom: true,
    size: spacing.space5
  }, /*#__PURE__*/React__default.createElement(StyledShare, null, /*#__PURE__*/React__default.createElement(StyledButton$1, {
    onClick: function onClick() {
      return toggleHidden(!isHidden);
    }
  }, isHidden ? 'Share' : 'Close'), /*#__PURE__*/React__default.createElement(StyledOptions, {
    isHidden: isHidden
  }, /*#__PURE__*/React__default.createElement(reactShare.FacebookShareButton, {
    className: "btn",
    url: shareUrl,
    quote: title
  }, /*#__PURE__*/React__default.createElement(reactShare.FacebookIcon, {
    size: 32
  })), /*#__PURE__*/React__default.createElement(reactShare.TwitterShareButton, {
    className: "btn",
    url: shareUrl,
    quote: title
  }, /*#__PURE__*/React__default.createElement(reactShare.TwitterIcon, {
    size: 32
  })), /*#__PURE__*/React__default.createElement(reactShare.LinkedinShareButton, {
    url: shareUrl,
    quote: title,
    windowWidth: 750,
    windowHeight: 600,
    className: "btn"
  }, /*#__PURE__*/React__default.createElement(reactShare.LinkedinIcon, {
    size: 32
  })), /*#__PURE__*/React__default.createElement(reactShare.WhatsappShareButton, {
    url: shareUrl,
    quote: title,
    windowWidth: 750,
    windowHeight: 600,
    className: "btn"
  }, /*#__PURE__*/React__default.createElement(reactShare.WhatsappIcon, {
    size: 32
  })), /*#__PURE__*/React__default.createElement(reactShare.EmailShareButton, {
    body: null,
    className: "btn",
    url: shareUrl,
    subject: title
  }, /*#__PURE__*/React__default.createElement(reactShare.EmailIcon, {
    size: 32
  })))));
};
Share.defaultProps = {
  title: null
};

var api = {
  garden: {
    header: {
      menu: [{
        label: 'About',
        url: '/about'
      }, {
        label: 'Explore',
        url: '/explore'
      }, {
        label: 'Events',
        url: '/events'
      }, {
        label: 'Visit',
        url: '/visit'
      }, {
        label: 'Contact',
        url: '/contact'
      }]
    },
    home: {
      hero: {
        img: 'https://images.unsplash.com/photo-1516294239181-73e90cf5c198?ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80',
        title: 'An indigenous garden featuring over 60 works by Dylan Lewis',
        description: '',
        ctas: [{
          label: 'Watch video',
          url: '/contact'
        }, {
          label: 'Find out more',
          url: '/contact'
        }]
      },
      explore: {
        subtitle: 'explore the garden',
        title: 'Unearth the wilderness within',
        items: [{
          meta: 'Item Name One',
          title: "A bird's-eye view of the Garden",
          image: 'https://images.unsplash.com/photo-1474914917321-8818dc7f2e74?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80'
        }, {
          meta: 'Item Name One',
          title: "A bird's-eye view of the Garden",
          image: 'https://images.unsplash.com/photo-1490375802951-32da9271ec4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=80'
        }, {
          meta: 'Item Name One',
          title: "A bird's-eye view of the Garden",
          image: 'https://images.unsplash.com/photo-1460379643280-cfee5065fde8?ixlib=rb-1.2.1&auto=format&fit=crop&w=1778&q=80'
        }, {
          meta: 'Item Name One',
          title: "A bird's-eye view of the Garden",
          image: 'https://images.unsplash.com/photo-1493705588539-027f5ac35547?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80'
        }, {
          meta: 'Item Name One',
          title: "A bird's-eye view of the Garden",
          image: 'https://images.unsplash.com/photo-1505861556929-2260d2f376d2?ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80'
        }, {
          meta: 'Item Name One',
          title: "A bird's-eye view of the Garden",
          image: 'https://images.unsplash.com/photo-1469362102473-8622cfb973cd?ixlib=rb-1.2.1&auto=format&fit=crop&w=1693&q=80'
        }]
      },
      events: {
        subtitle: 'Sculpture Garden',
        title: 'What’s happening',
        items: [{
          meta: 'Exhibitions',
          title: 'Chris van Niekerk: Invisible Embrace',
          description: 'Spring 2017',
          content: 'Quisque lobortis massa ornare, facilisis orci id, tempus ipsum.',
          image: 'https://images.unsplash.com/photo-1508997449629-303059a039c0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80'
        }, {
          meta: 'Exhibitions',
          title: 'Bombshelter Beast',
          description: 'Spring 2017',
          content: 'Quisque lobortis massa ornare, facilisis orci id, tempus ipsum.',
          image: 'https://images.unsplash.com/photo-1480439175398-9bc6fb2ebf9e?ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80'
        }, {
          meta: 'Exhibitions',
          title: 'The Old Store Launches Black Plum',
          description: 'Spring 2017',
          content: 'Quisque lobortis massa ornare, facilisis orci id, tempus ipsum.',
          image: 'https://images.unsplash.com/photo-1523301343968-6a6ebf63c672?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80'
        }, {
          meta: 'Exhibitions',
          title: 'Bombshelter Beast',
          description: 'Spring 2017',
          content: 'Quisque lobortis massa ornare, facilisis orci id, tempus ipsum.',
          image: 'https://images.unsplash.com/photo-1480439175398-9bc6fb2ebf9e?ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80'
        }, {
          meta: 'Exhibitions',
          title: 'Feast of Clarity: Food + Architecture',
          description: 'Spring 2017',
          content: 'Quisque lobortis massa ornare, facilisis orci id, tempus ipsum.',
          image: 'https://images.unsplash.com/photo-1470753937643-efeb931202a9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
        }, {
          meta: 'Exhibitions',
          title: 'Bombshelter Beast',
          description: 'Spring 2017',
          content: 'Quisque lobortis massa ornare, facilisis orci id, tempus ipsum.',
          image: 'https://images.unsplash.com/photo-1480439175398-9bc6fb2ebf9e?ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80'
        }]
      },
      cta: {
        visual: {
          image: {
            url: 'https://images.unsplash.com/photo-1527529482837-4698179dc6ce?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80'
          }
        },
        meta: '',
        title: 'Host your Private Event',
        content: 'The Dylan Lewis Sculpture Garden is available for a limited number of private events. Get in touch for more information.',
        ctas: [{
          label: 'Contact us',
          url: '/contact-garden'
        }]
      },
      poster: {
        meta: 'test',
        visual: {
          image: {
            url: 'https://images.unsplash.com/photo-1485921040253-3601b55d50aa?ixlib=rb-1.2.1&auto=format&fit=crop&w=564&q=80'
          }
        },
        title: 'Dylan Lewis was born in 1964 and raised in an artistic family in South Africa. ',
        content: 'Test contnet Dylan Lewis was born in 1964 and raised in an artistic family in South Africa. ',
        ctas: [{
          label: 'Contact us',
          url: '/contact-garden'
        }]
      }
    },
    about: {
      title: 'Located between two worlds, one wild and one tamed, the Dylan Lewis Sculpture Garden borders the manicured suburbs of Stellenbosch and a rugged mountain wilderness where leopard still roam. ',
      img: 'https://images.unsplash.com/photo-1497044383938-c0486a41b655?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2215&q=80',
      description: 'In this garden of private myth, the artist explores the Jungian notion of ‘the wilderness within’. More than sixty sculptures constituting a comprehensive record of his artistic development thus far have been carefully sited along four kilometres of paths. The sculptures in relation to the mountains, show the scale and enormity of the garden, and the dynamism of the sculptures.',
      content: '<p><b>Creating the Garden</b></p><p>The project began in 2009 when Dylan hired an excavator and began creating the contours of what would become a seven-hectare sculpture garden. During almost two years of earthworks, the artist shaped a disused tract of flat farmland into dynamic hills, valleys and water features. In fact, the garden could be considered his largest sculpture to date.</p>'
    },
    event: {
      meta: 'Performances',
      title: 'Bombshelter Beast',
      description: 'Woordfees 2018',
      img: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=3300&q=80'
    },
    slider: [{
      src: 'https://images.unsplash.com/photo-1537812471755-4e252389747c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2100&q=80',
      caption: 'Caption Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Vestibulum id ligula porta felis euismod semper.'
    }, {
      src: 'https://images.unsplash.com/photo-1537812471755-4e252389747c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2100&q=80',
      caption: 'Tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Vestibulum id ligula porta felis euismod semper.'
    }, {
      src: 'https://images.unsplash.com/photo-1521378141208-fa4a60112ef7?ixlib=rb-1.2.1&auto=format&fit=crop&w=2100&q=80'
    }, {
      src: 'https://images.unsplash.com/photo-1521378141208-fa4a60112ef7?ixlib=rb-1.2.1&auto=format&fit=crop&w=2100&q=80'
    }, {
      src: 'https://images.unsplash.com/photo-1521378141208-fa4a60112ef7?ixlib=rb-1.2.1&auto=format&fit=crop&w=2100&q=80'
    }]
  },
  studio: {
    header: {
      menu: [{
        label: 'Featured Work',
        url: '/work'
      }, {
        label: 'About',
        url: '/about'
      }, {
        label: 'Exhibitions & Auctions',
        url: '/exhibitions'
      }, {
        label: 'Contact',
        url: '/contact'
      }]
    },
    work: {
      meta: 'Wild Symbols',
      title: 'Big Cats',
      description: '',
      img: 'https://images.unsplash.com/photo-1517825738774-7de9363ef735?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1996&q=80'
    },
    about: {
      title: 'Dylan Lewis was born in 1964 and raised in an artistic family in South Africa.',
      img: 'https://images.unsplash.com/photo-1497044383938-c0486a41b655?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2215&q=80',
      content: '<p>His father was an accomplished sculptor, his mother and his grandmother were painters, and two great-grandfathers were an architect and cabinetmaker respectively. Dylan initially followed in the family tradition, beginning his career as a painter, but later turned to sculpture. Widely recognised as one of the world’s foremost sculptors of the animal form, he initially focused on the big cats; in recent years, he has used the human figure to explore our relationship with our inner wilderness. His international career spans two decades and includes exhibitions in Paris, Sydney, Toronto, Houston and San Francisco, as well as numerous one-man exhibitions in London, where he is among the few living artists to have held solo auctions at Christie’s in London.</p>',
      timeline: {
        moments: [{
          year: '1999',
          image: 'https://images.unsplash.com/photo-1438155047396-adbf4a7252ec?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1400&q=80',
          title: "Exhibition of recent work, Art London 2004 in association with The Everard Read Gallery, Burton's Court, London"
        }, {
          year: '2002',
          image: 'https://images.unsplash.com/photo-1438155047396-adbf4a7252ec?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1400&q=80',
          title: "Exhibition of recent work, Art London 2004 in association with The Everard Read Gallery, Burton's Court, London",
          content: "<p><ul><li>Predators & Prey urban outdoor sculpture installation of 23 life-size bronzes in town of Stellenbosch</li><li>'Shapeshifting - from animal to human' exhibition, RupertMuseum, Stellenbosch</li></ul></p>"
        }, {
          year: '2002',
          title: "Exhibition of recent work, Art London 2004 in association with The Everard Read Gallery, Burton's Court, London",
          content: "<p><ul><li>Predators & Prey urban outdoor sculpture installation of 23 life-size bronzes in town of Stellenbosch</li><li>'Shapeshifting - from animal to human' exhibition, RupertMuseum, Stellenbosch</li></ul></p>"
        }]
      }
    },
    auctions: {
      title: 'Auctions & Exhibitions',
      filters: [{
        label: 'View All'
      }, {
        label: 'Current'
      }, {
        label: 'Past'
      }, {
        label: 'Art Fairs'
      }],
      items: [{
        date: '2014',
        type: 'Past',
        title: 'Bronze, Steel and Stone, Group Show',
        description: 'Circa, London',
        image: {
          url: 'https://images.unsplash.com/photo-1473107522457-4ed378e0c05f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80',
          width: '180px',
          height: '120px'
        }
      }, {
        date: '2016',
        type: 'Art Fair',
        title: 'Spoor Series',
        description: 'Everard Read',
        image: {
          url: 'https://images.unsplash.com/photo-1493546109643-cd9fda7b38fe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1489&q=80',
          width: '120px',
          height: '180px'
        }
      }, {
        date: '2018',
        type: 'Past',
        title: 'Spoor Series',
        description: 'Everard Read',
        image: {
          url: 'https://images.unsplash.com/photo-1493546109643-cd9fda7b38fe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1489&q=80',
          width: '180px',
          height: '120px'
        }
      }]
    }
  },
  footer: {
    menu: {
      garden: {
        title: 'The Sculpture Garden',
        items: [{
          label: 'About the Garden ',
          url: '/'
        }, {
          label: 'Explore the Garden',
          url: '/'
        }, {
          label: 'The Pavilion',
          url: '/'
        }, {
          label: 'Old Storeroom',
          url: '/'
        }, {
          label: 'Events',
          url: '/'
        }, {
          label: 'Books',
          url: '/'
        }, {
          label: 'Visit',
          url: '/'
        }, {
          label: 'Contact',
          url: '/'
        }]
      },
      studio: {
        title: 'Dylan Lewis Studio',
        items: [{
          label: 'About ',
          url: '/'
        }, {
          label: 'Auctions & Exhibitions',
          url: '/'
        }, {
          label: 'Contact',
          url: '/'
        }]
      }
    }
  },
  accordion: {
    items: [{
      title: 'Availability',
      content: 'We do not keep stock of all sculptures where editions are still available, so please note that you may have to wait two to three months for a sculpture to be cast.',
      isopen: true
    }, {
      title: 'Shipping',
      content: "<ul>\n                    <li>Due to the variety of shapes and sizes of the sculptures, shipping quotes can only be provided once you know what you want.</li>\n                    <li>We will need a delivery address and contact details for the shipping quote.</li>\n                    <li>We get three estimates from three reputable companies that are very involved in the art industry. We provide you with the lowest of the estimates.</li>\n                    <li>Please remember that different countries have different duties and VAT applicable</li>\n                    <li>Where we can, we provide a full door to door solution including insurance and duties/taxes payable.</li>\n                    <li>SA VAT is not payable for sales where delivery is outside of SA.</li>\n                    <li>Once you have accepted the quote, we will forward an invoice including the sculpture cost and the shipping cost.</li>\n                    <li>Shipping will only take place once full payment has been received.</li>\n                    <li>Delivery to major SA cities is a complementary service.</li>\n                </ul>",
      isopen: false
    }, {
      title: 'VAT',
      content: '15% SA VAT is payable on all sales for delivery within South Africa.',
      isopen: true
    }, {
      title: 'Looking after your investment',
      content: "<div><b>CARE OF BRONZE SCULPTURE</b></div>\n          <ul>\n             <li>The sculpture is coated in a layer of beeswax, therefore simply buff with a soft lint-free cloth regularly to maintain the lustre.</li>\n             <li>Should polishing be required, apply a thin layer of the polish, working the wax into all the crevices - allow to set and buff well. Applying the wax onto a dry, sun-warmed bronze and allowing it to cool and set over-night before buffing in the cool of the morning works well.</li>\n             <li>Never use Brasso or scour the piece in any way, as this will destroy the patina.</li>\n             <li>Sculptures that are placed in the garden might acquire a natural green (or greener) and darker patina with time due to the bronze reacting to dampness and water. If you wish to slow this process down, polish regularly.</li>\n          </ul>\n          <div></div>\n          <div><b>CARE OF WALL PANELS</b></div>\n          <div>The wax we utilize is called <em>Trewax</em>, a specialist wax also used for the bronzes, a light brush over with a soft 100mm paint brush will suffice, but certainly NOT a cloth rubbing.</div>\n          <div>A good quality clear furniture wax will also be ok, but key is a light application.</div>\n          <div>Dust on the surface should be vacuumed with a bristle end prior to polishing.</div>",
      isopen: true
    }]
  },
  cardSelectionItems: {
    items: [{
      imgSrc: 'https://source.unsplash.com/random/300x423',
      title: 'Male Trans - Figure V',
      subTitle: 'Code: S283',
      price: 160000,
      type: 'product',
      slug: '#'
    }, {
      imgSrc: 'https://source.unsplash.com/random/300x225',
      title: 'Female Trans - Figure x',
      subTitle: 'Code: S158',
      price: 180000,
      type: 'product',
      slug: '#'
    }, {
      imgSrc: 'https://source.unsplash.com/random/300x400',
      title: 'Female Trans - Figure x',
      subTitle: 'Code: S262',
      price: 120000,
      type: 'product',
      slug: '#'
    }, {
      imgSrc: 'https://source.unsplash.com/random/300x280',
      title: 'Female Trans - Figure x',
      subTitle: 'Code: S257',
      price: 180000,
      type: 'product',
      slug: '#'
    }]
  },
  product: {
    title: 'Male Trans - Figure V',
    subTitle: 'Code: S283',
    imgArr: ['https://source.unsplash.com/random/600x800', 'https://source.unsplash.com/random/768x1024', 'https://source.unsplash.com/random/500x900'],
    videoURL: 'https://www.dylanlewis.com/studio/auctions_exhibitions/christies-upcoming?wvideo=cy46oj2qi8',
    priceExVAT: 160000,
    description: 'Edition of 8',
    hCM: 41.0,
    wCM: 36.5,
    dCM: 10,
    weightKG: 1200,
    isPurchasable: true,
    isSelectable: true
  },
  virtualTemplate: {
    page: {
      intro: "From the Greek [ khthon,\u2019ground, earth\u2019] + [-ios,\u2019of\u2019] <br/><br/>\n      The title of the exhibition derives from the Greekkhthonios,meaning \u2018of the earth\u2019. The chthonian once tied the idea of earth and the subterranean to a sense of\n      divine creative force and fertility. In Ancient Greece, worship of Chthonios was replaced with that of its opposite, the Olympian. This shift consigned divinity and enlightenment to the heavens above rather than the earth below, and prompted an association with the underground as being a malevolent realm of darkness andtorment; one to be feared. This logic continues to permeate many oppressive religious and secular narratives today.<br/><br/>\n      The chthonic has always been present in Dylan Lewis\u2019s work, through the ideas of wildness and untamed nature. For Lewis, disconnection with these parts of ourselves has caused a profound loss, and much of this body of work is about the difficult process of reconnection.\n      <br/><br/>\n      In Jungian terms, Chthonios is the underbelly of the unconscious, the shadow of the psyche that must be confronted and consolidated if one wishes to achieve a true sense of self. Failure to do so can result in devastating psychological effects for the individual, through repression.\n      <br/><br/>\n      For Dylan Lewis, the sculptural works that make up CHTHONIOS serve as a means of reclaiming an authentic sense of self through unearthing, confronting and embracing of the chthonic.\n      <br/><br/>\n      <i>Texts by Tim Leibbrandt<i>\n      "
    },
    heroDetails: {
      subtitle: 'Virtual Exhibition',
      title: 'CHTHONIOS by Dylan Lewis',
      visual: {
        props: {
          src: 'https://source.unsplash.com/random/800x600'
        }
      }
    }
  }
};
var menus = {
  garden: {
    header: [{
      label: 'About',
      url: '/garden/about-the-garden'
    }, {
      label: 'Explore',
      url: '/garden/explore'
    }, {
      label: 'Sculpture Groupings',
      url: '/garden/sculpture-groupings'
    }, {
      label: 'Events',
      url: '/garden/events'
    }, {
      label: 'Media',
      url: '/garden/media'
    }, {
      label: 'Studio',
      url: '/studio'
    }, {
      label: 'Contact',
      url: '/garden/contact-garden'
    }, {
      label: 'Visit',
      url: '/garden/visit-the-garden',
      hightlight: true
    }],
    footer: {
      title: 'Sculpture Garden',
      url: '/garden',
      items: [{
        label: 'About',
        url: '/garden/about-the-garden'
      }, {
        label: 'Explore',
        url: '/garden/explore'
      }, {
        label: 'Visit the garden',
        url: '/garden/visit-the-garden'
      }, {
        label: 'Sculpture Groupings',
        url: '/garden/sculpture-groupings'
      }, {
        label: 'Events',
        url: '/garden/events'
      }, {
        label: 'Media',
        url: '/garden/media'
      }, {
        label: 'Contact',
        url: '/garden/contact-garden'
      }]
    }
  },
  studio: {
    header: [{
      label: 'About',
      url: '/studio/about-dylan-lewis'
    }, {
      label: 'Sculpture',
      url: '/studio/sculpture'
    }, {
      label: 'Exhibitions',
      url: '/studio/auctions-exhibitions'
    }, {
      label: 'Contact',
      url: '/studio/contact-studio'
    }, {
      label: 'Sculpture Garden',
      url: '/garden',
      hightlight: true
    }],
    footer: {
      title: 'Dylan Lewis Studio',
      url: '/',
      items: [{
        label: 'About Dylan Lewis',
        url: '/studio/about-dylan-lewis'
      }, {
        label: 'Sculpture',
        url: '/studio/sculpture'
      }, {
        label: 'Auctions & Exhibitions',
        url: '/studio/auctions-exhibitions'
      }, {
        label: 'Contact',
        url: '/studio/contact-studio'
      }, {
        label: 'Sales Enquiries',
        url: 'mailto:info@dylanart.co.za'
      }]
    }
  },
  portfolio: {
    header: [{
      label: 'Your Portfolio',
      isPortfolio: true
    }, {
      label: 'CHTHONIOS',
      url: '/catalogue/chthonios-by-dylan-lewis/'
    }, {
      label: 'Your Selection',
      url: '/selection/',
      isCart: true
    }, {
      label: 'Contact',
      externalLink: true,
      url: 'https://dylanlewis.com/studio/contact-studio'
    }],
    footer: {
      title: 'Dylan Lewis Studio',
      url: '/',
      items: [{
        label: 'About Dylan Lewis',
        url: '/studio/about-dylan-lewis'
      }, {
        label: 'Featured Work',
        url: '/studio/sculpture'
      }, {
        label: 'Auctions & Exhibitions',
        url: '/studio/auctions-exhibitions'
      }, {
        label: 'Media',
        url: '/garden/media'
      }, {
        label: 'Books',
        url: 'mailto:info@dylanart.co.za'
      }, {
        label: 'Contact',
        url: '/studio/contact-studio'
      }]
    },
    details: {
      title: 'Details',
      items: [{
        label: 'Shipping',
        url: '#'
      }, {
        label: 'Disclaimer',
        url: '#'
      }, {
        label: 'Legal',
        url: '#'
      }, {
        label: 'Terms & Conditions',
        url: '#'
      }]
    }
  },
  contact: {
    title: 'Contact',
    items: [{
      label: 'Tel: +27 (0)21 880 0054',
      url: 'tel:+270218800054'
    }, {
      label: 'Fax: +27 (0)21 880 0588'
    }, {
      label: 'Email: info@dylanart.co.za',
      url: 'mailto:info@dylanart.co.za'
    }]
  },
  address: {
    title: 'Physical Address',
    items: [{
      label: 'Dylan Lewis Studio and Sculpture Garden, Mulberry Farm, Paradyskloof Road, Stellenbosch, 7600, South Africa',
      url: 'https://www.google.com/maps/dir//dylan+lewis+sculpture+garden+google+map/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x1dcdb3bc2b02fc07:0xb9998b7ba82bf5e0?sa=X&ved=2ahUKEwiGsLvA-ZjjAhWDSxUIHfgvCn0Q9RcwEHoECA4QDg',
      externalLink: true
    }]
  },
  social: {
    title: 'Stay in Touch',
    items: [{
      label: 'Newsletter',
      icon: 'envelope',
      url: '/studio/subscribe'
    }, {
      label: 'Instagram',
      icon: 'instagram',
      url: 'https://www.instagram.com/dylanlewissculpturegarden/',
      externalLink: true
    }, {
      label: 'Facebook',
      icon: 'facebook-square',
      url: 'https://www.facebook.com/dylanlewissculpturegarden/',
      externalLink: true
    }]
  }
};
var bannerContent = {
  event: {
    title: 'Host Your Private Event',
    description: 'The Dylan Lewis Sculpture Garden is available for a limited number of private events. Please contact us for more information.',
    link: {
      type: 'page',
      label: 'Contact Us',
      to: '/garden/contact-garden'
    },
    imgUrl: 'https://dlewis.wpengine.com/wp-content/uploads/2019/01/Events.jpg'
  },
  visit: {
    title: 'Book your Visit ',
    description: 'If you are interested in visiting the Dylan Lewis Sculpture Garden please get in touch.',
    link: {
      type: 'page',
      label: 'Visit Us',
      to: '/garden/visit-the-garden'
    },
    imgUrl: 'https://dlewis.wpengine.com/wp-content/uploads/2019/08/visit.jpg'
  },
  virtual: {
    title: 'CHTHONIOS online',
    description: 'never before seen tiny sculpture - 360° viewing',
    link: {
      type: 'url',
      label: 'View more',
      to: 'https://dylanlewis.com/online/catalogue/chthonios-by-dylan-lewis/',
      isExternal: true
    },
    imgUrl: 'https://cms.dylanlewis.com/wp-content/uploads/2020/06/CHTHONIOS.png'
  }
};

function _templateObject$J() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 0px;\n  background: ", ";\n  border-color: ", ";\n  padding: 8px;\n  font-family: ", ";\n  &:active,\n  &:focus {\n    background: ", ";\n    border-color: ", ";\n    outline: none;\n    box-shadow: none;\n  }\n"]);

  _templateObject$J = function _templateObject() {
    return data;
  };

  return data;
}
var StyledInput = styled.input(_templateObject$J(), colors.bgLight, function (props) {
  return props.error ? 'red' : colors.bgLight;
}, fonts.sans, colors.bgLight, colors.borderDark);
var TextField = function TextField(_ref) {
  var label = _ref.label,
      col = _ref.col,
      message = _ref.message,
      error = _ref.error,
      input = _objectWithoutProperties(_ref, ["label", "col", "message", "error"]);

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(col ? col : 'col-3')
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement(Element$1, {
    mb: [0],
    size: "form"
  }, label), /*#__PURE__*/React.createElement(StyledInput, _extends({
    className: "form-control",
    error: error
  }, input)), message && /*#__PURE__*/React.createElement(Alert, {
    text: message,
    status: 'info'
  }), error && /*#__PURE__*/React.createElement(Alert, {
    text: error,
    status: 'error'
  })));
};

function _templateObject$K() {
  var data = _taggedTemplateLiteral(["\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: transparent;\n  background-color: ", ";\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\") !important;\n  background-repeat: no-repeat;\n  background-position: 99% center;\n  border-radius: 0px;\n  border-color: ", ";\n  padding: 8px;\n  font-family: ", ";\n  &:active,\n  &:focus {\n    background-color: ", ";\n    border-color: ", ";\n    outline: none;\n    box-shadow: none;\n  }\n"]);

  _templateObject$K = function _templateObject() {
    return data;
  };

  return data;
}
var StyledInput$1 = styled.select(_templateObject$K(), colors.bgLight, colors.bgLight, fonts.sans, colors.bgLight, colors.bgLight);
var SelectField = function SelectField(_ref) {
  var label = _ref.label,
      message = _ref.message,
      placeholder = _ref.placeholder,
      options = _ref.options,
      error = _ref.error,
      input = _objectWithoutProperties(_ref, ["label", "message", "placeholder", "options", "error"]);

  return /*#__PURE__*/React__default.createElement("div", {
    className: 'col-12'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React__default.createElement(Element$1, {
    mb: [0],
    size: "form"
  }, label), /*#__PURE__*/React__default.createElement(StyledInput$1, _extends({
    className: "form-control"
  }, input), placeholder ? /*#__PURE__*/React__default.createElement("option", {
    key: placeholder,
    value: -1
  }, placeholder) : /*#__PURE__*/React__default.createElement("option", null), options.map(function (o) {
    return /*#__PURE__*/React__default.createElement("option", {
      key: o.value,
      value: o.value
    }, o.label);
  })), message && /*#__PURE__*/React__default.createElement(Alert, {
    text: message,
    status: 'info'
  }), error && /*#__PURE__*/React__default.createElement(Alert, {
    text: error,
    status: 'error'
  })));
};

function _templateObject$L() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 0px;\n  background: ", ";\n  border-color: ", ";\n  padding: 8px;\n  font-family: ", ";\n  &:active,\n  &:focus {\n    background: ", ";\n    border-color: ", ";\n    outline: none;\n    box-shadow: none;\n  }\n"]);

  _templateObject$L = function _templateObject() {
    return data;
  };

  return data;
}
var StyledInput$2 = styled.textarea(_templateObject$L(), colors.bgLight, function (props) {
  return props.error ? 'red' : colors.bgLight;
}, fonts.sans, colors.bgLight, colors.borderDark);
var TextAreaField = function TextAreaField(_ref) {
  var label = _ref.label,
      col = _ref.col,
      message = _ref.message,
      error = _ref.error,
      input = _objectWithoutProperties(_ref, ["label", "col", "message", "error"]);

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(col ? col : 'col-12')
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement(Element$1, {
    mb: [0],
    fontSize: '16px',
    fontFamily: 'sans'
  }, label), /*#__PURE__*/React.createElement(StyledInput$2, _extends({
    className: "form-control"
  }, input, {
    error: error
  })), message && /*#__PURE__*/React.createElement(Alert, {
    text: message,
    status: 'info'
  }), error && /*#__PURE__*/React.createElement(Alert, {
    text: error,
    status: 'error'
  })));
};

function _templateObject4$9() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 16px;\n  height: 16px;\n  border: solid 1px ", ";\n  cursor: ", ";\n  background: ", ";\n  background: ", ";\n  background: ", ";\n"]);

  _templateObject4$9 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$f() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"]);

  _templateObject3$f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$u() {
  var data = _taggedTemplateLiteral(["\n  cursor: ", ";\n  color: ", ";\n"]);

  _templateObject2$u = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$M() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n"]);

  _templateObject$M = function _templateObject() {
    return data;
  };

  return data;
}
var StyledWrapper$2 = styled.label(_templateObject$M());
var StyledLabel = styled(Element$1)(_templateObject2$u(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.disabled ? baseTheme.colors.baseGrayDark : baseTheme.colors.baseBlack;
});
var HiddenCheckbox = styled.input.attrs({
  type: 'checkbox'
})(_templateObject3$f());
var StyledCheckbox = styled.div(_templateObject4$9(), baseTheme.colors.baseBlack, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, baseTheme.colors.transparent, function (props) {
  return props.checked && baseTheme.colors.baseBlack;
}, function (props) {
  return props.disabled && baseTheme.colors.baseGrayDark;
});
var CheckBoxField = function CheckBoxField(_ref) {
  var label = _ref.label,
      disabled = _ref.disabled,
      message = _ref.message,
      options = _ref.options,
      error = _ref.error,
      value = _ref.value,
      _onChange = _ref.onChange,
      input = _objectWithoutProperties(_ref, ["label", "disabled", "message", "options", "error", "value", "onChange"]);

  var _useState = React.useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setChecked = _useState2[1];

  return /*#__PURE__*/React__default.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React__default.createElement(StyledWrapper$2, null, /*#__PURE__*/React__default.createElement(rebass.Box, {
    className: "HiddenCheckbox_Box",
    width: "".concat(baseTheme.space[2], "px"),
    height: "".concat(baseTheme.space[2], "px")
  }, /*#__PURE__*/React__default.createElement(HiddenCheckbox, _extends({
    className: "HiddenCheckbox",
    disabled: disabled,
    onChange: function onChange(e) {
      setChecked(e.target.checked);

      _onChange(e);
    }
  }, input)), /*#__PURE__*/React__default.createElement(StyledCheckbox, {
    className: "StyledCheckbox",
    disabled: disabled,
    checked: isChecked
  })), /*#__PURE__*/React__default.createElement(StyledLabel, {
    mb: [1],
    pl: [1],
    size: "form",
    html: label,
    disabled: disabled
  })), message && /*#__PURE__*/React__default.createElement(Alert, {
    text: message,
    status: 'info'
  }), error && /*#__PURE__*/React__default.createElement(Alert, {
    text: error,
    status: 'error'
  })));
};

var Description = function Description(props) {
  var label = props.label,
      rest = _objectWithoutProperties(props, ["label"]);

  return /*#__PURE__*/React__default.createElement("div", {
    className: 'col-12'
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React__default.createElement(Element$1, _extends({
    pb: [2],
    size: "form"
  }, rest, {
    html: label
  }))));
};
Description.propTypes = {
  /** Text (html) */
  text: propTypes.string.isRequired
};
Description.defaultProps = {
  text: ''
};

var FormContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(FormContainer, _React$Component);

  var _super = _createSuper(FormContainer);

  function FormContainer() {
    _classCallCheck(this, FormContainer);

    return _super.apply(this, arguments);
  }

  _createClass(FormContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          form = _this$props.form,
          buttonText = _this$props.buttonText,
          renderTitle = _this$props.renderTitle,
          isLoading = _this$props.isLoading;
      return /*#__PURE__*/React__default.createElement(React.Fragment, null, renderTitle ? renderTitle() : null, /*#__PURE__*/React__default.createElement("form", {
        className: "mb-3",
        onSubmit: this.props.onSubmit,
        noValidate: true
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "row"
      }, form.map(function (fieldProps) {
        switch (fieldProps.type) {
          case 'intro':
            return /*#__PURE__*/React__default.createElement(Description, _extends({}, fieldProps, {
              key: fieldProps.name
            }));

          case 'select':
            return /*#__PURE__*/React__default.createElement(SelectField, _extends({}, fieldProps, {
              key: fieldProps.name
            }));

          case 'textArea':
            return /*#__PURE__*/React__default.createElement(TextAreaField, _extends({}, fieldProps, {
              key: fieldProps.name
            }));

          case 'checkbox':
            return /*#__PURE__*/React__default.createElement(CheckBoxField, _extends({}, fieldProps, {
              key: fieldProps.name
            }));

          default:
            return /*#__PURE__*/React__default.createElement(TextField, _extends({}, fieldProps, {
              key: fieldProps.name
            }));
        }
      })), this.props.children, /*#__PURE__*/React__default.createElement(rebass.Flex, {
        justifyContent: "center",
        mt: [1, 3]
      }, /*#__PURE__*/React__default.createElement(Element$3, null, isLoading ? 'Working' : buttonText))));
    }
  }]);

  return FormContainer;
}(React__default.Component);
FormContainer.defaultProps = {
  buttonText: 'Send request'
};

function _templateObject5$3() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    display: ", ";\n  }\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$a() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    display: none;\n  }\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject4$a = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$g() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    display: none;\n  }\n  ", " {\n    display: none;\n  }\n  ", " {\n    display: ", ";\n  }\n"]);

  _templateObject3$g = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$v() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    display: none;\n  }\n  ", " {\n    display: ", ";\n  }\n"]);

  _templateObject2$v = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$N() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    display: ", ";\n  }\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject$N = function _templateObject() {
    return data;
  };

  return data;
}
var HideAtLarge = styled.div(_templateObject$N(), mediaQuery.small, function (props) {
  return props.flex ? 'flex' : 'block';
}, mediaQuery.medium, function (props) {
  return props.flex ? 'flex' : 'block';
}, mediaQuery.large);
var HideAtMedium = styled.div(_templateObject2$v(), mediaQuery.small, function (props) {
  return props.flex ? 'flex' : 'block';
}, mediaQuery.medium, mediaQuery.large, function (props) {
  return props.flex ? 'flex' : 'block';
});
var HideAtMediumAndBelow = styled.div(_templateObject3$g(), mediaQuery.small, mediaQuery.medium, mediaQuery.large, function (props) {
  return props.flex ? 'flex' : 'block';
});
var HideAtMediumAndAbove = styled.div(_templateObject4$a(), mediaQuery.small, function (props) {
  return props.flex ? 'flex' : 'block';
}, mediaQuery.medium, mediaQuery.large);
var HideAtSmall = styled.div(_templateObject5$3(), mediaQuery.medium, function (props) {
  return props.flex ? 'flex' : 'block';
}, mediaQuery.large, function (props) {
  return props.flex ? 'flex' : 'block';
});
function HideAt(_ref) {
  var breakpoint = _ref.breakpoint,
      flex = _ref.flex,
      children = _ref.children;
  var Component;

  switch (breakpoint) {
    case 'small':
      Component = HideAtSmall;
      break;

    case 'medium':
      Component = HideAtMedium;
      break;

    case 'mediumAndBelow':
      Component = HideAtMediumAndBelow;
      break;

    case 'mediumAndAbove':
      Component = HideAtMediumAndAbove;
      break;

    case 'large':
      Component = HideAtLarge;
      break;

    default:
      Component = React__default.Fragment;
  }

  return /*#__PURE__*/React__default.createElement(Component, {
    flex: flex
  }, children);
}
HideAt.propTypes = {
  /** Breakpoint for various viewports */
  breakpoint: propTypes.array,

  /** Should the display be flex? else set to block */
  flex: propTypes.string,

  /** Children node wrapper */
  children: propTypes.node
};

exports.Alert = Alert;
exports.Banner = Banner;
exports.Border = Border;
exports.BuilderLayout = BuilderLayout;
exports.Button = Element$3;
exports.ButtonIcon = ButtonIcon;
exports.ButtonText = ButtonText;
exports.Card = Card;
exports.CardCta = CardCta;
exports.CardPoster = CardPoster;
exports.CardSelection = CardSelection;
exports.CardSmall = CardSmall;
exports.Collapse = Collapse;
exports.CollapseWrapper = CollapseWrapper;
exports.Column = Column;
exports.Container = Container;
exports.ContentModal = ContentModal;
exports.Footer = Footer;
exports.FormContainer = FormContainer;
exports.GalleryZoom = GalleryZoom;
exports.GridCards = GridCards;
exports.GridExplore = GridExplore;
exports.GridGrouping = GridGrouping;
exports.GridHomeGarden = GridHomeGarden;
exports.GridHomeStudio = GridHomeStudio;
exports.GridItems = GridItems;
exports.GridSculpture = GridSculpture;
exports.Header = Header;
exports.Heading = Element;
exports.Hero = Hero;
exports.HeroLanding = HeroLanding;
exports.HeroMenu = HeroMenu;
exports.HideAt = HideAt;
exports.ImageBox = ImageBox;
exports.ImageIconOverlay = ImageIconOverlay;
exports.LegalFooter = Footer;
exports.Loading = Loading;
exports.Logo = Logo;
exports.Menu = Menu;
exports.Moment = Moment;
exports.NavSwitch = NavSwitch;
exports.NavSwitchWrapper = NavSwitchWrapper;
exports.Poem = Poem;
exports.PrimaryMenu = PrimaryMenu;
exports.Row = Row;
exports.SectionHeading = SectionHeading;
exports.SectionPreview = SectionPreview;
exports.Share = Share;
exports.ShowAt = ShowAt;
exports.SingleShowModal = SingleShowModal;
exports.SliderCards = SliderCards;
exports.SliderWrapper = SliderWrapper;
exports.Space = Space;
exports.StyledLink = StyledLink$1;
exports.Text = Element$1;
exports.Timeline = Timeline;
exports.VideoContainer = VideoContainer;
exports.api = api;
exports.bannerContent = bannerContent;
exports.baseTheme = baseTheme;
exports.colors = colors;
exports.constants = constants;
exports.convertCmToIn = convertCmToIn;
exports.convertKgToLb = convertKgToLb;
exports.fontWeight = fontWeight;
exports.fonts = fonts;
exports.formatCurrency = formatCurrency;
exports.getButton = getButton;
exports.getHeroDetails = getHeroDetails;
exports.globalSpringProps = globalSpringProps;
exports.menus = menus;
exports.opacity = opacity;
exports.spacing = spacing;
exports.theme = theme;
exports.timing = timing;
exports.tracking = tracking;
//# sourceMappingURL=index.js.map
